<template>
  <div class="JXYMainContainer">
    <div class="JXYPanel">
      <div class="JXYPanelHeader">
        <div class="lineHeader" v-if="panelMode == 'normal'">
          <div class="leftH title">云联络中心</div>
          <div class="leftR titleBtns">
            <Icon @click="()=>{panelMode = 'mini'}" class="pointer" type="ios-contract" />
          </div>
        </div>
        <div class="lineHeader">
          <div class="leftH">
            <template v-if="currentStatus == 'offline'">
              <span class="status offline"></span>离线
            </template>
            <template v-else>
              <Dropdown @on-click="changeStatus" transfer transfer-class-name="statusMenu">
                <template v-if="currentStatus == 'online'">
                  <span class="status online"></span>在线
                </template>
                <template v-if="currentStatus == 'offline'">
                  <span class="status offline"></span>下线
                </template>

                <template v-if="currentStatus == 'idle'">
                  <span class="status idle"></span>空闲
                </template>
                <template v-if="currentStatus == 'busy'">
                  <span class="status busy"></span>示忙
                </template>
                <template v-if="currentStatus == 'sleep'">
                  <span class="status sleep"></span>小休
                </template>
                <template v-if="currentStatus == 'handle'">
                  <span class="status busy"></span>话后处理
                </template>

                <Icon type="ios-arrow-down"></Icon>

                <DropdownMenu slot="list">
                  <!-- <DropdownItem name="online">
                    <span class="status online"></span>在线
                  </DropdownItem>-->
                  <DropdownItem name="btn_shutdown">
                    <span class="status offline"></span>离线
                  </DropdownItem>

                  <DropdownItem name="btn_showIdle">
                    <span class="status idle"></span>示闲
                  </DropdownItem>
                  <DropdownItem name="btn_showBusy">
                    <span class="status busy"></span>示忙
                  </DropdownItem>
                  <DropdownItem name="btn_askForRest">
                    <span class="status sleep"></span>
                    小休{{agentSetForm.restTime || 120}}秒
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </template>
          </div>
          <template v-if="panelMode == 'normal'">
            <div class="leftC">
              <div>
                <span class="tips">座席账号：</span>
                <span>{{loginInfo.operatorId || '--'}}</span>
              </div>
              <div>
                <span class="tips">分机号：</span>
                <span>{{loginInfo.extension || '--'}}</span>
              </div>
            </div>
            <div class="rightH">
              <div>{{stateMap[currentAgentCode]?.label || '未知'}}</div>
            </div>
          </template>
          <template v-else>
            <div class="centerH">
              <template v-if="canCall">
                <Input clearable placeholder="请输入需要拨打的号码" v-model="phoneNO" />
                <Button
                  :disabled="phoneNO.length > 0?false:true"
                  @click="makeCall"
                  icon="md-call"
                  type="success"
                ></Button>
              </template>
            </div>
            <div class="rightH titleBtns">
              <Icon @click="()=>{panelMode = 'normal'}" class="pointer" type="ios-expand" />
            </div>
          </template>
        </div>
      </div>
      <template v-if="panelMode == 'normal'">
        <div class="JXYPanelBody">
          <div class="hisPanel" v-if="viewModel=='opHis'">
            <div class="historyHeader">
              <Icon @click="backPanel" class="backBtn" type="md-arrow-round-back" />操作记录(仅显示本次记录)
            </div>
            <div class="historyRecordList" v-if="messageList && messageList.length > 0">
              <Timeline>
                <TimelineItem
                  :color="item.status == 'error'?'red':'green'"
                  :key="idx+'-log'"
                  v-for="(item, idx) in messageList"
                >
                  <p class="time">{{item.time}}</p>
                  <p class="content">{{item.message}}</p>
                </TimelineItem>
              </Timeline>
            </div>
          </div>
          <div class="hisPanel" v-else-if="viewModel=='history'">
            <div class="historyHeader">
              <Icon @click="backPanel" class="backBtn" type="md-arrow-round-back" />通话记录(仅显示近3天记录)
            </div>
            <div class="historyRecordList">
              <div class="loadingC" v-if="loadingHis">
                <Spin v-if="loadingHis">加载中...</Spin>
              </div>
              <template v-else>
                <template v-if="historyRecords && historyRecords.length > 0">
                  <div
                    :key="idx+'-his'"
                    class="historyRecord"
                    v-for="(item, idx) in historyRecords"
                  >
                    <div @click="loadCallRecord(item)" class="ledgerId" title="点击加载台账">
                      <div class="historyRecordTitle">
                        <template v-if="item.callType == 'INBOUND'">
                          <svg
                            class="icon"
                            height="20"
                            p-id="1070"
                            t="1754034495401"
                            version="1.1"
                            viewBox="0 0 1024 1024"
                            width="20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M665.4 679c2.3 0.9 54.4 22.3 96.9 52.5 16 11.5 42.8 30.6 47.2 57.8 2.8 18.6-4.3 39.1-21.7 62.8-4.3 6.1-43.1 58.7-117.6 72.7-20.5 3.9-42.1 4.6-64.2 2.1-23.2-2.5-47.6-8.6-72.1-18.2-96.6-35.3-175.9-89.3-257.6-175C136 586.5 106.9 443.1 102.6 415.9c-22.4-125.1 72.6-194 83.5-201.5 14.9-10.6 28.5-17 41.5-19.5 3.5-0.7 7.7-1.1 12-1.1 2.3 0 4.5 0.1 6.7 0.3 11.9 1.4 29.4 7.4 44.2 28.6 20.2 28.8 42.2 71.3 60.1 116.9 18.7 47.2-6.1 66.1-30.2 84.4l-1 0.6s-43.3 28.5-51 33.4c-7.5 4.9-10.1 14.9-5.7 22.7 29.3 53.9 68.9 108.2 114.6 156.8 45 47.8 95.8 90.2 147 122.5 2.6 1.7 5.8 2.6 9.2 2.6 1 0 2.1-0.1 3.1-0.3l1.4-0.4c5.1-1.5 9.2-5.1 11.1-9.8 4.9-9.5 13.5-24.8 23.1-38 18.1-25 36.1-38.8 54.9-42.4 2.9-0.6 6.4-0.9 9.8-0.9 2.1 0 4.1 0.1 6.1 0.3 4.5 1.2 12.8 3.8 22.4 7.9z"
                              fill="#2d8cf0"
                              p-id="1071"
                            />
                            <path
                              d="M515 427.4l202.7-176.9c8.6-7.6 21.9-6.7 29.4 2l54.9 62.9c7.6 8.6 6.7 21.9-2 29.4L597.1 521.6c-8.6 7.6-21.9 6.7-29.4-2l-54.9-62.9c-7.4-8.6-6.5-21.7 2.2-29.3z"
                              fill="#2d8cf0"
                              p-id="1072"
                            />
                            <path
                              d="M716.5 544.6L488.3 543c-18.7 2.8-33.7-15.4-27.3-33.3l44.7-205.3c6.5-17.8 29.7-22.3 42.3-8.1l183.5 207.1c13.3 14.8 4.7 38.3-15 41.2z"
                              fill="#2d8cf0"
                              p-id="1073"
                            />
                          </svg>
                          {{item.caller | desensitizedPhone}}
                        </template>
                        <template v-else-if="item.callType == 'OUTBOUND'">
                          <svg
                            class="icon"
                            height="20"
                            p-id="10413"
                            t="1754033914057"
                            version="1.1"
                            viewBox="0 0 1024 1024"
                            width="20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M665.4 679c2.3 0.9 54.4 22.3 96.9 52.5 16 11.5 42.8 30.6 47.2 57.8 2.8 18.6-4.3 39.1-21.7 62.8-4.3 6.1-43.1 58.7-117.6 72.7-20.5 3.9-42.1 4.6-64.2 2.1-23.2-2.5-47.6-8.6-72.1-18.2-96.6-35.3-175.9-89.3-257.6-175C136 586.5 106.9 443.1 102.6 415.9c-22.4-125.1 72.6-194 83.5-201.5 14.9-10.6 28.5-17 41.5-19.5 3.5-0.7 7.7-1.1 12-1.1 2.3 0 4.5 0.1 6.7 0.3 11.9 1.4 29.4 7.4 44.2 28.6 20.2 28.8 42.2 71.3 60.1 116.9 18.7 47.2-6.1 66.1-30.2 84.4l-1 0.6s-43.3 28.5-51 33.4c-7.5 4.9-10.1 14.9-5.7 22.7 29.3 53.9 68.9 108.2 114.6 156.8 45 47.8 95.8 90.2 147 122.5 2.6 1.7 5.8 2.6 9.2 2.6 1 0 2.1-0.1 3.1-0.3l1.4-0.4c5.1-1.5 9.2-5.1 11.1-9.8 4.9-9.5 13.5-24.8 23.1-38 18.1-25 36.1-38.8 54.9-42.4 2.9-0.6 6.4-0.9 9.8-0.9 2.1 0 4.1 0.1 6.1 0.3 4.5 1.2 12.8 3.8 22.4 7.9z"
                              fill="#2d8cf0"
                              p-id="10414"
                            />
                            <path
                              d="M751.6 362.6L548.9 539.5c-8.6 7.6-21.9 6.7-29.4-2l-54.9-62.9c-7.6-8.6-6.7-21.9 2-29.4l202.8-176.9c8.6-7.6 21.9-6.7 29.4 2l54.9 62.9c7.5 8.7 6.5 21.8-2.1 29.4z"
                              fill="#2d8cf0"
                              p-id="10415"
                            />
                            <path
                              d="M550.1 245.4l228.2 1.7c18.7-2.8 33.7 15.4 27.3 33.3l-44.7 205.3c-6.5 17.8-29.7 22.3-42.3 8.1L535.1 286.7c-13.3-14.9-4.7-38.4 15-41.3z"
                              fill="#2d8cf0"
                              p-id="10416"
                            />
                          </svg>
                          {{item.callee | desensitizedPhone}}
                        </template>
                      </div>
                      <div class="historyRecordTime">{{item.startTime}}</div>
                    </div>
                    <div
                      class="historyRecordBtns"
                      v-if="['INBOUND', 'OUTBOUND'].indexOf(item.callType) >=0"
                    >
                      <div @click="callP(item)" class="callBtn">
                        <Icon type="ios-call" />
                      </div>
                      <!-- <div class="moreBtn">
											<Icon type="md-more" />
                      </div>-->
                    </div>
                  </div>

                  <div class="textR">
                    <Page
                      :current="hisCurrentPage"
                      :total="historyRecordTotal"
                      @on-change="pageChange"
                      size="small"
                    />
                  </div>
                </template>
                <div class="nodata" v-else>暂无数据</div>
              </template>
            </div>
          </div>
          <template v-else-if="currentStatus != 'offline'">
            <template v-if="['online', 'idle', 'handle'].indexOf(currentStatus) >= 0">
              <!-- telRingPanel -->
              <div class="telRingPanel" v-if="viewModel == 'telRingPanel'">
                <template v-if="currentCallType == 'INBOUND'">
                  <!-- 呼入 -->
                  <div class="telPanelHeader">来电号码 | {{callingLocation || '未知' }}</div>
                  <div class="telNumber">{{recordInfo.caller | desensitizedTelNum}}</div>
                  <div class="telTime">{{txt_duration}}</div>
                  <template v-if="currentAgentCode != 256">
                    <Divider dashed>来电信息</Divider>
                    <div class="telRingInfo">
                      <div>
                        <div class="telRingLabel">48小时来电次数</div>
                        <div class="telRingValue">{{nearlyCallInfo?.times || '--'}}</div>
                      </div>
                      <div>
                        <div class="telRingLabel">上次来电时间</div>
                        <div class="telRingValue">{{nearlyCallInfo?.lastDateTime || '--'}}</div>
                      </div>
                      <div>
                        <div class="telRingLabel">被叫号码</div>
                        <div class="telRingValue">{{recordInfo.callee || '--'}}</div>
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else-if="currentCallType == 'OUTBOUND'">
                  <!-- 呼出 -->
                  <div class="telPanelHeader">去电号码 | {{callingLocation || '未知' }}</div>
                  <div class="telNumber">{{recordInfo?.callee | desensitizedTelNum}}</div>
                  <div class="telTime">{{txt_duration}}</div>
                  <template v-if="currentAgentCode != 256">
                    <Divider dashed>去电信息</Divider>
                    <div class="telRingInfo">
                      <div>
                        <div class="telRingLabel">48小时去电次数</div>
                        <div class="telRingValue">{{nearlyCallInfo?.times || '--'}}</div>
                      </div>
                      <div>
                        <div class="telRingLabel">上次去电时间</div>
                        <div class="telRingValue">{{nearlyCallInfo?.lastDateTime || '--'}}</div>
                      </div>
                      <div>
                        <div class="telRingLabel">主叫号码</div>
                        <div class="telRingValue">{{recordInfo?.caller || '--'}}</div>
                      </div>
                    </div>
                  </template>
                </template>
                <!--  -->
                <div class="inlineBtnContianer" v-if="currentAgentCode == 256">
                  <div class="inlineBtnLine">
                    <div :class="currentCallType != 'INBOUND'?'inlineBtn disabled':'inlineBtn'">
                      <Dropdown @on-click="transfer" trigger="click">
                        <div class="inlineBtnIcon">
                          <Icon type="md-swap" />
                        </div>
                        <div class="inlineBtnLabel">通话转移</div>
                        <DropdownMenu slot="list">
                          <DropdownItem
                            :disabled="currentCallType != 'INBOUND'"
                            name="btn_shiftToGroupAndSkill"
                          >转移至技能</DropdownItem>
                          <DropdownItem
                            :disabled="currentCallType != 'INBOUND'"
                            name="btn_shiftBanquets"
                          >转移至座席</DropdownItem>
                          <!-- <DropdownItem name="btn_shiftToIVR">转移至IVR</DropdownItem> -->
                        </DropdownMenu>
                      </Dropdown>
                    </div>

                    <div class="inlineBtn disabled">
                      <div @click="transfer('keepOrContinue')" class="inlineBtnIcon">
                        <Icon type="md-contacts" />
                      </div>
                      <div class="inlineBtnLabel">{{keepOrContinueLabel}}</div>
                    </div>
                  </div>
                  <div class="inlineBtnLine">
                    <div class="inlineBtn">
                      <div @click="transfer('btn_mute')" class="inlineBtnIcon">
                        <Icon :type="muteState?'md-mic-off':'md-mic'" />
                      </div>
                      <div class="inlineBtnLabel">{{muteState?'取消静音':'开始静音'}}</div>
                    </div>
                    <div class="inlineBtn">
                      <div @click="transfer('btn_shiftToStatic')" class="inlineBtnIcon">
                        <Icon type="md-happy" />
                      </div>
                      <div class="inlineBtnLabel">满意度调研</div>
                    </div>
                  </div>
                </div>

                <div class="btnContainer">
                  <div
                    class="answerBtn"
                    v-if="64 == currentAgentCode && currentCallType == 'INBOUND'"
                  >
                    <Tooltip content="接听">
                      <Button
                        @click="callAnswerCall"
                        disabled
                        icon="md-call"
                        shape="circle"
                        size="large"
                        style="width: 56px;height: 56px"
                        type="success"
                      ></Button>
                    </Tooltip>
                  </div>

                  <div
                    class="answerBtn"
                    v-if="(currentCallType == 'OUTBOUND'  || currentCallType == 'INBOUND') && [8192, 256, 64, 128 ].indexOf(currentAgentCode) >=  0 && options.params.canHangUp"
                  >
                    <Tooltip content="挂断">
                      <Button
                        @click="agentHangUp"
                        icon="md-call"
                        shape="circle"
                        size="large"
                        style="width: 56px;height: 56px"
                        type="error"
                      ></Button>
                    </Tooltip>
                  </div>

                  <template v-if=" [ 1024].indexOf(currentAgentCode) >= 0">
                    <div class="answerBtn">
                      <Button
                        @click="cancelAdjust()"
                        icon="md-call"
                        shape="circle"
                        size="large"
                        style="width: 56px;height: 56px"
                        type="success"
                      ></Button>
                      <p class="btnDesc">开始接听({{m_TextProcessCounter}}秒)</p>
                    </div>

                    <div class="answerBtn">
                      <Button
                        @click="agentBusinessArrange()"
                        icon="md-create"
                        shape="circle"
                        size="large"
                        style="width: 56px;height: 56px"
                        type="default"
                      ></Button>
                      <p class="btnDesc">话后处理</p>
                    </div>
                  </template>
                </div>
              </div>
              <!-- 拨号面板 -->
              <div class="numberPanel" v-else-if="viewModel == 'numberPanel'">
                <div class="JXYBtnItemHandler">
                  <div class="flex" style="margin-bottom: 5px">
                    <Select clearable filterable placeholder="请选择技能组" v-model="skillGroupValue">
                      <OptionGroup
                        :key="group.groupId"
                        :label="group.groupName"
                        v-for="group in groupWithSkills"
                      >
                        <template slot="label">{{(group.checkIn?'[已签入]':'[未签入]') }}</template>
                        <Option
                          :disabled="item.checkIn?false:true"
                          :key="item.value"
                          :label="item.skillName"
                          :value="item.value"
                          v-for="item in group.skills"
                        >{{(item.checkIn?'[已签入]':'[未签入]') + item.skillName}}</Option>
                      </OptionGroup>
                      <!-- <Option
                        :key="item.value"
                        :value="item.value"
                        v-for="item in skillGroups"
                      >{{item.name}}</Option>-->
                    </Select>
                    <Select clearable filterable placeholder="请选择呼叫类型" v-model="callType">
                      <Option
                        :key="item.value"
                        :value="item.value"
                        v-for="item in callTypes"
                      >{{item.name}}</Option>
                    </Select>
                  </div>
                  <div>
                    <Input clearable placeholder="请输入需要拨打的号码" v-model="phoneNO" />
                  </div>
                </div>

                <!-- <Input clearable placeholder="请输入需要拨打的号码" size="large" v-model="phoneNO" /> -->
                <div class="phoneContainer">
                  <div :key="i+'-line'" class="line" v-for="i in 3">
                    <div
                      :class="{'numBtn':true, 'disabled': currentStatus=='online'}"
                      :key="i+'-'+num"
                      @click="addNumber((i -1) * 3 + num)"
                      v-for="num in 3"
                    >{{(i -1) * 3 + num}}</div>
                  </div>
                  <div class="line">
                    <div @click="addNumber('*')" class="numBtn">*</div>
                    <div @click="addNumber('0')" class="numBtn">0</div>
                    <div @click="addNumber('#')" class="numBtn">#</div>
                  </div>

                  <div class="phoneBtns">
                    <div></div>
                    <div>
                      <Button
                        :disabled="phoneNO.length > 0?false:true"
                        @click="makeCall"
                        icon="md-call"
                        shape="circle"
                        size="large"
                        style="width: 52px;height: 52px"
                        type="success"
                      ></Button>
                    </div>
                    <div></div>
                  </div>
                </div>
              </div>
            </template>

            <template v-else-if="['busy'].indexOf(currentStatus) >= 0">
              <div class="JXYPanelOnline">
                <p>
                  <Icon color="#ff9900" size="20" type="md-information-circle" />当前示忙，电话无法接入
                </p>
              </div>
              <!-- 示忙 -->
              <div class="textC">
                <Button @click="changeStatus('btn_showIdle')" type="primary">立即示闲</Button>
                <Button @click="changeStatus('btn_shutdown')" type="error">立即下线</Button>
              </div>
            </template>

            <template v-else-if="['sleep'].indexOf(currentStatus) >= 0">
              <div class="JXYPanelOff">
                <div>
                  <Icon color="#ff9900" size="20" type="md-information-circle" />当前小休中，电话无法接入
                  <div>
                    剩余
                    <strong>{{remainingTime}}</strong>秒
                  </div>
                </div>
              </div>
              <!-- 示忙 -->
              <div class="textC">
                <Button @click="changeStatus('btn_showIdle')" type="primary">立即示闲</Button>
                <Button @click="changeStatus('btn_shutdown')" type="error">立即下线</Button>
              </div>
            </template>
          </template>
          <template v-else>
            <!-- 离线 -->
            <div class="JXYPanelOff">
              <p>
                <Icon color="#ff9900" size="20" type="md-information-circle" />您尚未开始工作
              </p>
            </div>
            <div class="textC">
              <Button @click="clickBtnSignIn(true)" type="primary">立即上线</Button>
            </div>
          </template>
        </div>
        <div class="buttomBtnContianer">
          <template v-if="currentStatus == 'idle' && currentAgentCode == 32">
            <div @click="transfer('btn_queue')" class="buttomBtn">
              <Badge :count="waitNum" :overflow-count="99">
                <Tooltip content="排队列表" placement="top">
                  <Icon type="md-call" />
                  <div class="btnLabel">排队列表</div>
                </Tooltip>
              </Badge>
            </div>

            <!-- 在线签入空闲 才能呼叫 -->
            <div @click="transfer('btn_callBanquets')" class="buttomBtn">
              <Tooltip content="呼叫座席" placement="top">
                <Icon type="md-contacts" />
                <div class="btnLabel">呼叫座席</div>
              </Tooltip>
            </div>

            <div @click="transfer('btn_agentSnatch')" class="buttomBtn">
              <Tooltip content="抢接座席" placement="top">
                <Icon type="md-hand" />
                <div class="btnLabel">抢接座席</div>
              </Tooltip>
            </div>

            <div @click="transfer('btn_conferenceManagement')" class="buttomBtn">
              <Tooltip content="会议管理" placement="top">
                <Icon type="md-filing" />
                <div class="btnLabel">会议管理</div>
              </Tooltip>
            </div>
          </template>
          <template v-else>
            <div class="buttomBtn disable">
              <Badge :count="waitNum" :overflow-count="99">
                <Icon type="md-call" />
                <div class="btnLabel">排队列表</div>
              </Badge>
            </div>

            <div class="buttomBtn disable">
              <Icon type="md-contacts" />
              <div class="btnLabel">呼叫座席</div>
            </div>

            <div class="buttomBtn disable">
              <Icon type="md-hand" />
              <div class="btnLabel">抢接座席</div>
            </div>

            <div class="buttomBtn disable">
              <Icon type="md-filing" />
              <div class="btnLabel">会议管理</div>
            </div>
          </template>
        </div>
        <div class="buttomBtnContianer">
          <template v-if="currentStatus == 'offline'">
            <div class="buttomBtn disable">
              <Icon type="md-person" />
              <div class="btnLabel">座席设置</div>
            </div>

            <div class="buttomBtn disable">
              <Icon type="md-hammer" />
              <div class="btnLabel">技能设置</div>
            </div>
          </template>
          <template v-else>
            <div @click="transfer('btn_agentSet')" class="buttomBtn">
              <Tooltip content="座席设置" placement="top">
                <Icon type="md-person" />
                <div class="btnLabel">座席设置</div>
              </Tooltip>
            </div>
            <div class="buttomBtn">
              <Dropdown @on-click="skillFuc">
                <Tooltip content="座席设置" placement="top">
                  <Icon type="md-hammer" />
                  <div class="btnLabel">技能设置</div>
                </Tooltip>
                <DropdownMenu slot="list">
                  <DropdownItem name="btn_checkInAll">
                    <div class="JXYBtnItemSub">
                      <span>签入所有</span>
                    </div>
                  </DropdownItem>
                  <DropdownItem name="btn_checkOutAll">
                    <div class="JXYBtnItemSub">
                      <span>签出所有</span>
                    </div>
                  </DropdownItem>

                  <DropdownItem name="btn_checkinOrout">
                    <div class="JXYBtnItemSub">
                      <span>指定技能</span>
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </template>

          <div
            :class="options.params.canViewHis?'buttomBtn':'buttomBtn disable'"
            @click="showHistory"
          >
            <Tooltip content="通话记录" placement="top">
              <Icon type="md-menu" />
              <div class="btnLabel">通话记录</div>
            </Tooltip>
          </div>
          <div @click="showOPHis" class="buttomBtn">
            <Tooltip content="操作记录" placement="top">
              <Icon type="md-list-box" />
              <div class="btnLabel">操作记录</div>
            </Tooltip>
          </div>
        </div>
      </template>
    </div>

    <div class="loginLoading" v-if="loginLoading">
      <Spin fix>
        <Icon class="loadingIcon" size="20" type="ios-loading"></Icon>
        <div>签入中...</div>
      </Spin>
    </div>

    <!-- 座席设置窗口 -->
    <Modal title="座席设置" v-model="showAgentSet">
      <Form :labelWidth="160" :model="agentSetForm" label-position="right" ref="agentSetForm">
        <Divider orientation="left">常规设置一</Divider>
        <FormItem
          :rules="[{required: true, type: 'number', min: 0, message: '请输入文书处理时长', trigger: 'change'}]"
          label="文书处理时长(秒)"
          prop="textProcTime"
        >
          <InputNumber
            :min="0"
            :precision="0"
            :step="1"
            clearable
            placeholder="请输入文书处理时长"
            style="width: 100%"
            v-model="agentSetForm.textProcTime"
          ></InputNumber>
        </FormItem>
        <FormItem
          :rules="[{required: true, type: 'number', min: 0, message: '请输入消息提示时长', trigger: 'change'}]"
          label="消息提示时长(秒)"
          prop="popMsgTime"
        >
          <InputNumber
            :min="0"
            :precision="0"
            :step="1"
            clearable
            placeholder="请输入消息提示时长"
            style="width: 100%"
            v-model="agentSetForm.popMsgTime"
          ></InputNumber>
        </FormItem>
        <FormItem
          :rules="[{required: true, type: 'number', min: 0, message: '请输入小休时长', trigger: 'change'}]"
          label="小休时长(秒)"
          prop="restTime"
        >
          <InputNumber
            :min="0"
            :precision="0"
            :step="1"
            clearable
            placeholder="请输入小休时长"
            style="width: 100%"
            v-model="agentSetForm.restTime"
          ></InputNumber>
        </FormItem>

        <FormItem
          :rules="[{required: true,  message: '请选择呼转连接模式', trigger: 'change'}]"
          label="呼转连接模式"
          prop="transferConnectMode"
        >
          <RadioGroup v-model="agentSetForm.transferConnectMode">
            <Radio :label="'0'">被叫响铃后连接</Radio>
            <Radio :label="'1'">被叫摘机后连接</Radio>
          </RadioGroup>
        </FormItem>
        <Divider orientation="left">常规设置二</Divider>

        <FormItem :label-width="200" label="登陆后自动签入所属组&技能" prop="autoSigin">
          <i-switch :false-value="0" :true-value="1" size="large" v-model="agentSetForm.autoSigin">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelAgentSet">取消</Button>
        <Button @click="submitAgentSet" type="primary">确定</Button>
      </div>
    </Modal>

    <Modal footer-hide title="签入/出的组&技能列表" v-model="showSkillList" width="600px">
      <!-- {{groupWithSkills}} -->
      <Tree :data="groupList" :render="renderContent" expand-node></Tree>
    </Modal>

    <Modal @on-cancel="canceAgent" footer-hide title="座席列表" v-model="showAgentList" width="60vw">
      <div style="max-height: 68vh; overflow-y: auto">
        <Form
          :label-width="60"
          :model="agentSearchBox"
          inline
          label-position="right"
          ref="agentSearchBox"
        >
          <FormItem label="座席组" prop="groupId">
            <Select clearable filterable v-model="agentSearchBox.groupId">
              <Option
                :key="item.id+'-groupTree'"
                :value="item.id"
                v-for="item in groupTree"
              >{{ item.title }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态" prop="agentStatus">
            <Select clearable filterable v-model="agentSearchBox.agentStatus">
              <Option
                :key="key+'-agentStatus'"
                :value="key.toString()"
                v-for="(item, key) in stateMap"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem :labelWidth="0">
            <Button @click="findAgent" type="primary">查询</Button>
          </FormItem>
        </Form>
        <Table :columns="columnsAgent" :data="agentList" :loading="loadAgent" border size="small" />
      </div>
    </Modal>

    <Modal @on-cancel="canceIvr" footer-hide title="IVR列表" v-model="showTransferIVR" width="60vw">
      <div style="max-height: 68vh; overflow-y: auto">
        <Form
          :label-width="100"
          :model="ivrSearchBox"
          inline
          label-position="right"
          ref="ivrSearchBox"
        >
          <FormItem label="转移方式" prop="transferType">
            <Select clearable filterable v-model="ivrSearchBox.transferType">
              <Option
                :disabled="item.disabled"
                :key="key+'-transferType'"
                :value="key.toString()"
                v-for="(item, key) in transferTypes"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="IVR名称" prop="flowName">
            <Input clearable placeholder="请输入流程名称" v-model="ivrSearchBox.flowName" />
          </FormItem>
          <FormItem :labelWidth="0">
            <Button @click="getIVRList" type="primary">查询</Button>
          </FormItem>
        </Form>
        <Table :columns="columnsIvr" :data="ivrList" :loading="loadIvr" border size="small" />
        <div style="margin-top: 10px;text-align: right;">
          <Page
            :current="ivrPages.current"
            :page-size="ivrPages.pageSize"
            :total="ivrPages.total"
            @on-change="changePageIvr"
            show-total
          />
        </div>
      </div>
    </Modal>

    <Modal
      @on-cancel="canceSkill"
      footer-hide
      title="技能列表"
      v-model="showTransferSkill"
      width="60vw"
    >
      <div style="max-height: 68vh; overflow: hidden">
        <Form
          :label-width="100"
          :model="skillSearchBox"
          inline
          label-position="right"
          ref="skillSearchBox"
        >
          <FormItem label="座席组" prop="groupName">
            <Input clearable placeholder="请输入组名称" v-model="skillSearchBox.groupName" />
          </FormItem>
          <FormItem label="技能名称" prop="skillName">
            <Input clearable placeholder="请输入技能名称" v-model="skillSearchBox.skillName" />
          </FormItem>
          <FormItem :labelWidth="0">
            <Button @click="getSkillList" type="primary">查询</Button>
          </FormItem>
        </Form>
        <Table
          :columns="columnsSkill"
          :data="transferSkillList"
          :loading="loadSkill"
          border
          size="small"
        />
        <div style="margin-top: 10px;text-align: right;">
          <Page
            :current="skillPages.current"
            :page-size="skillPages.pageSize"
            :total="skillPages.total"
            @on-change="changePageSkill"
            show-total
          />
        </div>
      </div>
    </Modal>

    <Modal @on-cancel="cancelWait" footer-hide title="排队电话" v-model="showWaitList" width="60vw">
      <div style="max-height: 68vh; overflow: hidden">
        <Form
          :label-width="100"
          :model="waitSearchBox"
          inline
          label-position="right"
          ref="waitSearchBox"
        >
          <FormItem label="座席组" prop="groupName">
            <Input clearable placeholder="请输入组名称" v-model="waitSearchBox.groupName" />
          </FormItem>
          <FormItem label="技能名称" prop="skillName">
            <Input clearable placeholder="请输入技能名称" v-model="waitSearchBox.skillName" />
          </FormItem>
          <FormItem :labelWidth="0">
            <Button @click="getWaitList(true)" type="primary">查询</Button>
          </FormItem>
        </Form>
        <Table :columns="columnsWait" :data="waitList" :loading="loadWait" border size="small" />
      </div>
    </Modal>

    <Modal
      @on-cancel="cancelMeeting"
      footer-hide
      title="会议管理"
      v-model="showMeetingMgr"
      width="66vw"
    >
      <div style="max-height: 68vh; overflow: hidden">
        <Form
          :label-width="100"
          :model="meetingMgrData"
          inline
          label-position="right"
          ref="meetingMgrData"
        >
          <FormItem label="会议数量" prop="confSize">
            <InputNumber
              :max="20"
              :min="4"
              :precision="0"
              :step="1"
              placeholder="请输入会议数量"
              v-model="meetingMgrData.confSize"
            />
          </FormItem>

          <FormItem :labelWidth="0">
            <Button @click="loadAllGroup('meeting')" type="primary">邀请座席</Button>
            <Button @click="closeMeeting(true)" type="error">解散会议</Button>
          </FormItem>

          <FormItem :label-width="0" prop="skillGroupValue">
            <Select
              clearable
              filterable
              placeholder="请选择技能组"
              v-model="meetingMgrData.skillGroupValue"
            >
              <OptionGroup
                :key="group.groupId"
                :label="group.groupName"
                v-for="group in groupWithSkills"
              >
                <template slot="label">{{(group.checkIn?'[已签入]':'[未签入]') }}</template>
                <Option
                  :disabled="item.checkIn?false:true"
                  :key="item.value"
                  :label="item.skillName"
                  :value="item.value"
                  v-for="item in group.skills"
                >{{(item.checkIn?'[已签入]':'[未签入]') + item.skillName}}</Option>
              </OptionGroup>
              <!-- <Option
                        :key="item.value"
                        :value="item.value"
                        v-for="item in skillGroups"
              >{{item.name}}</Option>-->
            </Select>
          </FormItem>
          <FormItem :label-width="0" label prop="phoneNO">
            <Input clearable placeholder="请输入电话号码" v-model="meetingMgrData.phoneNO" />
          </FormItem>
          <FormItem :labelWidth="0">
            <Button @click="inviteMeeting()" type="warning">邀请外线</Button>
          </FormItem>
        </Form>
        <Table
          :columns="columnsMeeting"
          :data="g_ConferenceArray"
          :loading="loadMeeting"
          border
          size="small"
        />
      </div>
    </Modal>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import agentServer from './jxy/js/agentServer.js'
import defComp from './jxy/js/def_component.js'
import acdFunc from './jxy/js/def_msgacd.js'
import agentFunc from './jxy/js/def_msgagent.js'
import obsFunc from './jxy/js/def_msgobs.js'
import callFunc from './jxy/js/def_msgcall.js'

/**
* 产生本次保持的操作类型对象
*/
var g_CONST_AgentHoldCallBeforOperation = new agentServer.CONST_AgentHoldCallBeforOperation()

export default {
  props: {
    options: {
      required: true
    }
  },
  data () {
    return {
      constMap: {

        defaultTransferType: 0,
        //转满意度 的流程信息
        defaultFlowID: 0,
        defaultNodeID: 159,
        /**
     * 常量:Cookie 是否已登录
     */
        cookie_IsLoad: 'isLoad',

        /**
        * 常量:电话转移类型-保持转移
        */
        transferType_Hold: 1,

        /**
        * 常量:电话转移类型-释放转移
        */
        transferType_Release: 0,

        /**
        * 常量:呼叫CallID的类型-座席ID
        */
        callIDType_CallID_AgentID: 0,

        /**
        * 常量:呼叫CallID的类型-通道号
        */
        callIDType_CallID_LogicNO: 1,

        /**
        * 常量:普通外呼时默认的会议方数
        */
        defaultCallOutConfSize: 3,

        /**
        * 常量:普通外呼时默认的业务类型
        */
        defaultCallOutBusiType: 0,

        /**
        * 常量:获取座席状态时每次请求的最大座席数量
        */
        maxRequestCount: 60,

        /**
        * 常量:Cookie 座席工号
        */
        cookie_WorkNO: 'workNO',

        /**
        * 常量:Cookie 座席密码
        */
        cookie_Password: 'password',

        /**
        * 常量:Cookie 座席登录的分机号
        */
        cookie_ExtensionTelNO: 'extension',

        /**
        * 常量:Cookie 座席登录时是否选中了保存登录信息
        */
        cookie_IsCheck: 'isCheck',

        /**
        * 常量:Cookie 座席姓名
        */
        cookie_AgentName: 'agentName',

        /**
        * 常量:座席登录AGP的优先级
        */
        agentLogin_Priority: 1,


        /**
        * 常量:选择座席对话框所在URL地址
        */
        dailogURL_SelectAgent: "dialogPage/selectAgent/selectAgent.html?type=",

        /**
        * 常量:选择座席对话框打开的类型 - 转移至座席
        */
        openSelectAgentDialogType_TransferAgent: "TransferAgent",

        /**
        * 常量:选择座席对话框打开的类型 - 抢接座席
        */
        openSelectAgentDialogType_AgentSnatch: "AgentSnatch",

        /**
        * 常量:选择座席对话框打开的类型 - 邀请座席
        */
        openSelectAgentDialogType_InviteAgent: "InviteAgent",

        /**
        * 常量:选择座席对话框打开的类型 - 多方会议
        */
        openSelectAgentDialogType_MultiCon: "MultiConf",

        /**
        * 常量:选择座席对话框打开的类型 - 呼叫座席
        */
        openSelectAgentDialogType_CallAgent: "CallAgent",

        /**
        * 常量:选择座席对话框打开的类型 - 监控 - 强插
        */
        openSelectAgentDialogType_Monitor_ForceInsert: "Monitor_ForceInsert",

        /**
        * 常量:选择座席对话框打开的类型 - 监控 - 拦截
        */
        openSelectAgentDialogType_Monitor_Intercept: "Monitor_Intercept",

        /**
        * 常量:选择座席对话框打开的类型 - 监控 - 监听
        */
        openSelectAgentDialogType_Monitor_Monitor: "Monitor_Monitor",

        /**
        * 常量:选择座席对话框打开的类型 - 监控 - 强制挂机
        */
        openSelectAgentDialogType_Monitor_ForceRelease: "Monitor_ForceRelease",

        /**
        * 常量:选择座席对话框打开的类型 - 监控 - 强制注销
        */
        openSelectAgentDialogType_Monitor_ForceLogOut: "Monitor_ForceLogOut",

        /**
        * 常量:选择座席对话框打开的类型 - 监控 - 强制示忙
        */
        openSelectAgentDialogType_Monitor_ForceBusy: "Monitor_ForceBusy",

        /**
        * 常量:选择座席对话框打开的类型 - 监控 - 强制示闲
        */
        openSelectAgentDialogType_Monitor_ForceIdle: "Monitor_ForceIdle",

        /**
        * 常量:选择座席对话框打开的类型 - 监控 - 强制闭塞
        */
        openSelectAgentDialogType_Monitor_ForceBlock: "Monitor_ForceBlock"
      },
      constPop: {
        /**
    * 常量-本次外呼应对应的弹屏类型-普通外呼(呼外线)
    */
        ConstPopupTypeAgentDefaultCallOut: "popup4agentdefaultcallout",

        /**
        * 常量-本次外呼应对应的弹屏类型-普通外呼(呼座席)
        */
        ConstPopupTypeAgentDefaultCallOutAgent: "popup4agentdefaultcalloutagent",

        /**
        * 常量-本次外呼应对应的弹屏类型-座席未接外呼
        */
        ConstPopupTypeAgentNoAnswerCallOut: "popup4agentnoanswercallout",
        /**
        * 常量-本次外呼应对应的弹屏类型-座席流失外呼
        */
        ConstPopupTypeAgentMissedCallOut: "popup5agentmissedcallout",
        /**
        * 常量-本次外呼应对应的弹屏类型-ACD流失外呼
        */
        ConstPopupTypeAcdMissedCallOut: "popup6acdmissedcallout",
        /**
        * 常量-本次外呼应对应的弹屏类型-留言外呼
        */
        ConstPopupTypeLeaveWordMissedCallOut: "popup7leavewordcallout",
        /**
        * 常量-本次外呼应对应的弹屏类型-邀请外呼
        */
        ConstPopupTypeInviteCallOut: "popup8invitecallout"
      },

      /**
        * 座席退出登录的方式,0=无效(初始化值),1=注销,2=退出,3=关闭浏览器窗口
        */
      agentLoggedOffType: 0,

      /**
      * 话机模式 1：表示话机摘挂机，2：表示座席软件摘挂机。
      */
      agentHookMode: 1,

      /**
       * 电话保持对列
       */
      HoldCallList: [],

      /**
       *上一次保持的通话
       */
      m_LastHoldCallItem: null,


      m_AgentMissedCallNumber: 0,
      m_LastAgentMissedCallDataKey: "",
      m_LastInviteAgent: null,

      /**
        * 座席当前呼入呼出数据记录,呼叫结束时需要删除这里的记录(AgentCallDataItem)
        */
      AgentCallList: [],


      /**
      * 座席未接电话数据,(String,AgentCallDataItem)
      */
      AgentMissedCallGridData: {},

      /**
* 排队电话数据,(String,CallQueueDataItem)
*/
      AgentQueueCallGridData: {},

      /**
      * 产生本次保持的操作类型
      */
      g_AgentHoldCallBeforOperation: g_CONST_AgentHoldCallBeforOperation.Unknown(),

      /**
       * 标识是否已加载了技能关联的那些座席组,false=尚未加载,true=已加载
       */
      g_IsLoadSkillOwnGroup: false,

      /**
      * 当前登录的座席主键ID值
      */
      g_AgentID: -1,

      /**
      * 当前登录的座席工号
      */
      g_WorkNO: null,

      /**
       * 当前登录座席密码
       */
      g_PassWord: "",

      /**
      * 当前登录的VDN主键ID
      */
      g_VDNID: -1,

      /**
      * 当前登录时使用的分机号
      */
      g_ExtensionTelNO: "",

      /**
      * 当前呼叫的标识号CallID
      */
      g_CallID: -1,

      /**
      * 当前呼叫的呼叫ID类型,EU_CallIDType  0-座席 1-外线
      */
      g_CallIDType: 0,

      /**
      * 当前呼叫的主标识号,64位整数(字符串)
      */
      g_BaseCallPID: '',

      /**
      * 当前呼叫的子标识号,64位整数(字符串)
      */
      g_AgCallPID: "",

      /**
       * 呼叫类型
       * 	ACT_Unknown			= 0,	//未知，一般不用
      * 	ACT_Inbound			= 1,	//呼叫入线
      * 	ACT_Agent			= 2,	//坐席呼叫坐席
      * 	ACT_TreeParyt		= 3,	//三方通话
      * 	ACT_Conf			= 4,	//会议呼叫
      * 	ACT_Monitor			= 5,	//监听
      * 	ACT_Insert			= 6,	//强插
      * 	ACT_Transfer		= 7,	//呼转
      * 	ACT_Snatch			= 8,	//抢接
      * 	ACT_Intercept		= 9,	//拦截
      * 	ACT_CallOut			= 10,	//外呼
      * 	ACT_OBS_CALLOUT		= 11,	//OBS外呼
      * 	ACT_TelAgent_CALLOUT= 12 	//话机外呼，针对sip话机摘机外呼
       */
      g_CallOfferedType: 0,

      /**
      * 当前Web的虚拟目录(不带/或\符号)
      */
      g_URLRoot: null,

      /**
      * 当前外呼时送出的主叫号码
      */
      g_CallerNO4AgentCallout: null,

      /**
      * 当前座席拥有的座席组(可供当前座席签入和签出的那些座席组)
      */
      g_AgentGroupArray4Agent: [],

      /**
       * 当前座席拥有的座席组(可供当前座席签入和签出的那些座席组)-克隆对象
       */
      g_OtherAgentGroupArray4Agent: [],

      //是否需要加载g_AgentGroupArray4Agent。当js发出$Send.AgentGetGroupReq(-1)时，需要把该变量重置为true.
      g_bReloadAgentGroupArray4Agent: true,

      /**
      * 当前座席拥有的技能组(可供当前座席签入和签出的那些技能组)
      */
      g_SkillArray4Agent: [],

      /**
       * 当前座席拥有的技能组(可供当前座席签入和签出的那些技能组) -克隆对象
       */
      g_OtherSkillArray4Agent: [],

      /**
       * 不存在表t_icip_acd_skillqueue的技能组
       */
      g_OSkillArray4Agent: [],

      /**
      * 当前座席本次请求签入的座席组集合
      */
      g_RequestSignInAgentGroupIDs: [],

      /**
      * 当前座席本次请求签出的座席组集合
      */
      g_RequestSignOutAgentGroupIDs: [],

      /**
      * 当前座席座席本次请求签入的技能组集合
      */
      g_RequestSignInSkillIDs: [],

      /**
      * 当前座席座席本次请求签出的技能组集合
      */
      g_RequestSignOutSkillIDs: [],

      /**
      * 当前座席来去电弹屏参数设置(数据项为CallPopupSetting对象)
      */
      g_CallPopupSettingList: [],

      /**
      * 当前座席未读公告数量
      */
      g_UnreadAnnounceCount: 0,

      /**
      * 当前座席登录后返回结果参数
      */
      AgentLoginAck_data: null,

      // 同意小休申请
      AgentApproveRestAck_data: null,


      /**
      * 小休数量
      */
      g_Rest4Count: 0,
      // 小休申请数据
      ResForData: [],

      /**
       * 小休状态(初始状态)，0表示同意,1表示不同意
       */
      restStatus: 0,

      // 排队电话数据
      CallQueueData: [],

      /**
      * 当前座席是否签入所有座席组
      * 1=签入所有座席组，0=非签入所有座席组
      */
      g_AgentGroup4AgentFlag: 0,

      /**
       * 当前座席是否签入所有技能组
       * 1=签入所有技能组，0=非签入所有技能组
       */
      g_SkillGroup4AgentFlag: 0,

      /**
       * 会议主持者是否进行会议
       * 1=是，0=否
       */
      g_ConferenceCaller: 0,
      /**
       * 当前会议所有参与者
       */
      g_ConferenceArray: [],
      /**
       * 会议管理窗口打开标识
       * 1=打开状态，0=关闭状态
       */
      g_ConferenceDialog: '0',
      /**
       * 传真服务地址
       */
      g_FaxServersPath: "",
      muteState: false,

      panelMode: 'normal', // normal mini
      viewModel: 'numberPanel',// numberPanel  history telRingPanel
      loginLoading: false,
      currentStatus: 'offline',
      currentAgentCode: -1,
      currentCallType: '',
      callingLocation: '',

      recordInfo: {

      },
      nearlyCallInfo: null,

      loadingHis: false,
      historyRecords: [],
      hisCurrentPage: 1,
      historyRecordTotal: 0,

      currentSerialNum: null,
      isRing: false,
      heartbeatIntervel: null,
      needReload: false,
      showAgentList: false,

      showAgentSet: false,
      remainingTime: 0,
      remainingTimer: null,
      agentSetForm: {
        //文书处理时长(秒)
        textProcTime: 60,
        //消息提示时长(秒)
        popMsgTime: 3,
        //小休时长(秒)
        restTime: 120,
        // 呼转连接模式
        transferConnectMode: '1',
        showLoginWindow: 0,
        autoBusyAfterTalk: 1,
        autoSigin: 1,
        showWhenCalling: 1
      },
      showSkillList: false,
      skillSeacrhBox: {
        groupName: '',
        skillName: ''
      },
      groupList: [],
      skillList: [],
      checkHeartTimer: null,

      linkStateLabel: '',
      img_keepOrContinue: '/jxyAgent/images/icon/Enable/keep.png',
      keepOrContinueLabel: '保持',
      img_time_state: '/jxyAgent/images/icon/agent_status_1.png',
      agentStatusLabel: '未登录',
      muteLable: "开始静音",
      img_mute: "images/icon/Enable/mute.png",

      /**
  * 通话时长
  */
      g_Timer4TalkingTime: null,
      timersDuration: 0,
      txt_duration: '00:00:00',
      idlecount: 0,
      setbusycount: 0,
      aftertalkcount: 0,

      phoneNO: '',
      skillGroupValue: '',

      groupsIds: [],
      skillIds: [],
      groupWithSkills: [],

      skillGroups: [],
      callType: '1',
      callTypes: [
        { value: '1', name: '呼叫外线' },
        { value: '2', name: '邀请外线' },
        { value: '3', name: '转移外线并保持' },
        { value: '4', name: '转移外线并释放' },
      ],

      messageList: [],
      m_ifAutoBusiness: 0,
      vdns: [],
      loginInfo: {},


      m_FinishedGetAgent: false,
      m_ifAutoBusiness: 0,
      telComeCount: 0,

      autoCallIPs: new Array(),
      interGetStatusCountTime: null,//获取状态人数的定时器

      g_connectclose_retry_connect_interval: 1000,	// 网络断开后自动重联的间隔时间,单位毫秒
      g_agp_reconnect_interval: null,				// agp服务重联定时器
      g_agp_is_reconnecting: false,					// 当前是否正在重联AGP服务
      g_agp_reconnect_counter: 0,					// agp服务重联计数器

      /**
       * 标识当前是否已联接上了AGP服务,false=尚未联接,true=已联接
       */
      g_IsConnectAGP: false,

      /**
       * agp服务器的url地址
       */
      g_agp_server_url: null,

      /**
       * 文书处理定时器对象
       */
      m_Timer4TextProcess: null,

      /**
       * 文书处理计数器
       */
      m_TextProcessCounter: 0,

      g_HeartSendInfo_Seq: 0, // 心跳序号

      g_HeartSendInfo_WebSessionID: null,

      g_bsSessionID: null,

      /**
       * 本地号码前缀
       */
      g_TelNoPrefix: [],

      m_SipPhoneDialOutNO: "",

      closeNetTime: 0,

      stopHeart: false,
      bIsReconnect: false,

      /**
       * 座席心跳回显
       */
      g_HeartSendInfo_LastRecvSeq: 0,
      g_HeartSendInfo_TotalLost: 0,
      g_HeartSendInfo_Received: 0,

      g_ModalDialogObj: null,
      g_MainProgressBarObj: null,

      g_agp_real_reconnect_counter: 0,
      g_Socket4AGP: null,

      oldTime: null,
      nowTime: null,

      m_iBackJsonTimeOutCount: 5,
      m_Timer4BackJsonTimeOut: null,
      flag1: 0,
      missedNum: 0,

      objAgentCallItem: null,

      // 座席状态表
      stateMap: {
        // AgentNull
        1: {
          label: "未登录",
          name: 'CONST_CCS_AS_Unknown_1',
          icon: "agent_status_1.png",
          description: "未知座席状态(未登录)"
        },
        2: {
          label: "示忙",
          name: 'CONST_CCS_AS_SetBusy_2',
          icon: "agent_status_2.png",
          description: "座席正在示忙"
        },
        4: {
          label: "小休",
          name: 'CONST_CCS_AS_AUX_4',
          icon: "agent_status_4.png",
          description: "离席"
        },
        8: {
          label: '被阻塞',
          name: 'CONST_CCS_AS_Block_8',
          icon: "agent_status_8.png",
          description: "座席被阻塞"
        },
        16: {
          label: "未签入",
          name: "CONST_CCS_AS_Available_16",
          icon: "agent_status_16.png", description: "座席登录未签入",
        },
        32: {
          label: "空闲",
          name: 'CONST_CCS_AS_Idle_32',
          icon: "agent_status_32.png",
          description: "座席空闲(已签入)"
        },
        64: {
          label: "振铃",
          name: "CONST_CCS_AS_Ring_64",
          icon: "agent_status_64.png",
          description: "座席正在振铃"
        },
        128: {
          label: "外呼",
          name: "CONST_CCS_AS_CallOut_128",
          icon: "agent_status_128.png",
          description: "座席外呼"
        },
        256: {
          label: "通话中",
          name: "CONST_CCS_AS_Taking_256",
          icon: "agent_status_256.png",
          description: "座席正在通话(通话中)，即座席应答了呼叫时"
        },
        512: {
          label: "保持",
          name: "CONST_CCS_AS_Hold_512",
          icon: "agent_status_512.png",
          description: "座席保持状态"
        },
        1024: {
          label: '话后处理',
          name: "CONST_CCS_AS_AfterCallWork_1024",
          icon: "agent_status_1024.png",
          description: "话后处理"
        },
        2048: {
          label: '质检',
          name: "CONST_CCS_AS_InspectStatus_2048",
          icon: "agent_status_2048.png",
          description: "座席正在质检其他座席(如不希望被分配非实时媒体任务则签出该技能)"
        },
        4096: {
          label: '离线',
          name: "CONST_CCS_AS_OffLine_4096",
          icon: "agent_status_4096.png",
          description: "座席离线"
        },
        8192: {
          label: '报工号',
          name: "CONST_CCS_AS_PlayWorkNO_8192",
          icon: "agent_status_8192.png",
          description: "通话报工号"
        },
        16384: {
          label: '催挂音',
          name: "CONST_CCS_AS_PlayOnHookVoc_16384",
          icon: "agent_status_16384.png",
          description: "送催挂音"
        },
        32768: {
          label: '收听录音',
          name: "CONST_CCS_AS_PlayRecord_32768",
          icon: "agent_status_32768.png",
          description: "收听录音"
        },
        65536: {
          label: '分机临时失效',
          name: "agent_status_65536",
          icon: "agent_status_32768.png",
          description: "分机临时失效"
        },
        131072: {
          label: '分机不存在',
          name: "CONST_CCS_AS_EXTNUMNOEXISTS_131072",
          icon: "agent_status_131072.png",
          description: "分机不存在"
        },
        262144: {
          label: '分机未注册',
          name: "CONST_CCS_AS_EXTNUMUNREGIST_262144",
          icon: "agent_status_262144.png",
          description: "分机未注册"
        },
        524288: {
          label: '边界',
          name: "CONST_CCS_AS_ENDSTATUS_524288",
          icon: "agent_status_end.png",
          description: "最后一个状态用于限制状态边界"
        },

      },

      loadAgent: false,
      agentSearchBox: {
        groupId: null,
        agentStatus: null
      },

      groupTree: [],
      agentListFull: [],
      agentList: [],
      opType: '',


      // CONS_CCS_TT_Release: 0,	// 释放转
      // CONS_CCS_TT_Hold: 1,	// 保持转
      transferTypes: {
        0: {
          label: '释放转',
          disabled: false
        },
        1: {
          label: '保持转',
          disabled: true
        }
      },
      ivrSearchBox: {
        transferType: '0',
        flowName: null
      },
      showTransferIVR: false,
      ivrPages: {
        current: 1,
        total: 0,
        pageSize: 10,
      },
      ivrList: [],
      loadIvr: false,

      showTransferSkill: false,
      skillSearchBox: {
        groupName: '',
        skillName: ''
      },

      skillPages: {
        current: 1,
        total: 0,
        pageSize: 10,
      },
      transferSkillFullList: [],
      transferSkillList: [],
      loadSkill: false,

      showWaitList: false,
      loadWait: false,
      waitList: [],
      waitSearchBox: {
        groupName: '',
        skillName: ''
      },

      showMeetingMgr: false,
      meetingMgrData: {
        confSize: 4,
        skillGroupValue: '',
        phoneNO: ''

      },
      meetingList: [],
      loadMeeting: false,
      type: '',
    }
  },
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler: function (val) {
        console.log('options val', val)
        agentServer.initData(val.params)
        this.g_agp_server_url = 'ws://' + val.params?.agpIp + ':' + val.params?.agpPort
      }
    }
  },
  computed: {
    baseURL: function () {
      return this.$store.getters['systemSupport/systemSupport']?.HL || process.env.VUE_APP_API_ROOT
    },
    hlLawyerStatus: function () {
      let status = this.$store.getters['lawyerInfo/lawyerStatus']['HL_FP']
      return status
    },
    canCall: function () {
      // return (this.currentStatus >= 200 && this.currentStatus < 300)
      return true
    },
    columnsAgent: function () {
      let that = this
      return [{
        type: 'index',
        title: '序号',
        align: "center",
        minWidth: 90,
        fixed: 'left'
      }, {
        title: "座席ID",
        align: "left",
        key: "id",
        tooltip: true,
        minWidth: 90,
      }, {
        title: "座席姓",
        align: "left",
        key: "username",
        tooltip: true,
        minWidth: 90,
      }, {
        title: "座席工号",
        align: "left",
        key: "workno",
        tooltip: true,
        minWidth: 90,
        // render: (h, params) => {
        //   return h('Tag', params.row.workOrderStatusLabel)
        // }
      }, {
        title: "技能名称",
        align: "left",
        key: "skillname",
        tooltip: true,
        minWidth: 90,
        // render: (h, params) => {
        //   return h('Tag', params.row.workOrderStatusLabel)
        // }
      }, {
        title: '座席状态',
        align: "center",
        minWidth: 90,
        key: 'agentStatus',
        render: (h, params) => {
          console.log('params.row.agentStatus', params.row.agentStatus)
          return h('Button', {
            props: {
              disabled: params.row.agentStatus == 32 ? false : true,
              size: 'small',
              type: params.row.agentStatus == 32 ? 'success' : 'error'
            },
            on: {
              'click': () => {
                let that = this
                let objCallListItem = this.GetAgentCallListItemEx(this.g_BaseCallPID, this.g_AgCallPID)
                let iAgentId = params.row.id			// 选择的目标座席主键ID
                let strWorkNO = params.row.workno			// 选择的目标座席工号
                let iAgentSkillID = params.row.skillid	// 选择的目标座席当前技能主键ID
                let iAgentGroupID = params.row.groupid	// 选择的目标座席当前座席组主键ID
                let strPrivateInfo = ""
                if (objCallListItem != null)
                  strPrivateInfo = JSON.stringify(objCallListItem)

                if ((this.g_WorkNO != undefined) && (this.g_WorkNO != null) && (this.g_WorkNO == strWorkNO)) {
                  this.$Message.warning("不允许操作自己！")
                  return
                }
                if (this.currentAgentCode == 16) {
                  this.$Message.warning("当前您暂未签入座席，请签入！")
                  return
                }

                if (this.opType == 'call') {
                  this.$Modal.confirm({
                    title: '呼出提醒',
                    content: '<p>请确认是否拨打当前座席！</p>',
                    okText: '呼出',
                    onOk: () => {
                      this.AgentCallAgent(this.g_CallerNO4AgentCallout, strWorkNO, iAgentGroupID, iAgentSkillID, this.constMap.defaultCallOutConfSize, this.constMap.defaultCallOutBusiType, this.constPop.ConstPopupTypeAgentDefaultCallOutAgent)
                      this.canceAgent()
                      // this.showAgentList = false
                      // top.$Send.AgentCallAgent(top.g_CallerNO4AgentCallout, strWorkNO, m_AgentGroupId, iAgentSkillID, top.g_CONST_DefaultCallOutConfSize, top.g_CONST_DefaultCallOutBusiType, top.$Global.ConstPopupTypeAgentDefaultCallOutAgent())
                    }
                  })
                } else if (this.opType == 'transfer') {
                  //转移
                  this.$Modal.confirm({
                    title: '转移提醒',
                    content: '<p>请确认是否转移通话到当前座席！</p>',
                    okText: '转移',
                    onOk: () => {
                      this.ShiftAgent(strWorkNO, iAgentGroupID, iAgentSkillID, strPrivateInfo)
                      this.canceAgent()
                      // top.$Send.AgentCallAgent(top.g_CallerNO4AgentCallout, strWorkNO, m_AgentGroupId, iAgentSkillID, top.g_CONST_DefaultCallOutConfSize, top.g_CONST_DefaultCallOutBusiType, top.$Global.ConstPopupTypeAgentDefaultCallOutAgent())
                    }
                  })

                } else if (this.opType == 'grabbing') {
                  // 抢接
                  this.$Modal.confirm({
                    title: '抢接提醒',
                    content: '<p>请确认是否抢接当前座席的通话！</p>',
                    okText: '抢接',
                    onOk: () => {
                      this.SnatchAgent(iAgentGroupID, iAgentSkillID, iAgentId)
                      this.canceAgent()
                      // top.$Send.AgentCallAgent(top.g_CallerNO4AgentCallout, strWorkNO, m_AgentGroupId, iAgentSkillID, top.g_CONST_DefaultCallOutConfSize, top.g_CONST_DefaultCallOutBusiType, top.$Global.ConstPopupTypeAgentDefaultCallOutAgent())
                    }
                  })
                } else if (this.opType == 'meeting') {
                  // 抢接
                  this.$Modal.confirm({
                    title: '邀请提醒',
                    content: '<p>请确认是否邀请座席加入会议！</p>',
                    okText: '邀请',
                    onOk: () => {
                      // top.$Send.AgentCallAgent(callerNO4AgentCallout, strWorkNO, m_AgentGroupId, iAgentSkillID, confSize, top.g_CONST_DefaultCallOutBusiType, top.$Global.ConstPopupTypeAgentDefaultCallOutAgent())
                      this.g_ConferenceCaller = "1"	//标识会议开始
                      this.AgentCallAgent(this.g_CallerNO4AgentCallout, strWorkNO, iAgentGroupID, iAgentSkillID, this.meetingMgrData.confSize, this.constMap.defaultCallOutBusiType, this.constPop.ConstPopupTypeAgentDefaultCallOutAgent)
                      this.canceAgent()
                      // top.$Send.AgentCallAgent(top.g_CallerNO4AgentCallout, strWorkNO, m_AgentGroupId, iAgentSkillID, top.g_CONST_DefaultCallOutConfSize, top.g_CONST_DefaultCallOutBusiType, top.$Global.ConstPopupTypeAgentDefaultCallOutAgent())
                    }
                  })
                }
              }
            },
          }, this.stateMap[params.row.agentStatus]?.label || '未知')
        }
      },]
    },
    columnsIvr: function () {

      return [{
        type: 'index',
        title: '序号',
        align: "center",
        width: 90,
        fixed: 'left'
      }, {
        title: "流程编号",
        align: "left",
        key: "flowid",
        tooltip: true,
        minWidth: 90,
      }, {
        title: "节点编号",
        align: "left",
        key: "nodeid",
        tooltip: true,
        minWidth: 90,
      }, {
        title: "流程名称",
        align: "left",
        key: "name",
        tooltip: true,
        minWidth: 90,
        render: (h, params) => {
          let that = this
          return h('Button', {
            props: {
              disabled: this.currentAgentCode != 256 ? true : false,
              size: 'small',
              type: 'success'
            },
            on: {
              'click': () => {
                let that = this
                this.$Modal.confirm({
                  title: '转移提醒',
                  content: '<p>请确认是否转移当前通话！</p>',
                  okText: '转移',
                  onOk: () => {
                    console.log('ivr transfer onOk', params.row)
                    let transferType = Number.parseInt(this.ivrSearchBox.transferType)
                    let iFlowID = params.row.flowid
                    let iNodeID = params.row.nodeid
                    let strPrivateInfo = "" // 座席要传入到IVR的私有信息
                    this.AgentTransferIVR(that.g_AgentID, that.g_CallID, that.g_CallIDType, transferType, iFlowID, iNodeID, strPrivateInfo)
                    this.canceIvr()

                  }
                })
              }
            },
          }, params.row.name)
        }
      },]
    },
    columnsSkill: function () {
      return [{
        type: 'index',
        title: '序号',
        align: "center",
        width: 90,
        fixed: 'left'
      }, {
        title: "座席组",
        align: "left",
        key: "groupname",
        tooltip: true,
        minWidth: 90,
      }, {
        title: "技能",
        align: "left",
        key: "skillname",
        tooltip: true,
        minWidth: 90,
      }, {
        title: "操作",
        align: "center",
        key: "op",
        tooltip: true,
        minWidth: 90,
        render: (h, params) => {
          let that = this
          return h('Button', {
            props: {
              disabled: this.currentAgentCode != 256 ? true : false,
              size: 'small',
              type: 'success'
            },
            on: {
              'click': () => {
                let that = this
                this.$Modal.confirm({
                  title: '转移提醒',
                  content: '<p>请确认是否转移当前通话！</p>',
                  okText: '转移',
                  onOk: () => {
                    console.log('skill transfer onOk', params.row)

                    this.TransferAgentACD(params.row.groupid, params.row.skillid)
                    this.canceSkill()
                  }
                })
              }
            },
          }, '转移')
        }
      },]
    },
    columnsWait: function () {
      return [{
        type: 'index',
        title: '序号',
        align: "center",
        width: 90,
        fixed: 'left'
      }, {
        title: "排队电话",
        align: "left",
        key: "CallerNO",
        tooltip: true,
        minWidth: 90,
      }, {
        title: "座席组",
        align: "left",
        key: "AgentGroupName",
        tooltip: true,
        minWidth: 90,
      }, {
        title: "技能",
        align: "left",
        key: "SkillName",
        tooltip: true,
        minWidth: 90,
      }, {
        title: "操作",
        align: "center",
        key: "op",
        tooltip: true,
        minWidth: 90,
        render: (h, params) => {
          let that = this
          return h('Button', {
            props: {
              disabled: this.currentAgentCode != 256 ? true : false,
              size: 'small',
              type: 'success'
            },
            on: {
              'click': () => {
                let that = this
                this.$Modal.confirm({
                  title: '接听提醒',
                  content: '<p>请确认是否接听当前通话！</p>',
                  okText: '转移',
                  onOk: () => {
                    console.log('skill transfer onOk', params.row)
                    this.SnatchACDQueueCall(params.row.LogicNO)
                    this.cancelWait()
                  }
                })
              }
            },
          }, '转移')
        }
      }


      ]
    },
    columnsMeeting: function () {
      return [{
        type: 'index',
        title: '序号',
        align: "center",
        width: 90,
        fixed: 'left'
      }, {
        title: '座席/号码',
        align: "center",
        minWidth: 130,
        key: 'calledNo'
      }, {
        title: '加入时间',
        align: "center",
        minWidth: 130,
        key: 'joinTime'
      },]
    },
    waitNum: function () {
      return Object.keys(this.AgentQueueCallGridData).length || 0
    },
    listStatusCanChoose: function () {
      return [32, 2, 256, 64, 512, 4, 16, 128, 1024, 2048, 8192]
    }
  },
  methods: {
    deepCopy: function (o) {
      if (o instanceof Array) {
        let n = []
        for (let i = 0; i < o.length; ++i) {
          n[i] = this.deepCopy(o[i])
        }
        return n
      } else if (o instanceof Function) {
        let n = new Function("return " + o.toString())()
        return n
      } else if (o instanceof Object) {
        let n = {}
        for (let i in o) {
          n[i] = this.deepCopy(o[i])
        }
        return n
      } else {
        return o
      }
    },
    /**
   * 获取最近的通话信息
   */
    nearlyCall: function (callType, telNumber) {
      let that = this
      let params = new this.$URLSearchParams()
      params.append("callType", callType)
      params.append("telNumber", telNumber)
      this.$axios.post(that.$apis.HLConfigApi.callRecord.nearlyCall, params, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          console.log('nearlyCall success')
          that.nearlyCallInfo = res.result || {}
        } else {
          console.log('nearlyCall fail', res)
        }
      }).catch(function (err) {
        console.log('nearlyCall err', err)
      })
    },
    loadCallRecord: function (data) {
      if (data.ledgerId) {
        this.$emit('loadCallRecord', this.options.appId, data.serialNum)
      } else {
        this.$Message.warning('暂无台账！')
        return
      }
    },
    /**
       * 点击显示
       */
    showHistory: function () {
      this.viewModel = 'history'
      this.pageChange(1)
    },
    showOPHis: function () {
      this.viewModel = 'opHis'
    },
    backPanel: function () {
      if ([64, 128, 256, 512, 1024, 8192].indexOf(this.currentAgentCode) >= 0) {
        this.viewModel = 'telRingPanel'
      } else {
        this.viewModel = 'numberPanel'
      }
    },
    pageChange: function (page) {
      console.log('pageChange', page)
      this.hisCurrentPage = page
      let _this = this
      this.loadingHis = true
      this.historyRecords = []
      let pageParams = {
        pageable: true,
        pageNo: page,
        pageSize: 10,
      }

      let params = new this.$URLSearchParams()
      params.append("pageParams", JSON.stringify(pageParams))
      this.$axios.post(_this.$apis.HLConfigApi.callRecord.nearlyCallPage, params, { baseURL: this.baseURL }).then(res => {
        _this.loadingHis = false
        if (res.success) {
          _this.historyRecordTotal = res.result?.total || 0
          _this.historyRecords = res.result?.data || []
          _this.historyRecords.forEach(element => {
            if (element.whenUpdated) element.whenUpdated = _this.$common.getDate(element.whenUpdated)
            if (element.whenCreated) element.whenCreated = _this.$common.getDate(element.whenCreated)
          })
        } else {
          _this.$Message.error({
            content: res.message,
            duration: 3
          })
        }
      }).catch(function (err) {
        _this.loadingHis = false
        _this.$Message.error({
          content: '数据获取失败！',
          duration: 3
        })
      })
    },
    addNumber: function (num) {
      this.phoneNO += num
    },


    /**
     * 排队电话抢接
     */
    SnatchACDQueueCall: function (logicNO) {
      //{{ modify by zhao 2018-08-27
      //var base = new Base(11, CONS_EU_AG_AgentCallOutAck_30);
      let base = new Base(11, 30)
      //}}

      let aprecordACDManualAllocCall = new APRecordACDManualAllocCall(base, this.g_AgentID, logicNO)
      let aprecordACDManualAllocCallJSON = JSON.stringify(aprecordACDManualAllocCall)
      //{{ modify by zhao 2018-08-27
      //$Log.info("Send [" + ShowComponentName(base.ComponentType) + "," + ShowAgentMessageName(base.Function) + "]==>(" + aprecordACDManualAllocCallJSON + ")");
      agentServer.$Log.send("Info", "Send [" + defComp.showComponentName(base.ComponentType) + "," + acdFunc.showACDMessageName(base.Function) + "]==>(" + aprecordACDManualAllocCallJSON + ")")
      //}}

      try {
        this.g_Socket4AGP.send(aprecordACDManualAllocCallJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },

    /**
    * 显示座席排队电话数量信息
    */
    changeToolBarAgentACDQueueCallButtonNumber () {
      this.waitNum = Object.keys(this.AgentQueueCallGridData).length
      // var objMainFrameRightTab4ACDQueueHeadDOM = getLigerTabHeaderTextDOM("mainFrameRightTab", "mainFrameRightTab4ACDQueue")
      // //showMainFrameAgentQueueCallGrid(); // 在主框架窗口右边栏tab选项卡排队

      // if (Number.parseInt($Global.AgentQueueCallGridData.length) > 0) {
      //   if (objMainFrameRightTab4ACDQueueHeadDOM != null)
      //     objMainFrameRightTab4ACDQueueHeadDOM.innerHTML = "排队<font color='red'>(" + String($Global.AgentQueueCallGridData.length) + ")</font>"

      //   $("#btn_queue span").text("排队(" + $Global.AgentQueueCallGridData.length + ")")
      //   $("#btn_queue span").css({ "color": "red" })
      // }
      // else {
      //   if (objMainFrameRightTab4ACDQueueHeadDOM != null)
      //     objMainFrameRightTab4ACDQueueHeadDOM.innerHTML = "排队"
      //   $("#btn_queue span").text("排队").removeClass("color")
      //   $("#btn_queue span").removeAttr("style")
      // }

      // try {
      //   if ((g_ModalDialogObj) && (g_ModalDialogObj.frame) && (g_ModalDialogObj.frame.refreshACDQueueCallGrid)) {
      //     g_ModalDialogObj.frame.refreshACDQueueCallGrid()
      //   }
      // }
      // catch (e) {
      //   console.error("改变显示ACD排除电话数量信息时异常" + e)

    },
    /**
    * 显示座席未接电话数量信息
    */
    changeToolBarAgentMissedCallButtonNumber: function () {
      //if(Number.parseInt($Global.AgentMissedCallGridData.length) > 0)
      this.missedNum = Object.keys(this.AgentMissedCallGridData).length

    },
    /**
     * 改变座席状态显示的图标
     */
    ChangePhoneToolbarAgentStatusIcon (iAgentState) {
      try {
        let statusC = this.stateMap[iAgentState]
        if (statusC) {
          this.img_time_state = "/jxyAgent/images/icon/" + statusC.icon
          this.agentStatusLabel = statusC.label
        }
      } catch (e) {
        agentServer.$Log.send('Error', "改变座席状态显示的图标失败" + agentServer.$Log.message(e))
        this.agentStatusLabel = "未知状态"
      }
    },


    /**
     * 初始化座席配置
     */
    loadAgentPersonalized () {
      let that = this
      agentServer.loadAgendSetting(this.g_AgentID).then(data => {
        console.log('loadAgentPersonalized data', data)
        that.agentSetForm = {
          //文书处理时长(秒)
          textProcTime: data.textproctime || 60,
          //消息提示时长(秒)
          popMsgTime: data.popmsgtime || 3,
          //小休时长(秒)
          restTime: data.resttime || 120,
          // 呼转连接模式
          transferConnectMode: data.transferconnectmode ? data.transferconnectmode.toString() : '1',
          // 启动后自动打开登陆窗口 1:选中0：未选中
          showLoginWindow: data.showloginwindow,
          //// 启用通话中自动置忙1:选中0：未选中
          autoBusyAfterTalk: data.autobusyaftertalk,
          //登陆后自动签入所属组&技能 1:选中0：未选中
          autoSigin: data.autosigin,
          // 来电弹屏1:选中0：未选中
          showWhenCalling: data.showwhencalling
        }
        // $Global.TextProcTime = data.textproctime
        // $Global.restTime = data.resttime
        // $Global.PopMsgTime = data.popmsgtime

        // 加载右侧拨号盘下的座席组技能列表(外呼时需要使用)
        that.loadSelectGroupAndSkill4Call()


        that.m_FinishedLoadAgentPersonalized = true

      }).catch(error => {
        console.log('loadAgentPersonalized error', error)
        this.$Message.error({
          content: '初始化座席配置失败！',
          duration: 3
        })
      })
    },

    initVDN () {
      let that = this
      agentServer.initVDN().then(data => {
        if ((data == null) || (data.lengh < 1)) {
          that.$Message.error("没有获取到VDN信息，请联系统管理员.")
          return
        } else {
          that.vdns = data
        }
      }).catch(error => {
        console.log('initVDN', error)
        that.$Message.error("获取VND信息失败！")
      })

    },
    loadAllGroup: function (type) {
      let that = this
      this.opType = type
      this.groupTree = []
      this.agentListFull = []
      this.agentList = []
      this.showAgentList = true
      this.$Spin.show()
      agentServer.initGroups(this.g_AgentID, '', 0).then(result => {
        let allGroup = result.Rows || []
        allGroup.forEach(item => {
          that.groupTree.push({
            title: item.name,
            id: item.id,
            calledNo: item.calledno,
            calledNoSrc: item.callednosrc
          })
        })
        // 空闲
        switch (type) {
          case 'grabbing':
            // 响铃
            this.agentSearchBox.agentStatus = '64'
            break
          default:
            // 空闲
            this.agentSearchBox.agentStatus = '32'
            break
        }
        if (that.groupTree.length > 0) {
          this.agentSearchBox.groupId = that.groupTree[0].id
          this.findAgent()
        }
      }).catch(err => {
        console.log('loadAllGroup error', err)
        that.$Message.error({
          content: '获取技能组失败！',
          duration: 3
        })
      }).finally(() => {
        that.$Spin.hide()
      })
    },
    findAgent: function () {
      let that = this
      if (this.agentSearchBox.groupId == null || this.agentSearchBox.groupId == undefined) {
        this.$Message.warning("请选择座席组！")
        return
      }
      this.loadAgent = true
      this.agentListFull = []
      this.agentList = []
      agentServer.loadAgentAndSkillByGroupId(this.agentSearchBox.groupId).then(data => {
        console.log('loadAgentAndSkillByGroupId ', data)
        this.agentListFull = data
        let AgentStatus = []
        this.agentListFull.forEach(agent => {
          agent.groupid = this.agentSearchBox.groupId
          let part = {
            AgentGroupID: that.agentSearchBox.groupId,
            AgentSkillID: agent.skillid,
            AgentID: agent.id,
          }
          AgentStatus.push(part)
        })

        // “AgentStatus":[{“AgentGroupID":xxxx,"AgentSkillID":xxxx,"AgentID":xxxx,"Status":xxx}]

        let base = new Base(12, 144)
        let stRequestAgentStatus = new RequestAgentStatus(base, this.g_VDNID, this.g_AgentID, data.length, AgentStatus)
        let stRequestAgentStatusJSON = JSON.stringify(stRequestAgentStatus)

        agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + stRequestAgentStatusJSON + ")")

        try {
          this.g_Socket4AGP.send(stRequestAgentStatusJSON)
        } catch (e) {
          agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
          this.$Message.warning('网络发生异常，请再试一次')
        }

      }).catch(err => {
        console.log('loadAgentAndSkillByGroupId err', err)
        this.$Message.error("加载座席失败！")
      }).finally(() => {
        that.loadAgent = false
      })
    },
    canceAgent: function () {
      this.agentSearchBox = {
        groupId: '',
        agentStatus: ''
      }
      this.showAgentList = false
    },
    getStatusCount () {
      let that = this
      agentServer.getAgentStatusCount().then(data => {
        that.idlecount = data?.idlecount || 0
        that.setbusycount = data?.setbusycount || 0
        that.aftertalkcount = data?.aftertalkcount || 0
      }).catch(err => {
        console.log('getStatusCount err', err)
      })
    },

    /**
     * 保存VDN等登录信息到后台的Session
     */
    saveLoginInfo2Session: function (ObjData) {
      let that = this
      agentServer.saveAgentLoginInfo(this.g_VDNID, this.g_AgentID, this.g_WorkNO, this.loginInfo.password, this.g_bsSessionID).then(data => {
        if (data) {
          that.afterSaveLoginInfo2Session(ObjData)
        } else {
          that.$Message.error("vdnId保存会话失败,请与管理员联系.")
        }
      }).catch(err => {
        console.log('saveLoginInfo2Session error ', err)
      })
    },
    loadSkillList: function () {
      let that = this
      this.skillList = []
      let strSkillIDs = [];

      (this.g_SkillArray4Agent || []).forEach(item => {
        strSkillIDs.push(item.SkillID)
      })
      agentServer.getGroupIDsBySkillIds(strSkillIDs).then(data => {
        console.log('loadSkillList data', data)
        if ((data != null) && (data.length > 0)) {
          data.forEach(dbitem => {
            this.g_SkillArray4Agent.forEach(skillitem => {
              if (dbitem.skillid == skillitem.SkillID) {
                let part = skillitem
                part.GroupId = dbitem.groupid
                that.g_AgentGroupArray4Agent.forEach(item => {
                  if (item.AgentGroupID == dbitem.groupid) {
                    part.GroupName = item.GroupName
                  }
                })
                that.skillList.push(part)
              }
            })
          })
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    initAgentSet: function () {
      let that = this
      this.$refs.agentSetForm.resetFields()
      agentServer.loadAgendSetting(this.g_AgentID).then(data => {
        console.log('initAgentSet data', data)
        this.agentSetForm = {
          //文书处理时长(秒)
          textProcTime: data.textproctime || 60,
          //消息提示时长(秒)
          popMsgTime: data.popmsgtime || 3,
          //小休时长(秒)
          restTime: data.resttime || 120,
          // 呼转连接模式
          transferConnectMode: data.transferconnectmode ? data.transferconnectmode.toString() : '1',
          // 启动后自动打开登陆窗口 1:选中0：未选中
          showLoginWindow: data.showloginwindow,
          //// 启用通话中自动置忙1:选中0：未选中
          autoBusyAfterTalk: data.autobusyaftertalk,
          //登陆后自动签入所属组&技能 1:选中0：未选中
          autoSigin: data.autosigin,
          // 来电弹屏1:选中0：未选中
          showWhenCalling: data.showwhencalling
        }
        this.showAgentSet = true
      }).catch(error => {
        console.log('initAgentSet error', error)
        this.$Message.error({
          content: '加载座席配置失败！',
          duration: 3
        })
      })
    },


    // 调用方法
    createFunc (funcName) {
      this.func = new Function(funcName + "();")
    },


    /**
    * 获取返回确认消息
    * @param functionName 调用的函数名称
    * @param backJson 传递的Json对象
    */
    getBackJsonTimeOut (functionName, backJson) {
      if (this.m_iBackJsonTimeOutCount == 0) {
        this.$Message.error('服务器端返回数据超时!')
        clearInterval(this.m_Timer4BackJsonTimeOut)
        this.m_Timer4BackJsonTimeOut = null
      } else {
        this.m_iBackJsonTimeOutCount--
        if (backJson != '' && typeof (backJson) != "undefined") {

          clearInterval(this.m_Timer4BackJsonTimeOut)
          this.m_Timer4BackJsonTimeOut = null
          let callFun = new createFunc(functionName)
          try {
            callFun.func()
          } catch (e) {
            this.$Message.error('找不到方法!')
          }
        }
        else {
          return
        }
      }
    },

    /**
    * 获取座席呼叫类型的中文名称
    * @param iAgentCallOfferType 座席呼叫类型
    */
    getAgentCallOfferTypeName (iAgentCallOfferType) {
      let strText = "未知"
      switch (iAgentCallOfferType) {
        case 0:
          strText = "未知"
          break
        case 1:
          strText = "外线呼入"
          break
        case 2:
          strText = "座席呼叫座席"
          break
        case 3:
          strText = "三方通话"
          break
        case 4:
          strText = "会议呼叫"
          break
        case 5:
          strText = "监听"
          break
        case 6:
          strText = "强插"
          break
        case 7:
          strText = "呼转"
          break
        case 8:
          strText = "抢接"
          break
        case 9:
          strText = "拦截"
          break
        case 10:
          strText = "外呼"
          break
        case 11:
          strText = "OBS外呼"
          break
        case 12:
          strText = "SIP话机外呼"
          break
      }
      return strText
    },

    /**
    * 获取弹屏类型的中文名称
    * @param iPopuType 弹屏类型
    */
    getPopupTypeName (iPopuType) {
      let strText = "未知类型弹屏"
      switch (iPopuType) {
        case 1:
          strText = "来电弹屏"
          break
        case 2:
          strText = "自动外呼(OBS)弹屏"
          break
        case 3:
          strText = "呼叫外线弹屏"
          break
        case 4:
          strText = "未接电话回访弹屏"
          break
        case 5:
          strText = "座席流失电话回访弹屏"
          break
        case 6:
          strText = "ACD流失电话回访弹屏"
          break
        case 7:
          strText = "留言电话回访弹屏"
          break
        case 8:
          strText = "座席直接呼叫另一座席"
          break
      }
      return strText
    },

    /**
    * 根据座席来去电呼叫类型代码获取弹屏参数设置
    * @param iPopupType 弹屏类型
    * return 成功返回一个CallPopupSetting对象，否则返回null
    */
    getCallPopupSetting (iPopupType) {
      let obj = null
      if ((!this.g_CallPopupSettingList) || (this.g_CallPopupSettingList.length < 1))
        return null
      this.g_CallPopupSettingList.forEach(item => {
        if (iPopupType == item.PopupType) {
          obj = item
          // return false // 退出each
        }
      })
      // $.each(g_CallPopupSettingList, function (i, item) {
      //   if (iPopupType == item.PopupType) {
      //     obj = item
      //     return false // 退出each
      //   }
      // })
      return obj
    },

    /**
    * 根据LigerUI的Tab的DOM ID值及标签页的tabid的值来获取标签页显示Header文字的DOM
    * @param strTabDomID LigerUI的Tab的DOM ID
    * @param strTabPageDomID LigerUI标签页的tabid的值
    * return 成功返回一个<A>标记的DOM对象，否则返回null
    */
    getLigerTabHeaderTextDOM (strTabDomID, strTabPageDomID) {
      let objTab = $("#" + strTabDomID)[0]
      let arrayTabPages = null

      if (objTab == null)
        return null
      arrayTabPages = objTab.getElementsByTagName("li")
      if ((arrayTabPages == null) || (arrayTabPages.length < 1))
        return null
      for (let i = 0; i < arrayTabPages.length; i++) {
        let item = arrayTabPages[i]
        if ((item.attributes["tabid"]) && (item.attributes["tabid"].value == strTabPageDomID)) {
          return item.childNodes[0]
        }
      }
      return null
    },


    /**
     * 过滤来去电(座席呼叫座席)电话
     */
    filterAgent2AgentCall (CallOfferedType) {
      let returnResult = 0
      let strText = ""
      switch (CallOfferedType) {
        case 0:
          strText = "未知"
          returnResult = 1
          break
        case 1:
          strText = "外线呼入"
          break
        case 2:
          strText = "座席呼叫座席"
          returnResult = 1
          break
        case 3:
          strText = "三方通话"
          break
        case 4:
          strText = "会议呼叫"
          break
        case 5:
          strText = "监听"
          break
        case 6:
          strText = "强插"
          break
        case 7:
          strText = "呼转"
          break
        case 8:
          strText = "抢接"
          break
        case 9:
          strText = "拦截"
          break
        case 10:
          strText = "外呼"
          break
        case 11:
          strText = "OBS外呼"
          break
        case 12:
          strText = "SIP话机外呼"
          break
      }

      if (returnResult == 1)
        return true
      else
        return false
    },
    /**
     * 把保存登陆信息到cookie里
     *
     * @param workNO 工号
     * @param password  密码
     * @param extension 分机号
     */
    saveLogiInfoToCookie: function (workNO, password, extension) {
      // if ($("#isSaveInfo").attr("checked") == true) {
      if (false) {
        Cookies.set(this.constMap.cookie_WorkNO, workNO,
          {
            expires: 365
          })
        Cookies.set(this.constMap.cookie_Password, password,
          {
            expires: 365
          })
        Cookies.set(this.constMap.cookie_ExtensionTelNO, extension,
          {
            expires: 365
          })
        Cookies.set(this.constMap.cookie_IsCheck, 'checked',
          {
            expires: 365
          })
      } else {
        Cookies.remove(this.constMap.cookie_WorkNO)
        Cookies.remove(this.constMap.cookie_Password)
        Cookies.remove(this.constMap.cookie_ExtensionTelNO)
        Cookies.remove(this.constMap.cookie_IsCheck)
      }
    },

    /**
     * 座席心跳回显
     */
    onHeartbeatEcho: function (dataEvt) {
      try {

        let obj = dataEvt

        let wsUri = this.g_agp_server_url

        let seq = null

        let t = null

        li = obj.Echo.split('&')
        for (let i = 0; i < li.length; i++) {
          kv = li[i].split('=')

          if (kv[0] == "seq") {
            seq = Number.parseInt(kv[1])
          } else if (kv[0] == "t") {
            t = Number.parseInt(kv[1])
          }
        }

        let dateRecv = new Date()
        let timestamp = dateRecv.getTime()

        let elapsed_ms = 0

        if (timestamp > t) {
          elapsed_ms = timestamp - t
        }

        if (seq > this.g_HeartSendInfo_LastRecvSeq + 1) {
          lost = seq - this.g_HeartSendInfo_LastRecvSeq - 1
          this.g_HeartSendInfo_TotalLost += lost
          tmp = this.g_HeartSendInfo_TotalLost / seq * 100
          agentServer.$Log.send('Error', '数据包: 已发送 = ' + seq.toString() + '，已接收 = ' + g_HeartSendInfo_Received.toString() + '，丢失 = ' + this.g_HeartSendInfo_TotalLost.toString() + ' (' + tmp.toString() + '% 丢失)')
        }

        this.g_HeartSendInfo_Received++
        this.g_HeartSendInfo_LastRecvSeq = seq

        if (elapsed_ms < 500) {
          agentServer.$Log.send('Debug', '来自 ' + wsUri + '的回复：seq=' + seq.toString() + ', time=' + elapsed_ms.toString() + ' ms.')
        } else if (elapsed_ms < 1000) {
          agentServer.$Log.send('Info', '来自 ' + wsUri + '的回复：seq=' + seq.toString() + ', time=' + elapsed_ms.toString() + ' ms.')
        } else if (elapsed_ms < 2000) {
          agentServer.$Log.send('Warn', '来自 ' + wsUri + '的回复：seq=' + seq.toString() + ', time=' + elapsed_ms.toString() + ' ms.')
        } else {
          let timeSend = t * 0.001
          let timeRecv = timestamp * 0.001
          agentServer.$Log.send('Error', '来自 ' + wsUri + '的回复：seq=' + seq.toString() + ', time=' + elapsed_ms.toString() + ' ms. SendTimestamp:' + timeSend.toString() + '. RecvTimestamp:' + timeRecv.toString())
        }
      } catch (err) {
        // agentServer.$Log.send('Warn', 'RESPONSE: ' + String(dataEvt));
        // agentServer.$Log.send('Warn', 'Error: ' + err.message);
      }
    },

    /**
     * 添加消息内容
     * @param msg 消息内容
     */
    addMessages: function (msg, status = 'success') {
      let that = this
      this.messageList.unshift({
        time: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        message: msg,
        status: status
      })
    },
    timers: function () {
      this.nowTime = new Date()
      if (this.oldTime != null) {
        let timeDifference = this.nowTime.getTime() - this.oldTime.getTime()
        if (timeDifference > 40000) {
          this.$Message.warning({
            content: '心跳超时！',
            duration: 3
          })
        }
      }
      this.oldTime = this.nowTime
    },
    /**
     * 弹出座席主界面右下角消息提示框
     * @param strMsg 消息内容
     */
    rightPrint: function (strMsg) {
      this.$Notice.warning({
        title: '消息提示',
        desc: strMsg,
        duration: this.agentSetForm.popMsgTime
      })
    },
    /**
     * 初始化websocket
     */
    initWebSocket () {
      console.log('initJXYWebSocket start')
      this.g_HeartSendInfo_WebSessionID = this.GetNewGUID()
      this.g_bsSessionID = this.GetNewGUID()

      window.WebSocket = window.WebSocket || window.MozWebSocket
      if (!window.WebSocket) {
        console.error("error initJXYWebSocket")
        return
      }

      if (window.WebSocket) {
        // this.g_agp_server_url = 'ws://' + agentServer.v_wsIP + ':' + agentServer.v_wsPort
        agentServer.$Log.send('Info', "AGP Server ===>>" + this.g_agp_server_url)
        this.connect() //开始连接ws服务器
      }
    },

    /**
     * 心跳发送消息
     */
    heartbeat: function () {
      let that = this
      let base = new Base(12, 141)
      let codeSignal = "Welcome To Focustar"

      let timestamp = (new Date()).getTime()
      let echo = "seq=" + this.g_HeartSendInfo_Seq.toString() + "&t=" + timestamp.toString()
      this.g_HeartSendInfo_Seq++

      let heartSendInfo = new HeartSendInfo(base, codeSignal, this.g_HeartSendInfo_WebSessionID, echo)
      let heartSendInfoJSON = JSON.stringify(heartSendInfo)
      try {

        if (this.g_Socket4AGP) {
          this.g_Socket4AGP.send(heartSendInfoJSON)
        } else {
          agentServer.$Log.send('Warn', "send heartbeat message failed! g_Socket4AGP is null.")
        }
      } catch (e) {
        agentServer.$Log.send('Error', "send heartbeat message failed!" + e)
        console.log('sendInfo error', e)
      }
    },

    Reconnect2AGP: function () {
      if (this.g_agp_reconnect_interval) {
        agentServer.$Log.send('Error', "WebSocket onclose event received,try reconnect...")
        this.linkStateLabel = '<span style="color:red;">网络异常，正在尝试重连...</span>'
        // $("#linkStateLabel").text("网络异常，正在尝试重连...")
        // $("#linkStateLabel").attr({ "style": "color:red;" })
        this.g_agp_is_reconnecting = true
        this.g_agp_reconnect_counter = 0
        //20190731  调整间隔计时器调用方法
        this.g_agp_reconnect_interval = setInterval(this.connect(), this.g_connectclose_retry_connect_interval)
      }
    },

    connect: function () {
      console.log('connect', this.g_agp_reconnect_counter)

      let that = this
      /*if ((Number.parseInt(new Date().getTime() / 1000) - closeNetTime) > 10 && g_agp_reconnect_interval != null) {
          $.ligerDialog.error('请重新登录');
          $("#linkStateLabel").text("请重新登录");
          $("#linkStateLabel").attr({"style": "color:red;"});
          window.clearInterval(g_agp_reconnect_interval);
          g_agp_reconnect_interval = null;
          closeNetTime = 0;
          stopHeart = true;
          return;
      }*/

      //{{ add by zhao 2020-02-26
      if (this.g_agp_reconnect_interval) {
        if (this.g_agp_reconnect_counter == 0) {
          this.g_agp_real_reconnect_counter = 0
        }
        this.rightPrint("当前网络质量不佳...")
      }
      //}}

      this.g_agp_reconnect_counter = this.g_agp_reconnect_counter + 1

      console.log('g_agp_reconnect_counter', this.g_agp_reconnect_counter)

      if (this.g_agp_reconnect_counter > 20 || this.g_agp_real_reconnect_counter > 10) {
        // 重连次数超过最大重试次数则认为网络已故障，不再重连
        if (this.g_agp_reconnect_interval) {
          // 联接成功时不再重复尝试重联
          clearInterval(this.g_agp_reconnect_interval)
          this.g_agp_reconnect_interval = null
          this.g_agp_is_reconnecting = false
          this.g_agp_reconnect_counter = 0
        }

        Cookies.remove(this.constMap.cookie_IsLoad)

        agentServer.$Log.send('Error', "WebSocket onclose,retry connect failed!")

        this.$Message.warning("网络连接已断开，请刷新页面重新登录!")
        return
      }

      if (this.g_Socket4AGP == undefined || this.g_Socket4AGP == null || this.g_Socket4AGP == "") {
        //{{ add by zhao 2020-02-26
        this.bIsReconnect = false
        if (that.g_agp_reconnect_interval) {
          this.bIsReconnect = true
          this.g_agp_real_reconnect_counter = this.g_agp_real_reconnect_counter + 1

          if (this.g_agp_real_reconnect_counter > 1) {

            this.linkStateLabel = '<span style="color:red;">网络异常，正在尝试重连...</span>'
            that.$Notice.warning({
              title: '网络异常',
              content: '当前网络异常，正在重连服务器。<br>第' + that.g_agp_real_reconnect_counter + '次尝试重连...',
              duration: 2
            })
          }
        }

        //}}
        this.g_Socket4AGP = new WebSocket(this.g_agp_server_url)

        if (this.g_Socket4AGP == null) {
          if (this.g_agp_is_reconnecting == false) {
            // 当前并不是重联APG服务时
            agentServer.$Log.send('Error', "connect APG failed,g_Socket4AGP returned null ")
            this.g_IsConnectAGP = false
            this.$Message.error({
              content: '连接创建失败，请刷新页面重新连接!',
              duration: 3
            })
            // window.location.href = "index.html"
            return
          }
        }

        this.g_Socket4AGP.onopen = function (event) {
          that.socketOpen(event)
        }

        this.g_Socket4AGP.onclose = function (event) {
          console.log('onclose', event)

          // 网络断开,需要重联
          that.g_IsConnectAGP = false

          if (that.heartbeatIntervel) {
            clearInterval(that.heartbeatIntervel)
            that.heartbeatIntervel = null
          }

          that.g_Socket4AGP = null
          that.bIsReconnect = false
          that.Reconnect2AGP()
          that.linkStateLabel = '<span style="color:red;">网络断开，连接失败</span>'
          that.closeNetTime = Number.parseInt(new Date().getTime() / 1000)
          console.log('changeStatus onclose')
          that.needReload = true
          that.$emit('changeStatus', false)
          that.$emit('changeRecordStatus', 'offline')
          return
        }

        this.g_Socket4AGP.onerror = function (event) {
          console.log('onerror', event)
          agentServer.$Log.send('Error', "WebSocket g_Socket4AGP is onerror " + event.data)
          that.Reconnect2AGP()
          that.linkStateLabel = '<span style="color:red;">连接异常</span>'
          return
        }

        this.g_Socket4AGP.onmessage = function (event) {
          console.log('onmessage', event)
          let webSockData = event.data
          //agentServer.$Log.send('Info', "AGP ACK====>>>"+webSockData);
          // 过滤第一个webSockData 握手协议
          if (webSockData == "welcome to webSock!") {
            return
          }
          let OBackData = window["eval"]("(" + event.data + ")")
          switch (OBackData.Base.ComponentType) {
            case 12:
              //座席代理服务器
              //agentServer.$Log.send('Info', "Back [CONST_CCS_CT_AgentProxy_12," + agentFunc.showAgentMessageName(OBackData.Base.Function) + "]==>(" + JSON.stringify(OBackData) + ")");
              switch (OBackData.Base.Function) {
                // 1 2 登陆响应
                case 2:
                //Agent// ack
                case 147:
                  //146 147座席登录扩展接口Ack
                  console.log('座席登录扩展接口Ack', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentLoginExAck====>>>" + JSON.stringify(OBackData))
                  //当前座席登录后返回结果参数
                  that.AgentLoginAck(OBackData)
                  break
                case 4:
                  // 3 4 注销,退出AgentLoggedOff_Status
                  console.log('座席下线事件ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentLoggedOffAck====>>>" + JSON.stringify(OBackData))
                  that.AgentLoggedOffAck(OBackData)
                  break
                // 5 6调用签入组响应结果
                case 6:
                  console.log('座席签入组事件ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentSignInGroupAck====>>>" + JSON.stringify(OBackData))
                  that.agentSignInGroupAck(OBackData)
                  break
                // 7 8调用签出组响应结果
                case 8:
                  console.log('座席签出组事件ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentSignOutGroupAck====>>>" + JSON.stringify(OBackData))
                  that.agentSignOutGroupAck(OBackData)
                  break
                // 9 10调用签入技能响应结果
                case 10:
                  console.log('座席签入技能事件ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentSignInSkillAck====>>>" + JSON.stringify(OBackData))
                  that.agentSignInSkillAck(OBackData)
                  break
                // 11 12 调用签出技能响应结果
                case 12:
                  console.log('座席签出技能事件ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentSignOutSkillAck====>>>" + JSON.stringify(OBackData))
                  that.agentSignOutSkillAck(OBackData)
                  break
                // 返回席组的信息
                case 14:
                  console.log('返回席组的信息事件ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentGetGroupAck====>>>" + JSON.stringify(OBackData))
                  // 调用选择组,返回分组用户信息 注：所在组一个个的返回
                  that.AgentGetGroupReqAck(OBackData)
                  break
                //座席技能信息
                case 16:
                  console.log('座席技能信息事件ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentGetSkillAck====>>>" + JSON.stringify(OBackData))
                  // 技能组
                  that.AgentSkillGroupAck(OBackData)
                  break
                // 座席摘机ACK
                case 18:
                  console.log('座席摘机事件ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentAnswerCallAck====>>>" + JSON.stringify(OBackData))
                  // 座席-摘机
                  that.answerCallAck(OBackData)
                  break
                // 座席挂机ACK
                case 20:
                  console.log('座席挂机事件ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentReleaseCallAck====>>>" + JSON.stringify(OBackData))
                  // 座席-挂机
                  that.AgentHangUpAck(OBackData)
                  break
                //座席保持ack
                case 22:
                  console.log('座席保持ack', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentHoldCallAck====>>>" + JSON.stringify(OBackData))
                  that.agentHoldCallAck(OBackData)
                  break
                //呼叫找回Ack
                case 24:
                  //CCS-->Agent 呼叫找回Ack
                  console.log('呼叫找回Ack', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentRetrieveHoldAck====>>>" + JSON.stringify(OBackData))
                  that.agentRetrieveHoldAck(OBackData)
                  break
                //连接一个被保持呼叫与当前正在与座席通话的对方进行联接
                case 26:
                  console.log('连接一个被保持呼叫与当前正在与座席通话的对方进行联接Ack', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentConnectHoldAck====>>>" + JSON.stringify(OBackData))
                  break
                //座席呼座席
                case 28:
                  console.log('座席呼座席Ack', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentCallAgentAck====>>>" + JSON.stringify(OBackData))
                  break
                //外呼ACK
                case 30:
                  console.log('外呼ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentCallOutAck====>>>" + JSON.stringify(OBackData))
                  that.agentCallOutAck(OBackData)
                  break
                //会议呼叫Ack
                case 32:
                  console.log('会议呼叫Ack', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentConfCallAck====>>>" + JSON.stringify(OBackData))
                  break
                //对邀请到会议的响应
                case 34:
                  console.log('邀请到会议Ack', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentInviteToConfAck====>>>" + JSON.stringify(OBackData))
                  break
                //把呼叫转移到IVR
                case 36:
                  console.log('呼叫转移到IVRAck', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentTransferIVRAck====>>>" + JSON.stringify(OBackData))
                  that.AgentTransferIVRAck(OBackData)
                  break
                //呼转外线ACK
                case 38:
                  console.log('呼转外线ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentTransferOutAck====>>>" + JSON.stringify(OBackData))
                  that.agentTransferOutAck(OBackData)
                  break
                //转座席组排队
                case 40:
                  console.log('转座席组排队ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentTransferAgentGroupAck====>>>" + JSON.stringify(OBackData))
                  that.agentTransferAgentGroupAck(OBackData)
                  break
                //将当前通话转移到座席
                case 42:
                  console.log('将当前通话转移到座席ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentTransferAgentAck====>>>" + JSON.stringify(OBackData))
                  that.transferAgentAck(OBackData)
                  break
                //抢接来话
                case 44:
                  console.log('抢接来话ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentSnatchCallAck====>>>" + JSON.stringify(OBackData))
                  that.snatchCallAck(OBackData)
                  break
                //踢出会议ACK
                case 46:
                  console.log('踢出会议ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentKickOutAck====>>>" + JSON.stringify(OBackData))
                  break
                //开始静音
                case 48:
                  console.log('开始静音ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentBeginMuteAck====>>>" + JSON.stringify(OBackData))
                  // 开始静音
                  that.AgentBeginMuteAck(OBackData)
                  break
                //停止静音
                case 50:
                  console.log('停止静音ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentEndMuteAck====>>>" + JSON.stringify(OBackData))
                  // 结束静音
                  that.AgentEndMuteAck(OBackData)
                  break
                //示忙 ACK
                case 52:
                  console.log('示忙ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentSetBusyAck====>>>" + JSON.stringify(OBackData))
                  that.AgentSetBusyAck(OBackData)
                  break
                // 示闲
                case 54:
                  console.log('示闲ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentSetIdleAck====>>>" + JSON.stringify(OBackData))
                  that.AgentSetIdleAck(OBackData)
                  break
                //请求休息
                case 56:
                  console.log('请求休息ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentRequestRestAck====>>>" + JSON.stringify(OBackData))
                  // 申请小休
                  that.agentRequestRestAck(OBackData)
                  break
                //请求文书处理ACK
                case 58:
                  console.log('请求文书处理ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentRequestTextProcAck====>>>" + JSON.stringify(OBackData))
                  that.AgentRequestTextProcAck(OBackData)
                  break
                //设置呼叫数据ACK
                case 60:
                  console.log('设置呼叫数据ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentSetCallDataAck====>>>" + JSON.stringify(OBackData))
                  break
                //查询呼叫数据ACK
                case 62:
                  console.log('查询呼叫数据ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentQueryCallDataAck====>>>" + JSON.stringify(OBackData))
                  break
                //播放语音ACK
                case 64:
                  console.log('播放语音ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentPlayFileAck====>>>" + JSON.stringify(OBackData))
                  break
                //座席收号ACK
                case 66:
                  console.log('座席收号ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentReceiveDTMFAck====>>>" + JSON.stringify(OBackData))
                  that.AgentReceiveDTMFAck(OBackData)
                  break
                //强插Ack
                case 68:
                  console.log('强插Ack', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentForceInsertAck====>>>" + JSON.stringify(OBackData))
                  that.backForceMessage(OBackData)
                  break
                //监听Ack
                case 70:
                  console.log('监听Ack', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentMonitorAck====>>>" + JSON.stringify(OBackData))
                  AgentMonitorAck_data = OBackData
                  that.AgentMonitorAck(OBackData)
                  break
                //强拆ACK
                case 72:
                  console.log('强拆ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentForceReleaseAck====>>>" + JSON.stringify(OBackData))
                  that.backForceMessage(OBackData)
                  break
                //拦截ACK
                case 74:
                  console.log('拦截ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentInterceptAck====>>>" + JSON.stringify(OBackData))
                  that.backForceMessage(OBackData)
                  break
                //{{ add by zhao 2017-06-22
                //强制注销请求
                case 75:
                  console.log('强制注销请求', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentForceLogOut====>>>" + JSON.stringify(OBackData))
                  that.onAgentForceLogOut(OBackData)
                  break
                //}}
                //强制注销ACK
                case 76:
                  console.log('强制注销ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentForceLogOutAck====>>>" + JSON.stringify(OBackData))
                  that.backForceMessage(OBackData)
                  break
                //强制示闲ACK
                case 78:
                  console.log('强制示闲ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentForceIdleAck====>>>" + JSON.stringify(OBackData))
                  that.backForceMessage(OBackData)
                  break
                //强制示忙ACK
                case 80:
                  console.log('强制示忙ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentForceBusyAck====>>>" + JSON.stringify(OBackData))
                  that.backForceMessage(OBackData)
                  break
                //强制阻塞ACK
                case 82:
                  console.log('强制阻塞ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentForceBlockAck====>>>" + JSON.stringify(OBackData))
                  that.backForceMessage(OBackData)
                  break
                //座席同意小休ACK
                case 84:
                  console.log('座席同意小休ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentApproveRestAck====>>>" + JSON.stringify(OBackData))
                  // 同意小休
                  that.AgentApproveRestAck_data = OBackData
                  that.agentApproveRestAck(OBackData)
                  break
                //班长收请求休息
                case 92:
                  console.log('班长收请求休息', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnRequestRestEvt====>>>" + JSON.stringify(OBackData))
                  that.agentOnRequestRestEvt(OBackData)
                  break
                //班长同意后座席开始小休
                case 93:
                  console.log('班长同意后座席开始小休', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnStartRestEvt====>>>" + JSON.stringify(OBackData))
                  that.agentOnStartRest(OBackData)
                  break
                //座席小休请求未被同意
                case 94:
                  console.log('座席小休请求未被同意', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnNotAgreeRestEvt====>>>" + JSON.stringify(OBackData))
                  that.agentOnNotAgreeRest(OBackData)
                  break
                // 座席结束小休时间已到
                case 95:
                  console.log('座席结束小休时间已到', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnRestTimeOverEvt====>>>" + JSON.stringify(OBackData))
                  that.agentOnRestTimeOver(OBackData)
                  break
                //停止座席文本处理态事件
                case 96:
                  console.log('停止座席文本处理态事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnStopTextProcessEvt====>>>" + JSON.stringify(OBackData))
                  that.AgentOnStopTextProcessEvt(OBackData)
                  break
                // 呼叫结束事件
                case 97:
                  console.log('呼叫结束事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnCallEndEvt====>>>" + JSON.stringify(OBackData))
                  that.agentOnCallEndEvt(OBackData)
                  break
                case 98:
                  // 来电事件
                  console.log('呼叫来电事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnCallOfferedEvt====>>>" + JSON.stringify(OBackData))
                  that.agentOnCallOfferedEvt(OBackData)
                  break
                //邀请会议完成事件
                case 99:
                  console.log('邀请会议完成事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnInviteToConfEvt====>>>" + JSON.stringify(OBackData))
                  break
                //被踢出会议事件
                case 100:
                  console.log('被踢出会议事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnKickedOutEvt====>>>" + JSON.stringify(OBackData))
                  break
                // 邀请加入三方或多方会议时对方应答事件
                case 101:
                  console.log('呼出被摘机事件，呼叫出被或坐席摘机后系统将会收到这个消息', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnAnsweredEvt====>>>" + JSON.stringify(OBackData))
                  that.agentOnAnsweredEvt(OBackData)
                  break
                // 从呼叫转出返回事件
                case 102:
                  console.log('从呼叫转出返回事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnReturnFromIVREvt====>>>" + JSON.stringify(OBackData))
                  break
                //收号完成事件
                case 103:
                  console.log('收号完成事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnReceiveDTMFCompleted====>>>" + JSON.stringify(OBackData))
                  that.OnReceiveDTMFCompleted(OBackData)
                  break
                //放音完成事件
                case 104:
                  console.log('放音完成事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnPlayFileCompleted====>>>" + JSON.stringify(OBackData))
                  break
                //自动摘机成功-----没有用，暂保留
                case 105:
                  console.log('自动摘机成功事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AutoAnswerCallSuccessEvt====>>>" + JSON.stringify(OBackData))
                  break
                //座席上线通知
                case 106:
                  console.log('座席上线通知事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnLineEvt====>>>" + JSON.stringify(OBackData))
                  that.AgentOnLineEvt(OBackData)
                  break
                //座席下线通知(如被另一座席强制注销)
                case 107:
                  console.log('座席下线通知事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOffLineEvt====>>>" + JSON.stringify(OBackData))
                  that.AgentOffLineEvt(OBackData)
                  break
                //座席被保持
                case 108:
                  console.log('座席被保持事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnHeldEvt====>>>" + JSON.stringify(OBackData))
                  that.agentOnHeldEvt(OBackData)
                  break
                //座席被找回
                case 109:
                  console.log('座席被找回事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnRetrievedEvt====>>>" + JSON.stringify(OBackData))
                  break
                //座席被连接
                case 110:
                  console.log('座席被连接', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnConnectHoldEvt====>>>" + JSON.stringify(OBackData))
                  break
                //座席被拦截
                case 111:
                  console.log('座席被拦截', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnInterceptedEvt====>>>" + JSON.stringify(OBackData))
                  break
                //座席被连接，说明座席电话已经被呼通
                case 112:
                  // 座席建立联接事件
                  console.log('座席被连接，说明座席电话已经被呼通', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentOnConnectedEvt====>>>" + JSON.stringify(OBackData))
                  that.agentOnConnectedEvt(OBackData)
                  break
                //被转出去的呼叫又转回来了
                case 113:
                  ////CCS -->Agent 被转出去的呼叫又转回来了
                  console.log('被转出去的呼叫又转回来了', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentCallComeBackEvt====>>>" + JSON.stringify(OBackData))
                  that.agentCallComeBackEvt(OBackData)
                  break
                //座席操作超时
                case 114:
                  console.log('座席操作超时', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentActionTimeOutEvt====>>>" + JSON.stringify(OBackData))
                  break
                //请求单座席状态
                case 116:
                  console.log('请求单座席状态', OBackData)
                  agentServer.$Log.send('Info', "AGP RequestAgentStatusAck====>>>" + JSON.stringify(OBackData))
                  that.RequestAgentStatusAck(OBackData)
                  break
                //座席状态更新事件,主要用于发到系统监控
                case 119:
                  console.log('座席状态更新事件', OBackData)
                  // agentServer.$Log.send('Info', "AGP AgentStatusUpdateEvt====>>>" + JSON.stringify(OBackData))
                  break
                //座席自己状态更新事件主要用于发到座席自己
                case 122:
                  console.log('座席自己状态更新事件', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentSelfStatusUpdateEvt====>>>" + JSON.stringify(OBackData))
                  that.AgentSelfStatusUpdateEvt(OBackData)
                  break
                //通知座席事件
                case 125:
                  console.log('通知座席事件', OBackData)
                  // agentServer.$Log.send('Info', "AGP AgentStatusUpdateEvt====>>>" + JSON.stringify(OBackData))
                  break
                //座席请求外呼
                case 132:
                  console.log('座席请求外呼', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentRequestCallOutEvt====>>>" + JSON.stringify(OBackData))
                  // that.g_AgentRequestCallOutEvt(OBackData)
                  break
                // 服务器状态通知事件
                case 140:
                  console.log('代理服务器通讯组件的状态', OBackData)
                  agentServer.$Log.send('Info', "AGP ComComponentStatusEvt====>>>" + JSON.stringify(OBackData))
                  that.componetOnLineEvt(OBackData)
                  break
                // 座席心跳回显事件
                case 141:
                  //that.onHeartbeatEcho(OBackData);
                  break
                //请求座席的状态ACK
                case 145:
                  console.log('请求座席的状态ACK', OBackData)
                  agentServer.$Log.send('Info', "AGP AgentRequestAgentStatusAck====>>>" + JSON.stringify(OBackData))
                  that.FunRequestAgentStatusListBak(OBackData)
                  break
                default:
                  console.log('OBackData.Base.Function=' + OBackData.Base.Function, OBackData)
                  agentServer.$Log.send('Warn', "Haven't process CONST_CCS_CT_AgentProxy_12 MSG " + agentFunc.showAgentMessageName(OBackData.Base.Function) + ":" + JSON.stringify(OBackData))
                  break
              }
              break
            case 11:
              //自动呼叫分配服务器

              agentServer.$Log.send('Info', "Back [CONST_CCS_CT_ACD_11," + acdFunc.showACDMessageName(OBackData.Base.Function) + "]==>(" + JSON.stringify(OBackData) + ")")
              switch (OBackData.Base.Function) {
                case 21:
                  that.acdCallQueueUpdateEvt(OBackData)   // 座席排队
                  break
                case 31:
                  that.ACDManualAllocCallAck(OBackData)
                  break
                default:
                  agentServer.$Log.send('Warn', "Haven't process CONST_CCS_CT_ACD_11 MSG " + acdFunc.showACDMessageName(OBackData.Base.Function) + ":" + JSON.stringify(OBackData))
                  break
              }
              break
            case 9:
              //自动外呼服务器
              agentServer.$Log.send('Info', "Back [CONST_CCS_CT_OBS_9," + obsFunc.showOBSMessageName(OBackData.Base.Function) + "]==>(" + JSON.stringify(OBackData) + ")")
              switch (OBackData.Base.Function) {
                default:
                  agentServer.$Log.send('Warn', "Haven't process CONST_CCS_CT_OBS_9 MSG " + obsFunc.showOBSMessageName(OBackData.Base.Function) + ":" + JSON.stringify(OBackData))
                  break
              }
              break
            case 14:
              //面向应用的呼叫接口
              agentServer.$Log.send('Info', "Back [CONST_CCS_CT_Call_14," + callFunc.showCallMessageName(OBackData.Base.Function) + "]==>(" + JSON.stringify(OBackData) + ")")
              switch (OBackData.Base.Function) {
                case 3:
                  that.CallAnswerCallAck(OBackData)
                  break
                case 37:
                  that.PlayFileAck(OBackData)
                  break
                case 67:
                  that.CallBindAgentAck(OBackData)
                  break
                case 56:
                  that.OnReceiveDTMFCompleted(OBackData)
                  break
                default:
                  agentServer.$Log.send('Warn', "Haven't process CONST_CCS_CT_Call_14 MSG " + callFunc.showCallMessageName(OBackData.Base.Function) + ":" + JSON.stringify(OBackData))
                  break
              }
              break
            default:
              agentServer.$Log.send('Info', "Back [" + defComp.showComponentName(OBackData.Base.ComponentType) + "," + OBackData.Base.Function + "]==>(" + JSON.stringify(OBackData) + ")")
              agentServer.$Log.send('Warn', "Haven't process " + defComp.showComponentName(OBackData.Base.ComponentType) + " MSG " + callFunc.showCallMessageName(OBackData.Base.Function) + ":" + JSON.stringify(OBackData))
              break
          }
        }
      }
    },
    OnReceiveDTMFCompleted (OBackData) {
      if (OBackData.DTMFCount < 3) {
        this.addMessages("OnReceiveDTMFCompleted不处理座席外呼")
        return
      }
      try {
        this.m_SipPhoneDialOutNO = OBackData.DTMF
        let iEndPos = this.m_SipPhoneDialOutNO.indexOf("#")
        if (iEndPos >= 0)
          this.m_SipPhoneDialOutNO = this.m_SipPhoneDialOutNO.substr(0, iEndPos)

        this.AgentCallOut(this.g_CallerNO4AgentCallout, this.m_SipPhoneDialOutNO, null, null, 3, 0, "")
      } catch (e) {
        this.rightPrint("OnReceiveDTMFCompleted处理异常")
      }

    },

    /**
     * 座席外呼
     * @param strCallerNO 主叫号码
     * @param strCalledNO 被叫号码
     * @param iGroupID 外呼时选择的座席组
     * @param iSkillID 外呼时选择的技能组
     * @param iConfSize 会议大小(默认为0,如果>3就是会议)
     * @param iBusiType 业务类型,用于更新录音表记录,用数值为代表
     * @param strPrivateInfo 外呼时座席传递的私有数据
     */
    AgentCallOut: function (strCallerNO, strCalledNO, iGroupID, iSkillID, iConfSize, iBusiType, strPrivateInfo) {
      let base = new Base(12, 29)
      let iAgentCalltype = 4 // 0=转座席，1=IVR，2=座席组，3=通用应用，4=外线
      let iFlowID = 0
      let szCallerNO = ""
      let agentCallOutObj = null
      let strAgentCallOut = null

      if ((strCallerNO == undefined) || (strCallerNO == null)) strCallerNO = ""
      if ((strCalledNO == undefined) || (strCalledNO == null)) strCalledNO = ""
      if ((iGroupID == undefined) || (iGroupID == null) || Number.isNaN(Number.parseInt(iGroupID))) iGroupID = -1
      if ((iSkillID == undefined) || (iSkillID == null) || Number.isNaN(Number.parseInt(iSkillID))) iSkillID = -1
      if ((iConfSize == undefined) || (iConfSize == null) || Number.isNaN(Number.parseInt(iConfSize))) iConfSize = 3
      if ((iBusiType == undefined) || (iBusiType == null) || Number.isNaN(Number.parseInt(iBusiType))) iBusiType = 0
      if ((strPrivateInfo == undefined) || (strPrivateInfo == null)) strPrivateInfo = ""

      strCallerNO = strCallerNO.trim()
      strCalledNO = strCalledNO.trim()
      iGroupID = Number.parseInt(iGroupID)
      iSkillID = Number.parseInt(iSkillID)
      iConfSize = Number.parseInt(iConfSize)
      iBusiType = Number.parseInt(iBusiType)
      strPrivateInfo = strPrivateInfo.trim()

      agentCallOutObj = new StAgentCallOut_t(base, this.g_AgentID, strCalledNO, iAgentCalltype, iGroupID, iSkillID, iFlowID, strPrivateInfo, strCallerNO, iBusiType, iConfSize)
      strAgentCallOut = JSON.stringify(agentCallOutObj)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + strAgentCallOut + ")")

      try {
        this.g_Socket4AGP.send(strAgentCallOut)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },
    PlayFileAck: function (dataAck) {
      if (dataAck.wResult == 0) {
        this.CallBindAgent()
      } else {
        this.rightPrint("请求PlayFile异常,返回结果码:" + dataAck.wResult)
      }
    },
    CallBindAgent: function () {
      let base = new Base(14, 66)
      let callBindAgentObject = new CallBindAgentObject(base, this.g_AgentID, this.g_CallID, 0)
      let callBindAgentObjectJSON = JSON.stringify(callBindAgentObject)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + callFunc.showCallMessageName(base.Function) + "]==>(" + callBindAgentObjectJSON + ")")

      try {
        this.g_Socket4AGP.send(callBindAgentObjectJSON)
        agentServer.saveData("面向应用的绑定座席请求参数：" + callBindAgentObjectJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!")
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },
    CallAnswerCallAck: function (dataAck) {
      console.log('CallAnswerCallAck dataAck', dataAck)
      if (dataAck.Result == 0) {
        this.PlayFile("telagent.wav")
      } else {
        this.rightPrint("请求CallAnswerCall异常,返回结果码:" + dataAck.Result)
      }
    },

    CallBindAgentAck: function (dataAck) {
      //$Send.CallOut(m_SipPhoneDialOutNO,"");
      if (dataAck.Result == 0) {
        this.AgentReceiveDTMF()
      } else {
        this.rightPrint("请求CallBindAgent异常,返回结果码:" + dataAck.Result)
      }
    },

    AgentReceiveDTMF: function () {
      let base = new Base(12, 65)
      let MODE = 4
      let MaxDigits = 15
      let TerminatingCharacter = 35
      let FirstDigitInform = 0
      let PromptingToneContinueFlag = 0
      let FirstDigitTimer = 120
      let InterDigitermer = 4
      let CompletionTimer = 300

      let beginReceiveDTMFObject = new BeginReceiveDTMFObject(base, this.g_AgentID, this.g_CallID, MODE, MaxDigits, TerminatingCharacter, FirstDigitInform, PromptingToneContinueFlag, FirstDigitTimer, InterDigitermer, CompletionTimer)

      let beginReceiveDTMFObjectJSON = JSON.stringify(beginReceiveDTMFObject)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + beginReceiveDTMFObjectJSON + ")")

      try {
        this.g_Socket4AGP.send(beginReceiveDTMFObjectJSON)
        agentServer.saveData("座席开始收码请求参数：" + beginReceiveDTMFObjectJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!")
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },

    PlayFile: function (fileName) {
      let base = new Base(14, 36)
      let PrivateData = 0


      let MODE = 4
      let MaxDigits = 15
      let TerminatingCharacter = 35
      let FirstDigitInform = 0
      let PromptingToneContinueFlag = 0
      let FirstDigitTimer = 120
      let InterDigitermer = 60
      let CompletionTimer = 360
      let playFileObject = new PlayFileObject(base, PrivateData, g_CallID, fileName, MODE, MaxDigits, TerminatingCharacter, FirstDigitInform, PromptingToneContinueFlag, FirstDigitTimer, InterDigitermer, CompletionTimer)
      let playFileObjectJSON = JSON.stringify(playFileObject)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + callFunc.showCallMessageName(base.Function) + "]==>(" + playFileObjectJSON + ")")

      try {
        this.g_Socket4AGP.send(playFileObjectJSON)
        agentServer.saveData("面向应用的播放文件请求参数：" + playFileObjectJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!")
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },
    socketOpen: function (event) {
      console.log('onopen', event)
      console.log('g_agp_reconnect_interval', this.g_agp_reconnect_interval)
      let that = this
      if (this.g_agp_reconnect_interval) {
        // 联接成功时不再重复尝试重联
        clearInterval(this.g_agp_reconnect_interval)
        this.g_agp_reconnect_interval = null
        this.g_agp_is_reconnecting = false
        this.g_agp_reconnect_counter = 0
      }

      this.g_IsConnectAGP = true
      try {
        this.g_Socket4AGP.send("connect")
      } catch (e) {
        console.log('g_Socket4AGP send error', e)
        agentServer.$Log.send('Error', "send first connect message failed!" + agentServer.$Log.message(e))
      }

      // 连接成功启动心跳包
      if (this.heartbeatIntervel) {
        clearInterval(this.heartbeatIntervel)
        this.heartbeatIntervel = null
      }
      that.heartbeat()
      this.heartbeatIntervel = setInterval(() => {
        that.heartbeat()
      }, 5000)

      if (this.bIsReconnect) {
        this.rightPrint("重连成功...")
        agentServer.$Log.send('Info', "WebSocket 重连成功")
      } else {
        agentServer.$Log.send('Info', "WebSocket 连接成功")
      }

      if (this.needReload) {
        this.autoSign()
      }

      console.log('g_AgentID', this.g_AgentID)
      if ((typeof (this.g_AgentID) == "number") && (this.g_AgentID != -1)) {
        // 获取当前座席的状态
        // $Send.GetSingleAgentStatus(g_AgentID);
      }

      this.linkStateLabel = '<span style="color:green;">连接中</span>'

      //20190731  ws连接成功后停止重连计时器
      /* if (g_agp_reconnect_interval != null) {
           window.clearInterval(g_agp_reconnect_interval);
           g_agp_reconnect_interval = null;
       }*/
    },

    /**
     * 响应CCS函数 座席注销返回
     */
    AgentLoggedOffAck: function (dataAck) {
      if (dataAck.Result == 0) {
        if (this.HoldCallList.length != 0) {
          // 清空保持列表的数据
          this.HoldCallList = []
        }

        this.changeToolBarAgentHold4RetriveCallButtonNumber()

        // 座席退出登录的方式,0=无效(初始化值),1=注销,2=退出,3=关闭浏览器窗口
        let iStatus = Number.parseInt(this.agentLoggedOffType)
        if (iStatus == 1) {
          console.info("注销成功")
          this.g_Socket4AGP.close()
          Cookies.remove(this.constMap.cookie_IsLoad)
        } else if (iStatus == 2) {
          console.info("退出成功")
          this.g_Socket4AGP.close()
          Cookies.remove(this.constMap.cookie_IsLoad)
        } else if (iStatus == 3) {
          console.info("onbeforeunload事件调用成功")
          this.g_Socket4AGP.close()
          Cookies.remove(this.constMap.cookie_IsLoad)
        } else {
          console.error("异常关闭")
          this.g_Socket4AGP.close()
          Cookies.remove(this.constMap.cookie_IsLoad)
        }
      } else {
        this.onNetResult(dataAck.Result)
        console.error("退出异常，强制关闭")
        this.g_Socket4AGP.close()
        this.$Message.error('请重新登录')
        // $("#linkStateLabel").text("请重新登录")
        // this.linkStateLabel = '请重新登录'
        this.linkStateLabel = '<span style="color:red;">请重新登录</span>'
        // $("#linkStateLabel").attr({ "style": "color:red;" })

        Cookies.remove(this.constMap.cookie_IsLoad)
        //window.location.href = "index.html";
      }
    },


    /**
     * 初始化技能组接收CCS反馈回来的参数
     */
    AgentSkillGroupAck: function (dataAck) {
      let iSkillInfoCount = dataAck.SkillInfoCount
      //封装座席成员
      if (iSkillInfoCount != -1) {
        let skillList = dataAck.SkillInfoList.slice(0, iSkillInfoCount)
        for (let i = 0; i < skillList.length; i++) {
          let skillObject = skillList[i]
          let skillGroup = new SkillGroup(skillObject.SkillID, skillObject.SkillName, skillObject.AutoCheckIn)
          let ext = this.g_SkillArray4Agent.filter(item => item.SkillID == skillObject.SkillID)
          if (ext && ext.length > 0) {
            ext[0] = skillGroup
          } else {
            this.g_SkillArray4Agent.push(skillGroup)
          }
          console.log('g_SkillArray4Agent', this.g_SkillArray4Agent)
        }
      }
    },


    /**
     * 请求座席返回函数
     */
    AgentGetGroupReqAck: function (dataAck) {
      console.log('潜入座席 AgentGetGroupReqAck', dataAck)
      let agentIDListCount = dataAck.AgentInfoCount
      let AgentGroupID = dataAck.AgentGroupID

      let agentGroup = null

      if (agentIDListCount < 0) {

        if (this.g_bReloadAgentGroupArray4Agent) {
          this.g_AgentGroupArray4Agent.length = 0
          this.g_bReloadAgentGroupArray4Agent = false
        }

        if (g_AgentGroupArray4Agent.length > 0) {
          console.log("座席组数组已加载")
        } else {
          console.log("座席组数组加载错误")
        }
        return
      }

      if (this.g_bReloadAgentGroupArray4Agent) {
        this.g_AgentGroupArray4Agent.length = 0
        this.g_bReloadAgentGroupArray4Agent = false
      } else {
        (this.g_AgentGroupArray4Agent || []).forEach(item => {
          if (item.AgentGroupID == AgentGroupID) {
            agentGroup = this.g_AgentGroupArray4Agent[i]
            agentGroup.GroupName = dataAck.GroupName
            agentGroup.AutoCheckIn = dataAck.AutoCheckIn
          }
        })
      }

      if (agentGroup == null) {
        //构建座席组对象
        agentGroup = new AgentGroup(AgentGroupID, dataAck.GroupName, dataAck.AutoCheckIn)
        this.g_AgentGroupArray4Agent.push(agentGroup)
        console.log('g_AgentGroupArray4Agent', this.g_AgentGroupArray4Agent)
      }

      //封装座席成员
      if (agentIDListCount != -1) {
        let agentIDList = dataAck.AgentInfoList.slice(0, agentIDListCount)
        for (let i = 0; i < agentIDList.length; i++) {
          let agentObject = agentIDList[i]
          let status = agentObject.Status[1]
          agentObject.agentStauts = status
          agentObject.agentId = agentObject.AgentID
          agentObject.workNo = agentObject.AgentWorkNo
          agentObject.agentName = agentObject.AgentName
          agentGroup.AddAgent(agentObject)
        }
        if (typeof (agentGroupsDialog) != "undefined") {
          agentGroupsDialog.window.showList(agentGroup.AgentInfoList)
        }
      }

      if (this.g_AgentGroupArray4Agent.length > 0) {
        console.log("座席组数组正在加载")
      }
    },


    /**
     * 座席 下线通知
     */
    AgentOffLineEvt: function (jsonData) {
      if (jsonData.AgentID == this.g_AgentID) {
        Cookies.remove(this.constMap.cookie_IsLoad)
        //window.location.href = "index.html";
        // msg = "座席已被注销"
        // this.rightPrint("座席已被注销!")
        this.linkStateLabel = ''
        console.log('changeStatus offline')
        //onclosed的时候会触发
        // this.$emit('changeStatus', false)
        this.currentStatus = 'offline'
        this.addMessages("下线成功！")
        this.$emit('signLog', { appId: this.options?.appId, seatId: this.loginInfo?.operatorId, logType: 'signOut', logStatus: true, remark: '退出成功' })
      }
    },


    //示忙-ack
    AgentSetBusyAck: function (dataAck) {

      if (dataAck.Status != 0) {
        this.onNetResult(dataAck.Status)
        console.log("示忙-ack:" + dataAck.Status)
        if (dataAck.Status == 1084) {
          //座席应用无效, 注销座席
          this.logOut()
        }
      } else {
        this.addMessages("示忙成功！")
        this.currentStatus = 'busy'
      }
    },

    // 示闲-ack
    AgentSetIdleAck: function (dataAck) {
      if (dataAck.Status != 0) {
        console.log("示闲-ack:" + dataAck.Status)
        this.onNetResult(dataAck.Status)
      } else {
        this.currentStatus = 'idle'
        this.addMessages("示闲成功！")
        this.rightPrint("座席已经示闲")
      }
    },

    // 申请小休
    agentRequestRestAck: function (jsonData) {
      console.log('申请小休 jsonData', jsonData)
    },

    //班长收到小休
    agentOnRequestRestEvt: function (jsonData) {
      console.log('班长收到小休', jsonData)
    },

    //小休返回函数
    agentApproveRestAck: function (jsonData) {
      if (jsonData.Status != 0) {
        this.onNetResult(jsonData.Status)
      } else {
        // let msg = "申请成功"
        // this.rightPrint(msg)
        this.addMessages("申请小休成功！")
        let that = this

        this.remainingTime = this.agentSetForm.restTime
        this.remainingTimer = setInterval(() => {
          that.remainingTime--
          if (that.remainingTime == 0) {
            clearInterval(that.remainingTimer)
            that.remainingTimer = null
          }
        }, 1000)
        this.backPanel()
      }
    },

    //同意小休申请
    agentOnStartRest: function (jsonData) {
      this.img_time_state = "/jxyAgent/images/icon/Enable/agentSet.png"
      this.agentStatusLabel = "小休中"
      let o_AgentOnStartRestAck = jsonData
      let msg = "****** 您的小休申请已批准   ****** <br />小休时长: " + this.agentSetForm.restTime
      this.rightPrint(msg)
      this.currentStatus = "sleep"
    },


    // 不同意小休
    agentOnNotAgreeRest: function (jsonData) {
      console.log('不同意小休 agentOnNotAgreeRest', jsonData)
      let msg = '您的小休申请未被同意'
      this.addMessages("小休申请被驳回！")
      this.rightPrint(msg)
    },

    //	小休结束
    agentOnRestTimeOver: function (jsonData) {
      if (this.g_AgentID == jsonData.AgentID) {
        this.rightPrint("您的小休已结束，座席已自动上线。")
      }
    },

    // 文书处理-ack
    AgentRequestTextProcAck: function (dataAck) {
      if (dataAck.Status != 0) {
        console.log("文书处理-ack:" + dataAck.Status)
        this.onNetResult(dataAck.Status)
      } else {
        this.addMessages("开始文书处理！")
        // this.rightPrint("开始文书处理")
      }
    },

    // 强制-CCS返回的消息确认
    backForceMessage: function (jsonData) {

      if (jsonData.Status != 0) {
        this.onNetResult(jsonData.Status)
      }
    },


    /**
     * 坐席被注销事件
     */
    onAgentForceLogOut: function (dataEvt) {
      if ((dataEvt) && (dataEvt.AgentID) && (dataEvt.AgentID == this.g_AgentID)) {

        this.HoldCallList = []	// 清空保持列表的数据
        this.changeToolBarAgentHold4RetriveCallButtonNumber()
        agentServer.$Log.send('Info', "坐席被强制注销")
        // $Log.info("坐席被强制注销");
        this.g_Socket4AGP.close()
        Cookies.remove(this.constMap.cookie_IsLoad)
        // window.location.href = "index.html";
      }
    },
    // 坐席请求外呼
    g_AgentRequestCallOutEvt: function (jsonData) {
      this.CallOut(jsonData.Called)
    },

    /**
     * 外呼-外线
     * 
     * @param phoneNo
     *            号码
     */
    CallOut: function (phoneNo, privateInfo) {
      let base = new Base(12, 29)
      let agentCalltype = 4// TCT_Agent:0,TCT_IVR:1//IVR;TCT_AgentGroup:2//坐席组TCT_App:3//通用应用;TCT_External:4
      // //外线
      let groupID = this.g_AgentGroupArray4Agent[0]
      let skillID = this.g_SkillArray4Agent[0]
      let iGroupID = -1
      let iSkillID = -1
      let flowID = 0
      let szCallerNO = ""
      let stAgentCallOut_t = null
      let stAgentCallOutJSON = null
      if (this.g_CallerNO4AgentCallout)
        szCallerNO = this.g_CallerNO4AgentCallout
      if ((groupID != null) && (groupID["AgentGroupID"]))
        iGroupID = groupID["AgentGroupID"]
      if ((skillID != null) && (skillID["SkillID"]))
        iSkillID = skillID["SkillID"]
      if ((privateInfo == undefined) || (privateInfo == null))
        privateInfo = ""
      privateInfo = String(privateInfo)
      stAgentCallOut_t = new StAgentCallOut_t(base, this.g_AgentID, phoneNo, agentCalltype, iGroupID, iSkillID, flowID, privateInfo, szCallerNO, 0, 3)
      stAgentCallOutJSON = JSON.stringify(stAgentCallOut_t)
      try {
        this.g_Socket4AGP.send(stAgentCallOutJSON)
      } catch (e) {
        // parent.msgAlert("error", '网络发生异常，话务系统已断开，请刷新页面')
        this.$Message.warning('网络发生异常，话务系统已断开，请刷新页面')
      }
    },
    //签入所有座席组返回确认消息
    agentSignInGroupAck: function (dataAck) {
      console.log('签入座席组返回确认消息', this.g_RequestSignInAgentGroupIDs, dataAck)
      // let len = 0
      // this.g_AgentGroupArray4Agent.forEach(item => {
      //   if (item.AutoCheckIn == 1) {
      //     ++len
      //   }
      // })


      //	if(len == g_AgentGroupArray4Agent.length && flag2 == 1){
      //		$.ligerDialog.warn('当前座席已经签入所有座席组.');
      //	}

      if (dataAck.Result == 0) {
        this.groupWithSkills.forEach(item => {
          if (this.g_RequestSignInAgentGroupIDs.indexOf(item.groupId) >= 0)
            item.checkIn = true   // 标记签入状态,0=未签入,1=已签入
        })

        this.reloadSkills()
        this.g_AgentGroup4AgentFlag = 1
        // flag2 = 1
      } else {
        this.onNetResult(dataAck.Result)
      }
    },

    //签出座席组返回确认消息
    agentSignOutGroupAck: function (dataAck) {
      console.log('签出座席组返回确认消息', this.g_RequestSignOutAgentGroupIDs, dataAck)
      // let len = 0;
      // (this.g_AgentGroupArray4Agent || []).forEach(item => {
      //   if (item.AutoCheckIn == 1) {
      //     ++len
      //   }
      // })


      // if (len == 0 && this.flag1 == 1) {
      //   this.$Message.warning('当前座席已经签出所有座席组！')
      // }
      if (dataAck.Result == 0) {
        this.groupWithSkills.forEach(item => {
          if (this.g_RequestSignOutAgentGroupIDs.indexOf(item.groupId) >= 0)
            item.checkIn = false   // 标记签入状态,0=未签入,1=已签入
        })
        this.reloadSkills()
        this.flag1 = 1
      } else {
        this.onNetResult(dataAck.Result)
      }
    },

    // 签入所有技能组返回确认消息
    agentSignInSkillAck: function (dataAck) {
      console.log('签入技能组返回确认消息', this.g_RequestSignInSkillIDs, dataAck)
      if (dataAck.Result == 0) {
        let that = this
        this.groupWithSkills.forEach(item => {

          (item.skills || []).forEach(sk => {
            console.log(sk.skillId, that.g_RequestSignInSkillIDs.indexOf(sk.skillId) >= 0)
            if (that.g_RequestSignInSkillIDs.indexOf(sk.skillId) >= 0) {
              sk.checkIn = true   // 标记签入状态,0=未签入,1=已签入
              console.log(sk)
            }
          })
        })
        this.reloadSkills()
      } else {
        this.onNetResult(dataAck.Result)
      }
    },


    //签出座席技能返回确认消息
    agentSignOutSkillAck: function (dataAck) {
      console.log('签出座席技能返回确认消息', this.g_RequestSignOutSkillIDs, dataAck)
      if (dataAck.Result == 0) {
        let that = this
        // this.groupWithSkills.forEach(item => {
        // 	item.skills.forEach(sk => {
        // 		if(sk.skillId )
        // 	})
        // })
        this.groupWithSkills.forEach(item => {
          (item.skills || []).forEach(sk => {
            if (that.g_RequestSignOutSkillIDs.indexOf(sk.skillId) >= 0) {
              sk.checkIn = false   // 标记签入状态,0=未签入,1=已签入
            }
          })

          // if (this.g_RequestSignOutSkillIDs.contains(item.SkillID))
          //   item.AutoCheckIn = 0   // 标记签入状态,0=未签入,1=已签入
        })
        this.reloadSkills()
      } else {
        this.onNetResult(dataAck.Result)
      }
    },


    //呼转座席组返回事件
    agentTransferAgentGroupAck: function (dataAck) {
      if (dataAck.Status != 0) {
        this.onNetResult(dataAck.Status)
        return
      }
    },

    // 呼转座席返回事件
    transferAgentAck: function (dataAck) {
      if (dataAck.Status != 0) {
        this.onNetResult(dataAck.Status)
        return
      }
    },

    // 呼转IVR返回事件
    AgentTransferIVRAck: function (dataAck) {
      if (dataAck.Status != 0) {
        this.onNetResult(dataAck.Status)
        return
      }
    },


    /**
     * 呼叫座席
     * @param strCallerNO 主叫号码
     * @param strTargetWorkNO 被叫座席工号
     * @param iTargetGroupID 被叫座席的座席组
     * @param iTargetSkillID 被叫座席的技能组
     * @param iConfSize 会议大小(默认为0,如果>3就是会议)
     * @param iBusiType 业务类型,用于更新录音表记录,用数值为代表
     * @param strPrivateInfo 呼叫目标座席传递的私有数据
     */
    AgentCallAgent: function (strCallerNO, strTargetWorkNO, iTargetGroupID, iTargetSkillID, iConfSize, iBusiType, strPrivateInfo) {
      let base = new Base(12, 29)
      let iAgentCalltype = 0 // 0=座席，1=IVR，2=座席组，3=通用应用，4=外线
      let objAgentCallOut = null
      let strAgentCallOut = ""
      let iFlowID = 0

      if ((strCallerNO == undefined) || (strCallerNO == null)) strCallerNO = ""
      if ((strTargetWorkNO == undefined) || (strTargetWorkNO == null)) strTargetWorkNO = ""
      if ((iTargetGroupID == undefined) || (iTargetGroupID == null) || Number.isNaN(Number.parseInt(iTargetGroupID))) iTargetGroupID = -1
      if ((iTargetSkillID == undefined) || (iTargetSkillID == null) || Number.isNaN(Number.parseInt(iTargetSkillID))) iTargetSkillID = -1
      if ((iConfSize == undefined) || (iConfSize == null) || Number.isNaN(Number.parseInt(iConfSize))) iConfSize = 3
      if ((iBusiType == undefined) || (iBusiType == null) || Number.isNaN(Number.parseInt(iBusiType))) iBusiType = 0
      if ((strPrivateInfo == undefined) || (strPrivateInfo == null)) strPrivateInfo = ""

      strCallerNO = strCallerNO.trim()
      strTargetWorkNO = strTargetWorkNO.trim()
      iTargetGroupID = Number.parseInt(iTargetGroupID)
      iTargetSkillID = Number.parseInt(iTargetSkillID)
      iConfSize = Number.parseInt(iConfSize)
      iBusiType = Number.parseInt(iBusiType)
      strPrivateInfo = strPrivateInfo.trim()

      objAgentCallOut = new StAgentCallOut_t(base, this.g_AgentID, strTargetWorkNO, iAgentCalltype, iTargetGroupID, iTargetSkillID, iFlowID, strPrivateInfo, strCallerNO, iBusiType, iConfSize)
      strAgentCallOut = JSON.stringify(objAgentCallOut)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + strAgentCallOut + ")")

      try {
        this.g_Socket4AGP.send(strAgentCallOut)
      } catch (e) {
        $Log.error("send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },


    //摘机返回事件
    answerCallAck: function (dataAck) {
      if ((dataAck.Status != 0) && (dataAck.Status != 1105) && (dataAck.Status != 1078) && (dataAck.Status != 1035)) {
        this.onNetResult(dataAck.Status)
        return
      }
      this.$emit('changePanel', true)
    },

    // 挂机返回事件
    AgentHangUpAck: function (dataAck) {
      this.g_ConferenceCaller = "0"
      this.g_ConferenceArray = []
      if (dataAck.Status != 0) {
        this.isRing = false
        this.onNetResult(dataAck.Status)
        return
      }
    },

    // 座席保持Ack
    agentHoldCallAck: function (dataAck) {
      if (dataAck.Status != 0) {
        // 保持失败,关闭提示窗口，显示错误原因
        this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.Unknown()
        this.LastInviteAgent(null)


        this.onNetResult(dataAck.Status)
        return
      }

      this.changeToolBarAgentHold4RetriveCallButtonNumber()
      //	$("#img_keepOrContinue").attr("src", "images/icon/Enable/continue.png");
      //	$('#keepOrContinueLabel').text("恢复");

      //	if(TransferAgent==true){
      //		$Send.AgentCallAgent(
      //				top.TransferAgentPrivateInfo.Caller
      //				,top.TransferAgentData.WorkNO
      //				,top.TransferAgentData.AgentGroupID
      //				,top.TransferAgentData.AgentSkillID
      //				,g_CONST_DefaultCallOutConfSize
      //				,g_CONST_DefaultCallOutBusiType
      //				,"");
      //		top.TransferAgent=false;
      //		top.TransferAgentData=null;
      //		top.TransferAgentPrivateInfo=null;
      //	}

    },


    //文书处理停止-ack
    AgentOnStopTextProcessEvt: function (dataEvt) {
      if (dataEvt.IsAuto == 1) {
        if (this.m_Timer4TextProcess) {
          clearTimeout(this.m_Timer4TextProcess)
          this.m_Timer4TextProcess = null
        }
        // $Send.AgentSetIdle()

        let base = new Base(12, 53)
        let stAgentSetIdle_t = new StAgentSetIdle_t(base, this.g_AgentID)
        let jsStAgentSetIdle_t = JSON.stringify(stAgentSetIdle_t)
        agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + jsStAgentSetIdle_t + ")")

        try {
          this.g_Socket4AGP.send(jsStAgentSetIdle_t)
        } catch (e) {
          agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
          // $.ligerDialog.warn(网络发生异常，请再试一次')
          this.$Message.warning('网络发生异常，请再试一次')
        }
      }
    },
    //面向应用的应答呼叫
    callAnswerCall: function () {
      // let base = new Base(14, 2)
      // // let base = new Base(12, 17)
      // let callAnswerCall_t = new StCallAnswerCall_t(base, this.g_CallID, 0)
      // let callAnswerCall_t_tJSON = JSON.stringify(callAnswerCall_t)
      // agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + callFunc.showCallMessageName(base.Function) + "]==>(" + callAnswerCall_t_tJSON + ")")
      // try {
      //   this.g_Socket4AGP.send(callAnswerCall_t_tJSON)
      // } catch (e) {
      //   agentServer.$Log.send('Error', "send message to agp failed!")
      //   this.$Message.warning('网络发生异常，请再试一次')
      // }
      this.AgentAnswerCall()
    },

    /**
     * 坐席-摘机
     */
    AgentAnswerCall: function () {
      let base = new Base(12, 17)
      let agentAnswerCall_t = new StAgentAnswerCall_t(base, this.g_AgentID, this.g_CallID, this.g_CallIDType)
      let agentAnswerCall_tJSON = JSON.stringify(agentAnswerCall_t)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + agentAnswerCall_tJSON + ")")
      try {
        this.g_Socket4AGP.send(agentAnswerCall_tJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!")
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },
    //呼叫来电事件
    agentOnCallOfferedEvt: function (dataEvt) {
      console.log('呼叫来电事件 agentOnCallOfferedEvt', dataEvt)

      // 呼入
      // 			{
      //     "AgCallPID": "1769650431655000008",
      //     "AgentGroupID": 3,
      //     "AgentID": 12815,
      //     "Base": {
      //         "ComponentType": 12,
      //         "Function": 98
      //     },
      //     "BaseCallPID": "1769650431655000025",
      //     "CallData": "",
      //     "CallID": 656,
      //     "CallIDType": 1,
      //     "CallOfferedType": 1,
      //     "CallSN": "1769650431655000053",
      //     "Called": "38258423",
      //     "Caller": "13758202092",
      //     "ConSN": "1769650431655000051",
      //     "JsonPrivateInfo": "{\"ExtContactsIP\":[\"183.128.188.44\"]}\n",
      //     "PrivateInfo": "",
      //     "SkillID": 3,
      //     "TotalQueueWaitNum": 0,
      //     "VDNName": "上海法烙",
      //     "PopupType": 1
      // }

      //呼出
      // {
      //     "AgCallPID": "1769650431655000009",
      //     "AgentGroupID": 3,
      //     "AgentID": 12815,
      //     "Base": {
      //         "ComponentType": 12,
      //         "Function": 98
      //     },
      //     "BaseCallPID": "1769650431655000030",
      //     "CallData": "",
      //     "CallID": 843,
      //     "CallIDType": 1,
      //     "CallOfferedType": 10,
      //     "CallSN": "1769650431655000058",
      //     "Called": "015868125734",
      //     "Caller": "38258423",
      //     "ConSN": "1769650431655000053",
      //     "JsonPrivateInfo": "{\"ExtContactsIP\":[\"183.128.188.44\"]}\n",
      //     "PrivateInfo": "",
      //     "SkillID": 3,
      //     "TotalQueueWaitNum": 0,
      //     "VDNName": "上海法烙",
      //     "PopupType": 3
      // }
      let that = this
      this.g_CallID = Number.parseInt(dataEvt.CallID)
      this.g_CallIDType = Number.parseInt(dataEvt.CallIDType)


      this.g_BaseCallPID = dataEvt.BaseCallPID


      this.g_AgCallPID = dataEvt.AgCallPID
      this.g_CallOfferedType = dataEvt.CallOfferedType
      let strCaller = dataEvt.Caller
      let strCalled = dataEvt.Called
      let skillID = dataEvt.SkillID

      let iCallOfferedType = Number.parseInt(dataEvt.CallOfferedType)


      let iBaseCallPID = dataEvt.BaseCallPID
      let iAgCallPID = dataEvt.AgCallPID
      let iPopupType = 1
      let objAgentCallDataItem = null
      let iCallData = dataEvt.CallData
      let keyNum = iCallData

      let iJsonPrivateInfo = ""
      if (dataEvt.JsonPrivateInfo != "" && dataEvt.JsonPrivateInfo != null) {
        try {
          iJsonPrivateInfo = JSON.parse(dataEvt.JsonPrivateInfo)
          iJsonPrivateInfo.ExtContactsIP
          console.dir(iJsonPrivateInfo.ExtContactsIP)
          autoCallIPs = iJsonPrivateInfo.ExtContactsIP
        } catch (e) {

        }
      } else {
        autoCallIPs = ""
      }

      // 振铃状态
      this.$emit('changeRecordStatus', 'ringing')
      //ChangePhoneToolbarIconsByAction(CONST_PhoneToolbarAction_ringing);


      // if((this.g_CallIDType == 0)&&(iCallOfferedType == 12)) // 直接通过IP话机在进行外拨呼出
      // {
      // 	this.callAnswerCall();
      // 	return;
      // }

      objAgentCallDataItem = this.GetAgentCallListItemEx(iBaseCallPID, iAgCallPID)
      if (objAgentCallDataItem != null) {
        iPopupType = objAgentCallDataItem.PopupType
      } else if (iCallOfferedType == 10) {
        // 外呼
        iPopupType = 3         		// 呼叫外线
      }


      let needUpload = false
      this.currentSerialNum = this.g_BaseCallPID
      let pushData = {
        serviceCode: that.options.serviceCode,
        appId: that.options.appId,
        serialNum: that.g_BaseCallPID,
        startTime: that.$moment().format('YYYY-MM-DD HH:mm:ss'),
        caller: strCaller,
        callee: strCalled,
        agentIds: [that.loginInfo.operatorId],
        serviceAccounts: [that.$store.getters['userInfo/account']],
      }

      //iCallOfferedType
      // ACT_Unknown			= 0,	//未知，一般不用
      // 	ACT_Inbound			= 1,	//呼叫入线
      // 	ACT_Agent			= 2,	//座席呼叫座席
      // 	ACT_TreeParyt		= 3,	//三方通话
      // 	ACT_Conf			= 4,	//会议呼叫
      // 	ACT_Monitor			= 5,	//监听
      // 	ACT_Insert			= 6,	//强插
      // 	ACT_Transfer		= 7,	//呼转
      // 	ACT_Snatch			= 8,	//抢接
      // 	ACT_Intercept		= 9,	//拦截
      // 	ACT_CallOut			= 10,	//外呼
      // 	ACT_OBS_CALLOUT		= 11,	//OBS外呼
      // 	ACT_TelAgent_CALLOUT= 12 	//话机外呼，针对sip话机摘机外呼
      let callType = ''
      // 咨询人号码
      switch (iCallOfferedType) {
        case 1:
          // ACT_Inbound			= 1,	//呼叫入线
          callType = 'INBOUND'
          needUpload = true
          this.$emit('onCallComing', {
            caller: strCaller,
            jobId: that.g_BaseCallPID
          })
          this.nearlyCall('INBOUND', strCaller)
          this.districtArea(strCaller)
          break
        case 10:
          // ACT_CallOut			= 10,	//外呼
          needUpload = true
          callType = 'OUTBOUND'
          this.nearlyCall('OUTBOUND', strCalled)
          this.districtArea(strCalled)
          break
        case 4:
          // ACT_Conf			= 4,	//会议呼叫
          needUpload = false
          callType = 'CONFERENCE'
          break
        case 2:
          // ACT_Agent			= 2,	//座席呼叫座席
          needUpload = false
          callType = 'INTERNAL'
          break
        case 6:
          // ACT_Insert			= 6,	//强插
          needUpload = false
          callType = 'INTERCEPT'
          break
      }
      this.currentCallType = callType || 'INBOUND'

      if (needUpload) {
        pushData.callType = callType
        this.recordInfo = {
          callType: callType,
          caller: strCaller,
          callee: strCalled,
          serialNum: this.g_BaseCallPID,
          //弹屏类型:1=来电弹屏,2=自动外呼(OBS)弹屏,3=呼叫外线,4=未接电话回访,5=座席流失电话回访,6=ACD流失电话回访,7=留言电话回访,8=座席直接呼另一座席
          iPopupType: iPopupType
        }
        that.$emit('pushCallRecord', pushData)
      }



      if ((this.g_CallIDType == 0 && [12].indexOf(iCallOfferedType) >= 0)) {
        // 座席SIP话机外呼
        this.callAnswerCall()
        return
      }

      if (iCallOfferedType != 10) {
        this.AgentAnswerCall()
      }


      // // 是否自动应答(0=需手动在座席软件上应答后话机才响铃,1=自动应答话机响铃)
      // console.log('AutoAnswer', this.AgentLoginAck_data.AutoAnswer)
      // if (this.AgentLoginAck_data.AutoAnswer == 1 && iCallOfferedType != 1) {
      //   //呼叫入线 座席-摘机
      //   this.callAnswerCall()
      // }

      try {
        if (this.g_ConferenceCaller == "0") {
          //$AgentProxyHanlde.onCallOfferedEvtHandle(strCalled,strCaller,iPopupType,iBaseCallPID,iAgCallPID);
        } else if (this.g_ConferenceCaller == "1") {
          // 会议
          let nowDate = new Date()
          let strDateTime = nowDate.getFullYear() + "-" + (nowDate.getMonth() + 1) + "-" + nowDate.getDate()
            + " " + (nowDate.getHours() < 10 ? ("0" + nowDate.getHours()) : nowDate.getHours())
            + ":" + (nowDate.getMinutes() < 10 ? ("0" + nowDate.getMinutes()) : nowDate.getMinutes())
            + ":" + (nowDate.getSeconds() < 10 ? ("0" + nowDate.getSeconds()) : nowDate.getSeconds())

          let obj = {
            calledNo: strCalled,
            joinTime: strDateTime,
          }
          this.g_ConferenceArray.push(obj)
        }
      } catch (e) {
        console.error("来去电弹屏异常! err:" + e)
      }

      dataEvt.PopupType = iPopupType
      // 插入本呼叫到座席来电去电呼叫列表中（记录存在时则进行更新）
      this.insertToAgentCallGrid(dataEvt, 1)
      //{{ add by zhao 2020-12-28 : 修复：外线A呼入，座席B接听，座席B转移呼叫至座席C接听，座席C接听后点击保持后直接提示请求中，
      // let iCallOfferedType = Number.parseInt(dataEvt.CallOfferedType)

      // CallOfferedType:7 -- 呼转
      //其它座席转呼过来的
      if (iCallOfferedType == 7 && dataEvt.CallIDType == 0 && dataEvt.CallID != g_AgentID) {
        try {
          // 取出原始的外线参数
          let jsonPrivateInfoFromCallerAgent = JSON.parse(dataEvt.PrivateInfo)
          this.g_CallID = Number.parseInt(jsonPrivateInfoFromCallerAgent.CallID)
          this.g_CallIDType = Number.parseInt(jsonPrivateInfoFromCallerAgent.CallIDType)
          this.g_BaseCallPID = jsonPrivateInfoFromCallerAgent.BaseCallPID
          this.g_AgCallPID = jsonPrivateInfoFromCallerAgent.AgCallPID
          this.insertToAgentCallGrid(jsonPrivateInfoFromCallerAgent, 1)
          console.log("PrivateInfoFromCallerAgent: " + jsonPrivateInfoFromCallerAgent + ".")
        } catch (e) {
          console.error("分析其它座席转呼过来的数据时,异常! " + agentServer.$Log.message(e))
          agentServer.$Log.send('Error', "分析其它座席转呼过来的数据时,异常! " + agentServer.$Log.message(e))
        }
      }
      //}}
    },

    /**
    * 获取座席当前呼入呼出数据项
    * return 返回值：成功返回AgentCallDataItem对象，失败返回null.
    */
    GetAgentCallListItemEx: function (iBaseCallPID, iAgCallPID) {
      if ((this.AgentCallList == null) || (this.AgentCallList.length < 1))
        return null
      if ((iBaseCallPID == undefined) || (iBaseCallPID == null))
        return null
      if ((iAgCallPID == undefined) || (iAgCallPID == null))
        return null
      for (let i = 0; i < this.AgentCallList.length; i++) {
        let item = this.AgentCallList[i]
        if ((item.BaseCallPID == iBaseCallPID) && (item.AgCallPID == iAgCallPID)) {
          //return item;
          return this.deepCopy(item)
        }
      }
      return null
    },


    AgentMonitorAck: function (dataAck) {
      if (dataAck.Status != 0) {
        this.onNetResult(dataAck.Status)
      }
      else {
        this.rightPrint("坐席监听中")
      }
    },

    /**
    * 获取座席尚未被保持的最新呼入呼出数据项
    * return 返回值：成功返回AgentCallDataItem对象，失败返回null.
    */
    GetRecentAgentCallItem4Hold: function () {
      if ((this.AgentCallList == null) || (this.AgentCallList.length < 1))
        return null
      for (let i = this.AgentCallList.length - 1; i >= 0; i--) {
        let item4Agent = this.AgentCallList[i]
        if (this.GetAgentHoldCallListItemEx(item4Agent.BaseCallPID, item4Agent.AgCallPID) == null) // 没在保持队列时
        {
          //return item4Agent;
          return this.deepCopy(item4Agent)
        }
      }
      return null
    },


    /**
    * 获取座席指定的保持呼入呼出数据项
    * return 返回值：成功返回AgentCallDataItem对象，失败返回null.
    */
    GetAgentHoldCallListItem: function (iCallIDType, iCallID) {
      console.dir(this.HoldCallList)
      console.dir(iCallIDType)
      console.dir(iCallID)

      if ((this.HoldCallList == null) || (this.HoldCallList.length < 1))
        return null
      if ((iCallIDType == undefined) || (iCallIDType == null))
        return null
      if ((iCallID == undefined) || (iCallID == null))
        return null
      for (let i = 0; i < this.HoldCallList.length; i++) {
        let item = this.HoldCallList[i]

        if ((item.CallIDType == iCallIDType) && (item.CallID == iCallID)) {
          //return item;
          return this.deepCopy(item)
        }
      }
      return null
    },
    /**
    * 获取座席指定的保持呼入呼出数据项
    * return 返回值：成功返回AgentCallDataItem对象，失败返回null.
    */
    GetAgentHoldCallListItemEx: function (iBaseCallPID, iAgCallPID) {
      if ((this.HoldCallList == null) || (this.HoldCallList.length < 1))
        return null
      if ((iBaseCallPID == undefined) || (iBaseCallPID == null))
        return null
      if ((iAgCallPID == undefined) || (iAgCallPID == null))
        return null
      for (let i = 0; i < this.HoldCallList.length; i++) {
        let item = this.HoldCallList[i]
        if ((item.BaseCallPID == iBaseCallPID) && (item.AgCallPID == iAgCallPID)) {
          //return item;
          return this.deepCopy(item)
        }
      }
      return null
    },

    /**
    * 生成座席未接电话数据数据的Key值
    */
    generateAgentMissedCallDataKey: function () {
      let date = new Date()
      let strYear = String(date.getFullYear())
      let strMonth = String(date.getMonth() + 1)
      let strDay = String(date.getDate())
      let strHour = date.getHours() < 10 ? "0" + String(date.getHours()) : String(date.getHours())
      let strMinute = date.getMinutes() < 10 ? "0" + String(date.getMinutes()) : String(date.getMinutes())
      let strSecond = date.getSeconds() < 10 ? "0" + String(date.getSeconds()) : String(date.getSeconds())

      this.m_AgentMissedCallNumber++
      if (this.m_AgentMissedCallNumber > 1000)
        this.m_AgentMissedCallNumber = 0
      this.m_LastAgentMissedCallDataKey = strYear + strMonth + strDay + strHour + strMinute + strSecond + this.m_AgentMissedCallNumber.toString()

      return this.deepCopy(this.m_LastAgentMissedCallDataKey)
    },

    //座席外呼返回事件
    agentCallOutAck: function (dataAck) {
      console.log('座席外呼返回事件 agentCallOutAck', dataAck)
      // 			{
      //     "AgCallPID": "1769650431655000010",
      //     "AgentID": 12815,
      //     "AgentLogicNO": 395,
      //     "Base": {
      //         "ComponentType": 12,
      //         "Function": 30
      //     },
      //     "BaseCallPID": "1769650431655000031",
      //     "CallID": 395,
      //     "CallIDType": 1,
      //     "Cause": 0,
      //     "PrivateInfo": "",
      //     "Status": 0
      // }
      this.g_CallID = dataAck.CallID
      //0,		//座席 
      this.g_CallIDType = dataAck.CallIDType
      this.g_BaseCallPID = dataAck.BaseCallPID
      this.g_AgCallPID = dataAck.AgCallPID
      this.g_CallOfferedType = 10
      let iCallOfferedType = 0	// 本次呼叫类型
      let strCaller = this.g_CallerNO4AgentCallout
      let strCalled = this.phoneNO.trim()
      let strPrivateInfo = dataAck.PrivateInfo
      let iPopupType = 3 // 弹屏类型:1=来电弹屏,2=自动外呼(OBS)弹屏,3=呼叫外线,4=未接电话回访,5=座席流失电话回访,6=ACD流失电话回访,7=留言电话回访,8=座席直接呼另一座席
      let iBaseCallPID = dataAck.BaseCallPID
      let iAgCallPID = dataAck.AgCallPID

      if (dataAck.Status != 0) {
        // 呼叫失败
        this.setLastAgentMissedCallDataKey("") // 失败时，需要清空下最后一次呼出的座席流失主键，否则收到CONS_EU_AG_AgentOnCallEndEvt_97消息会误删除未接电话记录
        this.onNetResult(dataAck.Status)

        let objLastHoldCallItem = this.LastHoldCallItem()
        switch (this.g_AgentHoldCallBeforOperation) {
          case g_CONST_AgentHoldCallBeforOperation.InviteAgent():     // 将收到的事件：呼叫失败=CONS_EU_AG_AgentOnCallEndEvt_97,呼叫成功=CONS_EU_AG_AgentOnAnsweredEvt_101
          case g_CONST_AgentHoldCallBeforOperation.InviteCallOut():   // 将收到的事件：呼叫失败=CONS_EU_AG_AgentOnCallEndEvt_97,呼叫成功=CONS_EU_AG_AgentOnAnsweredEvt_101
            if (objLastHoldCallItem != null) {


              let iCallIDType = objLastHoldCallItem.CallIDType

              let iCallID = objLastHoldCallItem.CallID
              if (objLastHoldCallItem.PopupType == 8) // 座席直接呼叫另一座席时
              {
                iCallIDType = 0
                iCallID = -1
              }
              // $Send.AgentRetrieveHoldCall(iAgentID, iCallIDType, iCallID)
              this.agentRetrieveHoldCall(this.g_AgentID, iCallIDType, iCallID)
            }
            break
          default:
            break
        }
        this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.Unknown()
        //}}

        return
      }

      if ((strCaller == null) || strCaller == undefined || (strCaller.trim() == ""))
        strCaller = this.g_ExtensionTelNO // 当座席未配置外呼主叫时，则把座席当前登陆的分机号作为外呼主叫在弹屏上显示

      if (this.constPop.ConstPopupTypeAgentNoAnswerCallOut == strPrivateInfo)
        iPopupType = 4
      else if (this.constPop.ConstPopupTypeAgentMissedCallOut == strPrivateInfo)
        iPopupType = 5
      else if (this.constPop.ConstPopupTypeAcdMissedCallOut == strPrivateInfo)
        iPopupType = 6
      else if (this.constPop.ConstPopupTypeLeaveWordMissedCallOut == strPrivateInfo)
        iPopupType = 7
      else if (this.constPop.ConstPopupTypeAgentDefaultCallOutAgent == strPrivateInfo) {
        iPopupType = 8
        iCallOfferedType = 2
        // CCS发来的消息中，CallIDType=1，CallID=通道号，但由于本次是座席呼另一座席，则在本函数中，需将CallIDType设置成0，而具体的CallID则应在 agentOnCallOfferedEvt 中进一步获取并更新
        dataAck.CallIDType = 0
        this.g_CallIDType = 0
      } else if (this.constPop.ConstPopupTypeInviteCallOut == strPrivateInfo)
        iPopupType = 9
      else
        iPopupType = 3

      // 处理去电(部分数据需在来电则在 agentOnCallOfferedEvt 中处理)
      let dataEvt = {
        CallOfferedType: 0, // 呼叫类型
        CallIDType: this.g_CallIDType,//当前呼叫的呼叫ID类型,EU_CallIDType 0-座席 1-外线
        CallID: this.g_CallID,
        BaseCallPID: iBaseCallPID,
        AgCallPID: iAgCallPID,
        Caller: strCaller, // 主叫号码
        Called: strCalled, // 被叫号码
        CallData: "", // 呼叫数据
        AgentGroupID: -1, //座席组ID
        SkillID: -1,  //技能ID
        PopupType: iPopupType //// 本次来电弹屏类型
      }

      // 插入本呼叫到座席来电去电呼叫列表中（记录存在时则进行更新）
      this.insertToAgentCallGrid(dataEvt, 2)
    },

    setLastAgentMissedCallDataKey: function (val) {
      this.m_LastAgentMissedCallDataKey = val
    },

    //呼叫结束事件
    agentOnCallEndEvt: function (dataEvt) {
      if (dataEvt.AgentID != this.g_AgentID) // 不是当前座席接收到的事件
        return
      console.log('呼叫结束事件 dataEvt', dataEvt)
      console.log('呼叫结束事件 dataEvt', this.AgentMissedCallGridData)
      this.muteState = false
      this.$emit('onCallRelease', { appId: this.options.appId, serialNum: this.currentSerialNum })
      // 1、处理被自动保持的列表记录
      if ((dataEvt.CallID == this.g_AgentID) && (dataEvt.CallIDType == 0)) {
        // 当前座席结束通话时
        this.HoldCallList = []
        this.changeToolBarAgentHold4RetriveCallButtonNumber()
      } else {
        //{{ add by zhao 2017-05-27
        this.RemoveHoldCallList(dataEvt.CallIDType, dataEvt.CallID)
        this.changeToolBarAgentHold4RetriveCallButtonNumber()
        //}}

        let objLastHoldCallItem = this.LastHoldCallItem()
        console.log('呼叫结束事件 g_AgentHoldCallBeforOperation', this.g_AgentHoldCallBeforOperation)
        switch (this.g_AgentHoldCallBeforOperation) {
          case g_CONST_AgentHoldCallBeforOperation.InviteAgent():     // 将收到的事件：呼叫失败=CONS_EU_AG_AgentOnCallEndEvt_97,呼叫成功=CONS_EU_AG_AgentOnAnsweredEvt_101
          case g_CONST_AgentHoldCallBeforOperation.InviteCallOut():   // 将收到的事件：呼叫失败=CONS_EU_AG_AgentOnCallEndEvt_97,呼叫成功=CONS_EU_AG_AgentOnAnsweredEvt_101
            if (objLastHoldCallItem != null) {
              //{{ modify by zhao 2017-05-23
              //let iCallIDType = g_CallIDType;
              let iCallIDType = objLastHoldCallItem.CallIDType
              //}}
              let iCallID = objLastHoldCallItem.CallID
              if (objLastHoldCallItem.PopupType == 8) // 座席直接呼叫另一座席时
              {
                iCallIDType = 0
                iCallID = -1
              }
              // $Send.AgentRetrieveHoldCall(iAgentID, iCallIDType, iCallID)
              this.agentRetrieveHoldCall(this.g_AgentID, iCallIDType, iCallID)
            }
            break
          default:
            break
        }
      }
      this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.Unknown()



      // 2、将座席来电去电通话列表移除记录
      if (dataEvt.CallIDType == 0 && dataEvt.CallID == this.g_AgentID) { // 当前座席结束通话时
        console.log("移除所有通话记录")
        this.AgentCallList = []
        console.log("成功移除所有通话记录。")
      } else {
        console.log("移除指定通话记录，dataEvt.CallIDType=" + dataEvt.CallIDType + ",dataEvt.CallID=" + dataEvt.CallID)
        if (!this.RemoveAgentCallList(dataEvt.CallIDType, dataEvt.CallID)) {
          console.log("成功移除指定通话记录！")
          return
        }
      }

      // 判断通话时长,通话时长为0 表示未接, 把来电事件存储的未接电话 展示否则清除
      if (Number.parseInt(this.timersDuration) > 0) {
        // 产生来电时长 移除未接存储的数据
        this.$delete(this.AgentMissedCallGridData, this.m_LastAgentMissedCallDataKey)
        // $Global.AgentMissedCallGridData.delete(this.getLastAgentMissedCallDataKey())
      }

      // 改变话务工具栏上座席未接电话数量数值
      this.changeToolBarAgentMissedCallButtonNumber()
      this.setLastAgentMissedCallDataKey("")

      this.callRecord = {}
      // 发起置忙处理
      //if((dataEvt.CallIDType != 0)||(dataEvt.CallID == g_AgentID)) // 其他座席结束通话时不进入文书处理
      if ((dataEvt.CallIDType == 0 && dataEvt.CallID == this.g_AgentID) || this.AgentCallList.length == 0) {
        //m_ifAutoBusiness=1;
        this.m_ifAutoBusiness = 0
        this.agentBusinessArrange()
        //$Send.AgentSetBusy();
        // this.ChangePhoneToolbarIconsByAction(CONST_PhoneToolbarAction_callEnd)
        // 挂机清除 倒计时
        if (this.g_Timer4TalkingTime) {
          clearInterval(this.g_Timer4TalkingTime)
          this.g_Timer4TalkingTime = null
        }
        // 清除右边来电数据

        this.txt_duration = "00:00:00"
        this.timersDuration = 0
      }
    },


    /**
     * 设置或获取最后一次邀请加入三方或多方会议的座席数据记录(InviteAgentDataItem)
     * @param item 参数未传入时表示返回最后一次邀请的座席数据,否则表示设置最后一次邀请的座席数据
     */
    LastInviteAgent: function (item) {
      if (arguments.length < 1) {
        //return m_LastInviteAgent
        return this.deepCopy(this.m_LastInviteAgent)
      }
      //m_LastInviteAgent = item;
      //return m_LastInviteAgent
      this.m_LastInviteAgent = this.deepCopy(item)
      return this.deepCopy(this.m_LastInviteAgent)
    },
    /**
   * 设置或获取最后一次保持的电话记录(AgentCallDataItem)
   * @param item 参数未传入时表示返回最后一次保持的数据,否则表示设置最后一次保持的数据
   */
    LastHoldCallItem: function (item) {
      //{{ modify by zhao 2017-09-13
      //    -- 改用深拷贝，防止对象被意外修改
      if (arguments.length < 1) {
        //return m_LastHoldCallItem
        return this.deepCopy(this.m_LastHoldCallItem)
      }
      //m_LastHoldCallItem = item;
      //return m_LastHoldCallItem
      this.m_LastHoldCallItem = this.deepCopy(item)
      return this.deepCopy(this.m_LastHoldCallItem)
      //}}
    },


    /**
    * 获取座席当前呼入呼出数据项
    * return 返回值：成功返回AgentCallDataItem对象，失败返回null.
    */
    GetAgentCallListItem: function (iCallIDType, iCallID) {
      if ((this.AgentCallList == null) || (this.AgentCallList.length < 1))
        return null
      if ((iCallIDType == undefined) || (iCallIDType == null))
        return null
      if ((iCallID == undefined) || (iCallID == null))
        return null
      for (let i = 0; i < this.AgentCallList.length; i++) {
        let item = this.AgentCallList[i]
        //if((item.CallIDType == iCallIDType)||(item.CallID == iCallID))
        if ((item.CallIDType == iCallIDType) && (item.CallID == iCallID)) {
          //return item;
          return this.deepCopy(item)
        }
      }
      return null
    },

    /**
        * 座席当前呼入呼出数据记录中移除指定的记录
        */
    RemoveAgentCallList: function (iCallIDType, iCallID) {
      if ((this.AgentCallList == null) || (this.AgentCallList.length < 1))
        return false
      if ((iCallIDType == undefined) || (iCallIDType == null))
        return false
      if ((iCallID == undefined) || (iCallID == null))
        return false
      for (let i = 0; i < this.AgentCallList.length; i++) {
        let item = this.AgentCallList[i]
        //{{ modify by zhao 2017-05-17
        //if((item.CallIDType == iCallIDType)||(item.CallID == iCallID))
        if (item.CallIDType == iCallIDType && item.CallID == iCallID)
        //}}
        {
          this.AgentCallList.splice(i, 1)
          return true
        }
      }
      return false
    },


    /**
     * 电话保持对列中移除指定的记录
     */
    RemoveHoldCallList: function (iCallIDType, iCallID) {
      if ((this.HoldCallList == null) || (this.HoldCallList.length < 1))
        return
      if ((iCallIDType == undefined) || (iCallIDType == null))
        return
      if ((iCallID == undefined) || (iCallID == null))
        return

      //{{ add by zhao 2017-05-27
      if (this.m_LastHoldCallItem != null && this.m_LastHoldCallItem.CallIDType == iCallIDType && this.m_LastHoldCallItem.CallID == iCallID) {
        this.m_LastHoldCallItem = null
      }
      //}}
      for (let i = 0; i < this.HoldCallList.length; i++) {
        let item = this.HoldCallList[i]
        //{{ modify by zhao 2017-05-17
        //if((item.CallIDType == iCallIDType)||(item.CallID == iCallID))
        if (item.CallIDType == iCallIDType && item.CallID == iCallID)
        //}}
        {
          this.HoldCallList.splice(i, 1)
          return
        }
      }
    },

    //恢复
    agentRetrieveHoldCall: function (iAgentID, iCallIDType, iCallID) {

      let base = new Base(12, 23)
      let agentRetrieveHold = new StAgentRetrieveHold_t(base, iAgentID, iCallID, iCallIDType)
      let agentRetrieveHold_tJSON = JSON.stringify(agentRetrieveHold)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + agentRetrieveHold_tJSON + ")")

      try {
        this.g_Socket4AGP.send(agentRetrieveHold_tJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.error("网络发生异常，请再试一次.")
      }
    },


    //座席被保持事件
    agentOnHeldEvt: function (dataEvt) {
      let iCount = 0
      let strCalledNO = this.phoneNO.trim()
      let iCallType = Number.parseInt(this.callType)

      let strGroupAndSkillVal = this.skillGroupValue
      let arrayGroupAndSkill = []
      let strPrivateInfo = ""
      let iGroupID = -1
      let iSkillID = -1
      let objAgentCallDataItem4Hold = this.GetAgentCallListItem(dataEvt.CallIDType, dataEvt.CallID)

      if (objAgentCallDataItem4Hold == null) {
        switch (this.g_AgentHoldCallBeforOperation) {
          case g_CONST_AgentHoldCallBeforOperation.TransferOutThenRelease():
            console.error("释放并转移失败：收到保持事件，但查找不到相关的呼叫.")
            this.$Message.error("释放并转移失败：收到保持事件，但查找不到相关的呼叫.")
            this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.Unknown()
            break
          case g_CONST_AgentHoldCallBeforOperation.TransferOutThenHold():
            console.error("保持并转移失败：收到保持事件，但查找不到相关的呼叫.")
            this.$Message.error("保持并转移失败：收到保持事件，但查找不到相关的呼叫.")
            this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.Unknown()
            break
          default:
            console.error("收到保持事件，但查找不到相关的呼叫.")
            this.$Message.error("收到保持事件，但查找不到相关的呼叫.")
            break
        }
        return
      }

      //    -- 已经开始保持了，把这个呼叫从“未接”列表中移除
      this.$delete(this.AgentMissedCallGridData, this.m_LastAgentMissedCallDataKey)
      // $Global.AgentMissedCallGridData.delete($Global.getLastAgentMissedCallDataKey())

      objAgentCallDataItem4Hold.CallID = dataEvt.CallID
      objAgentCallDataItem4Hold.CallIDType = dataEvt.CallIDType
      this.g_CallID = this.deepCopy(dataEvt.CallID)
      this.g_CallIDType = this.deepCopy(dataEvt.CallIDType)

      arrayGroupAndSkill = strGroupAndSkillVal.split("|")
      iGroupID = Number.parseInt(arrayGroupAndSkill[0])
      iSkillID = Number.parseInt(arrayGroupAndSkill[1])
      this.LastHoldCallItem(objAgentCallDataItem4Hold)
      switch (this.g_AgentHoldCallBeforOperation) {
        case g_CONST_AgentHoldCallBeforOperation.InviteAgent():   // 将收到的事件：呼叫失败=CONS_EU_AG_AgentOnCallEndEvt_97,呼叫成功=CONS_EU_AG_AgentOnAnsweredEvt_101

          let objInviteAgentDataItem = this.LastInviteAgent()
          if (objInviteAgentDataItem != null) {

            console.log("————>>>邀请座席，保持的通话")
            console.dir(objAgentCallDataItem4Hold)
            console.log("邀请座席，保持的通话<<<————")

            this.HoldCallList.push(this.deepCopy(objAgentCallDataItem4Hold))
            this.changeToolBarAgentHold4RetriveCallButtonNumber()

            // $Send.AgentCallAgent(this.g_CallerNO4AgentCallout, objInviteAgentDataItem.WorkNO, objInviteAgentDataItem.GroupID, objInviteAgentDataItem.SkillID, this.constMap.defaultCallOutConfSize, this.constMap.defaultCallOutBusiType, strPrivateInfo)
            this.AgentCallAgent(this.g_CallerNO4AgentCallout, objInviteAgentDataItem.WorkNO, objInviteAgentDataItem.GroupID, objInviteAgentDataItem.SkillID, this.constMap.defaultCallOutConfSize, this.constMap.defaultCallOutBusiType, strPrivateInfo)
          } else {
            agentServer.$Log.send('Error', "接收到邀请另一座席进行三方或多方通话前保持成功事件,但最后一次邀请的目标座席数据项为null.")
            this.rightPrint("邀请座席失败.")
            this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.Unknown()
          }
          this.LastInviteAgent(null)
          break
        case g_CONST_AgentHoldCallBeforOperation.InviteCallOut(): // 将收到的事件：呼叫失败=CONS_EU_AG_AgentOnCallEndEvt_97,呼叫成功=CONS_EU_AG_AgentOnAnsweredEvt_101
          this.agentCallOut(this.g_CallerNO4AgentCallout, strCalledNO, iGroupID, iSkillID, this.constMap.defaultCallOutConfSize, this.constMap.defaultCallOutBusiType, strPrivateInfo)
          break
        case g_CONST_AgentHoldCallBeforOperation.TransferOutThenRelease():  // 需忽略转移到外线时平台自动发过来的保持事件
          this.HoldCallList.push(this.deepCopy(objAgentCallDataItem4Hold))
          this.changeToolBarAgentHold4RetriveCallButtonNumber()
          this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.Unknown()
          break
        case g_CONST_AgentHoldCallBeforOperation.TransferOutThenHold():    // 需忽略转移到外线时平台自动发过来的保持事件
          this.HoldCallList.push(this.deepCopy(objAgentCallDataItem4Hold))
          this.changeToolBarAgentHold4RetriveCallButtonNumber()
          this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.Unknown()
          break
        default:
          this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.Unknown()
          this.HoldCallList.push(this.deepCopy(objAgentCallDataItem4Hold))
          this.changeToolBarAgentHold4RetriveCallButtonNumber()
          break
      }
    },


    //服务器状态通知事件
    componetOnLineEvt: (jsonData) => {
      let stComponetOnLineEvt = jsonData
      let serverStatus = stComponetOnLineEvt.Status
      if (serverStatus == 3) {
        if (typeof (this.AgentLoginAck_data) != "undefined" && this.AgentLoginAck_data != '') {
          // $.ligerDialog.alert("CCS服务下线")
          this.$Message.warning('CCS服务下线')
          // $.cookie(constMap.cookie_IsLoad, null)
          Cookies.remove(this.constMap.cookie_IsLoad)
          // window.location.href = "index.html"
          return
        } else {
          return
        }
      }
      if (serverStatus == 5) {
        if (typeof (this.AgentLoginAck_data) != "undefined" && this.AgentLoginAck_data != '') {
          // $.ligerDialog.alert("代理服务下线")
          this.$Message.warning('代理服务下线')
          // $.cookie(constMap.cookie_IsLoad, null)
          Cookies.remove(this.constMap.cookie_IsLoad)
          // window.location.href = "index.html"
          return
        } else {
          return
        }
      }
    },


    /**
     * 插入本呼叫到座席来电去电呼叫列表中
     */
    insertToAgentCallGrid: function (dataEvt, insertType) {
      console.log('insertToAgentCallGrid dataEvt', dataEvt)
      console.log('insertToAgentCallGrid insertType', insertType)
      let that = this
      let objAgentCallDataItem = null
      let strCallOfferedTypeName = this.getAgentCallOfferTypeName(dataEvt.CallOfferedType) // 呼叫类型
      let iCallIDType = dataEvt.CallIDType
      let iCallID = dataEvt.CallID
      let iBaseCallPID = dataEvt.BaseCallPID
      let iAgCallPID = dataEvt.AgCallPID
      let strCaller = dataEvt.Caller             // 主叫号码
      let strCalled = dataEvt.Called             // 被叫号码
      let strCallData = dataEvt.CallData         // 呼叫数据
      let iAgentGroupID = dataEvt.AgentGroupID   // 座席组ID
      let iSkillID = dataEvt.SkillID             // 技能ID
      let strAgentGroupName = ""                 // 座席组名
      let strSkillName = ""                      // 技能名
      let strDateTime = ""						// 座席响铃时间
      let iPopupType = dataEvt.PopupType			// 来次弹屏类型
      if (iAgentGroupID >= 4294967295) {
        iAgentGroupID = -1
        dataEvt.AgentGroupID = -1
      }
      if (iSkillID >= 4294967295) {
        iSkillID = -1
        dataEvt.SkillID = -1
      }

      if (insertType == 1) {
        // 来电弹屏时
        agentServer.getSkillNameAndGroupName(iAgentGroupID, iSkillID).then(data => {
          strAgentGroupName = data.agentgroupname
          strSkillName = data.skillname
          strDateTime = data.datenow
          objAgentCallDataItem = that.GetAgentCallListItemEx(iBaseCallPID, iAgCallPID)

          let strPrimaryKey = this.generateAgentMissedCallDataKey()
          if (objAgentCallDataItem == null) {
            objAgentCallDataItem = new AgentCallDataItem(strPrimaryKey, iCallIDType, iCallID, iBaseCallPID, iAgCallPID, strDateTime, strCallOfferedTypeName, strCaller, strCalled, iAgentGroupID, strAgentGroupName, iSkillID, strSkillName, strCallData, iPopupType)

            //过滤不存放未接电话
            if (!that.filterAgent2AgentCall(dataEvt.CallOfferedType)) {
              if (dataEvt.CallOfferedType != 10) {
                this.$set(this.AgentMissedCallGridData, strPrimaryKey, objAgentCallDataItem)
                // $Global.AgentMissedCallGridData.set(strPrimaryKey, objAgentCallDataItem)
              }
            }
            if (dataEvt.CallOfferedType != 10) {
              this.AgentCallList.push(objAgentCallDataItem)
            }
          } else {
            // 重新设置特定参数的值（这些参数在 agentCallOutAck 中并未正确返回获取，因此需要在这里补充正确值）
            objAgentCallDataItem.AgentGroupID = iAgentGroupID
            objAgentCallDataItem.AgentGroupName = strAgentGroupName
            objAgentCallDataItem.SkillID = iSkillID
            objAgentCallDataItem.SkillName = strSkillName
            objAgentCallDataItem.CallData = strCallData
            objAgentCallDataItem.CallOfferedType = strCallOfferedTypeName
            objAgentCallDataItem.DateTime = strDateTime
            if (objAgentCallDataItem.PopupType == 8) {
              // 座席呼另一座席时，需要获取对方座席的ID填写到CallID参数上
              dataEvt.CallOfferedType = 2
              strCallOfferedTypeName = this.getAgentCallOfferTypeName(dataEvt.CallOfferedType) // 呼叫类型
              objAgentCallDataItem.CallOfferedType = strCallOfferedTypeName
              objAgentCallDataItem.Called = strCalled

              // 这里返回的被叫号码其实是被呼座席的工号
              agentServer.getUserByWorkNo(strCalled).then(data => {
                if (typeof (data) == "string")
                  data = eval("(" + data + ")")
                if (data)
                  objAgentCallDataItem.CallID = data.id
                else
                  console.error("来电弹屏事件中根据座席工号[" + strCalled + "]获取座席主键失败.")
              }).catch(err => {
                console.log('getUserByWorkNo err', err)
              })
            }
          }
        }).catch(err => {
          console.log('getSkillNameAndGroupName error', err)
        })

      } else {
        // 外呼ACK时
        objAgentCallDataItem = this.GetAgentCallListItemEx(iBaseCallPID, iAgCallPID)
        console.dir(objAgentCallDataItem)
        if (objAgentCallDataItem == null) {
          let strPrimaryKey = this.generateAgentMissedCallDataKey()
          objAgentCallDataItem = new AgentCallDataItem(strPrimaryKey, iCallIDType, iCallID, iBaseCallPID, iAgCallPID, strDateTime, strCallOfferedTypeName, strCaller, strCalled, iAgentGroupID, strAgentGroupName, iSkillID, strSkillName, strCallData, iPopupType)

          console.log("————>>>外呼ACK时,插入本呼叫到座席来电去电呼叫列表中")
          console.log(strPrimaryKey, objAgentCallDataItem)
          console.log("<<<————外呼ACK时,插入本呼叫到座席来电去电呼叫列表中")

          //过滤座席呼叫座席不存放未接电话数组
          if (!that.filterAgent2AgentCall(dataEvt.CallOfferedType)) {
            //$Global.AgentMissedCallGridData.set(strPrimaryKey,objAgentCallDataItem);
          }

          //$Global.AgentCallList.push(objAgentCallDataItem);
        } else {
          // 重新设置特定参数的值（这些参数在 agentOnCallOfferedEvt 中并未正确返回获取，因此需要在这里补充正确值）
          objAgentCallDataItem.CallID = iCallID
        }



        this.g_CallID = Number.parseInt(dataEvt.CallID)
        this.g_CallIDType = Number.parseInt(dataEvt.CallIDType)


        this.g_BaseCallPID = dataEvt.BaseCallPID

        this.g_AgCallPID = dataEvt.AgCallPID
        this.g_CallOfferedType = dataEvt.CallOfferedType


        // 振铃状态
        this.currentCallType = 'OUTBOUND'

        this.currentSerialNum = this.g_BaseCallPID
        let pushData = {
          callType: 'OUTBOUND',
          serviceCode: that.options.serviceCode,
          appId: that.options.appId,
          serialNum: that.g_BaseCallPID,
          startTime: that.$moment().format('YYYY-MM-DD HH:mm:ss'),
          caller: strCaller,
          callee: strCalled,
          agentIds: [that.loginInfo.operatorId],
          serviceAccounts: [that.$store.getters['userInfo/account']],
        }


        this.recordInfo = {
          callType: 'OUTBOUND',
          caller: strCaller,
          callee: strCalled,
          serialNum: this.g_BaseCallPID,
          //弹屏类型:1=来电弹屏,2=自动外呼(OBS)弹屏,3=呼叫外线,4=未接电话回访,5=座席流失电话回访,6=ACD流失电话回访,7=留言电话回访,8=座席直接呼另一座席
          iPopupType: iPopupType
        }
        that.$emit('pushCallRecord', pushData)
      }
    },


    /**
     * 登录成功，Result为0时
     */
    success_login: function (ObjData) {
      console.log('success_login', ObjData)
      this.$emit('changePanel', true)
      this.currentStatus = 'online'
      this.g_AgentID = ObjData.AgentID
      this.g_WorkNO = ObjData.workNO
      this.g_VDNID = ObjData.VDNID
      this.g_CallerNO4AgentCallout = ""

      //获取当前座席拥有的技能组及签入状态
      let base = new Base(12, 15)
      let stAgentGetSkillReq = new StAgentGetSkillReq_t(base, this.g_AgentID)
      let stAgentGetSkillReqJSON = JSON.stringify(stAgentGetSkillReq)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + stAgentGetSkillReqJSON + ")")

      try {
        this.g_Socket4AGP.send(stAgentGetSkillReqJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.warning({
          content: '网络发生异常，请再试一次',
          duration: 3
        })
      }


      // 获取当前座席拥有的座席组及签入状态
      this.g_bReloadAgentGroupArray4Agent = true

      // $Send.AgentGetGroupReq(-1)
      let base2 = new Base(12, 13)
      let stACDRequestGroup_t = new StACDRequestGroup_t(base2, this.g_AgentID, -1)
      let stACDRequestGroupJSON = JSON.stringify(stACDRequestGroup_t)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + stACDRequestGroupJSON + ")")

      try {
        this.g_Socket4AGP.send(stACDRequestGroupJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.warning('网络发生异常，请再试一次')
      }

      // 写入VDN值常量值
      this.saveLoginInfo2Session(ObjData)

    },


    /**
     * 加载右侧拨号盘下的座席组技能列表(外呼时需要使用)
     */
    loadSelectGroupAndSkill4Call () {
      let that = this

      this.groupWithSkills = []
      this.skillGroups = []
      this.groupsIds = []
      this.skillIds = []

      this.skillGroupValue = ''
      agentServer.initGroupAndSkill({
        "agentId": this.g_AgentID
      }).then(data => {
        console.log('loadSelectGroupAndSkill4Call', data)
        let rows = data?.Rows || []
        rows.forEach(item => {
          let arr = that.groupWithSkills.filter(group => group.groupId == item.groupid)
          let groupItem
          if (arr && arr.lengh > 0) {
            groupItem = arr[0]
          } else {
            groupItem = {
              groupName: item.groupname,
              groupId: item.groupid,
              checkIn: false,
              skills: [{
                groupName: item.groupname,
                groupId: item.groupid,
                skillName: item.skillname,
                skillId: item.skillid,
                checkIn: false,
                value: item.groupid + "|" + item.skillid,
              }]
            }
            that.groupWithSkills.push(groupItem)
          }

          if (this.groupsIds.indexOf(item.groupid) < 0) {
            this.groupsIds.push(item.groupid)
          }

          let skills = groupItem.skills || []
          let arrS = skills.filter(skill => skill.groupId == item.groupid && skill.skillId == item.skillid)
          if (arrS.length == 0) {
            skills.push({
              groupName: item.groupname,
              groupId: item.groupid,
              skillName: item.skillname,
              skillId: item.skillid,
              checkIn: false,
              value: item.groupid + "|" + item.skillid,
            })
          }
          groupItem.skills = skills

          if (this.skillIds.indexOf(item.skillid) < 0) {
            this.skillIds.push(item.skillid)
          }
        })

        // that.$Spin().show()
        if (this.agentSetForm.autoSigin == 1) {
          // 签入 座席组,技能组
          that.signInAllGroup()
          that.signInAllSkill()
        } else {
          // 签出 座席组,技能组
          that.signOutAllGroup()
          that.signOutAllSkill()
        }
        for (let index = 0; index < this.groupWithSkills.length; index++) {
          const element = this.groupWithSkills[index]
          console.log('element', element)
          if (element.skills && element.skills.length > 0) {
            that.skillGroupValue = element.skills[0].value
            break
          }
        }
        console.log('that.skillGroupValue', that.skillGroupValue)
      }).catch(err => {
        console.log('loadSelectGroupAndSkill4Call error', err)
        that.$Message.warning('技能加载异常')
      })
    },


    //获取区域
    districtArea: function (caller) {
      agentServer.areaInfo(caller).then(result => {
        this.callingLocation = result
      }).catch(err => {
        console.log('districtArea error', err)
      })
    },

    /**
     * 签入签出 JS
     */

    // 签入当前座席拥有的所有座席组
    signInAllGroup: function () {
      this.g_RequestSignInAgentGroupIDs = []
      if (this.groupsIds.length > 0) {
        this.groupsIds.forEach(item => {
          this.g_RequestSignInAgentGroupIDs.push(item)
        })
      }
      if (this.g_RequestSignInAgentGroupIDs.length > 0) {
        // $Send.SignInAllGroup(g_RequestSignInAgentGroupIDs, g_RequestSignInAgentGroupIDs.length)
        this.SignInGroup(this.g_RequestSignInAgentGroupIDs)

      } else {
        this.rightPrint("签入座席组失败,当前座席没有可供签入的座席组，请为当前座席分配座席组.")
        console.info("签入座席组失败,当前座席没有可供签入的座席组，请为当前座席分配座席组.")
      }
    },

    SignInGroup: function (groups) {
      let base = new Base(12, 5)
      let agentSignInGroup = new StAgentSignInGroup_t(base, this.g_AgentID, groups, groups.length)
      let agentSignInGroupJSON = JSON.stringify(agentSignInGroup)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + agentSignInGroupJSON + ")")

      console.dir(this.g_RequestSignInAgentGroupIDs)
      console.dir(this.g_AgentGroupArray4Agent)

      try {
        this.g_Socket4AGP.send(agentSignInGroupJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        // $.ligerDialog.warn('网络发生异常，请再试一次')
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },

    // 签出当前座席拥有的所有座席组
    signOutAllGroup: function () {
      this.g_RequestSignOutAgentGroupIDs = []
      if (this.groupsIds.length > 0) {
        this.groupsIds.forEach(item => {
          this.g_RequestSignOutAgentGroupIDs.push(item)
        })
      }
      if (this.g_RequestSignOutAgentGroupIDs.length > 0) {
        // $Send.SignOutAllGroup(g_RequestSignOutAgentGroupIDs, g_RequestSignOutAgentGroupIDs.length)
        this.SignOutGroup(this.g_RequestSignOutAgentGroupIDs)

      } else {

        this.rightPrint("签出座席组失败,当前座席没有可供签出的座席组，请为当前座席分配座席组.")
        console.info("签出座席组失败,当前座席没有可供签出的座席组，请为当前座席分配座席组.")
      }
    },
    SignOutGroup: function (groups) {
      console.log('SignOutGroup groups', groups)
      let that = this
      let base = new Base(12, 7)
      let agentSignOutGroup = new StAgentSignOutGroup_t(base, this.g_AgentID, groups, groups.length)
      let agentSignOutGroupJSON = JSON.stringify(agentSignOutGroup)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + agentSignOutGroupJSON + ")")

      //{{added by zhao at 2018-09-13
      //  -- 签出座席组时，清空座席组相关排队队列
      try {
        if (Object.keys(this.AgentQueueCallGridData).length > 0) {
          for (let i = 0; i < groups.length; i++) {
            let iAgentGroupID = groups[i]

            let keys = Object.keys(this.AgentQueueCallGridData) || []
            keys.forEach(key => {
              let obj = that.AgentQueueCallGridData[key]
              if (obj.AgentGroupID == iAgentGroupID) {
                that.$delete(that.AgentQueueCallGridData, key)
              }
            })


            // this.AgentQueueCallGridData.deleteByGroupID(iAgentGroupID)
            //}}
          }
          // this.changeToolBarAgentACDQueueCallButtonNumber()
        }
      } catch (e) {
        // console.error("签出座席组时，清空座席组相关排队队列异常! ")
        this.$Message.error('签出座席组时，清空座席组相关排队队列异常! ')
      }
      //}}


      try {
        this.g_Socket4AGP.send(agentSignOutGroupJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        // $.ligerDialog.warn('网络发生异常，请再试一次')
        this.$$Message.warning('网络发生异常，请再试一次')
      }
    },
    // 签入当前座席拥有的所有技能组
    signInAllSkill: function () {
      this.g_RequestSignInSkillIDs = []
      if (this.skillIds.length > 0) {
        this.skillIds.forEach(item => {
          this.g_RequestSignInSkillIDs.push(item)
        })
      }
      if (this.g_RequestSignInSkillIDs.length > 0) {

        // $Send.SignInSkill(g_RequestSignInSkillIDs, g_RequestSignInSkillIDs.length)
        this.signInSkill(this.g_RequestSignInSkillIDs)
      } else {

        this.rightPrint("签入技能失败,当前座席没有可供签入的技能，请为当前座席分配技能.")
        console.info("签入技能组失败,当前座席没有可供签入的技能，请为当前座席分配技能.")
      }
    },
    signInSkill: function (skills) {

      let base = new Base(12, 9)
      let agentSignInSkill = new StAgentSignInSkill_t(base, this.g_AgentID, skills, skills.length)
      let agentSignInSkillJSON = JSON.stringify(agentSignInSkill)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + agentSignInSkillJSON + ")")

      try {
        this.g_Socket4AGP.send(agentSignInSkillJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        // $.ligerDialog.warn('网络发生异常，请再试一次')
        this.$Message.error({
          content: '网络发生异常，请再试一次',
          duration: 3
        })
      }
    },

    // 签出当前座席拥有的所有技能组
    signOutAllSkill: function () {
      this.g_RequestSignOutSkillIDs = []

      this.skillIds.forEach(item => {
        this.g_RequestSignOutSkillIDs.push(item)
      })

      if (this.g_RequestSignOutSkillIDs.length > 0) {
        // $Send.SignOutAllSkill(g_RequestSignOutSkillIDs, g_RequestSignOutSkillIDs.length)
        this.signOutSkill(this.g_RequestSignOutSkillIDs)
      } else {
        this.rightPrint("签出技能失败,当前座席没有可供签出的技能，请为当前座席分配技能.")
        console.info("签出技能组失败,当前座席没有可供签出的技能，请为当前座席分配技能.")
      }
    },

    signOutSkill: function (skillIds) {
      let that = this
      let base = new Base(12, 11)
      let agentSignOutSkill = new StAgentSignOutSkill_t(base, this.g_AgentID, skillIds, skillIds.length)
      let agentSignOutSkillJSON = JSON.stringify(agentSignOutSkill)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + agentSignOutSkillJSON + ")")

      //{{added by zhao at 2018-09-13
      //  -- 签出技能时，清空技能相关排队队列
      try {
        if (Object.keys(this.AgentQueueCallGridData).length > 0) {
          let keys = Object.keys(this.AgentQueueCallGridData) || []
          for (let i = 0; i < _SkillGroups.length; i++) {
            let iSkillID = _SkillGroups[i]
            keys.forEach(key => {
              let obj = that.AgentQueueCallGridData[key]
              if (obj.SkillID == iSkillID) {
                that.$delete(that.AgentQueueCallGridData, key)
              }
            })
            // $Global.AgentQueueCallGridData.deleteBySkillID(iSkillID)
            //}}
          }
          // this.changeToolBarAgentACDQueueCallButtonNumber()
        }
      } catch (e) {
        console.error("签出技能时，清空技能相关排队队列异常! ")
        this.$Message.error('签出技能时，清空技能相关排队队列异常!')
      }
      //}}


      try {
        this.g_Socket4AGP.send(agentSignOutSkillJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        // $.ligerDialog.warn('网络发生异常，请再试一次')
        this.$Message.warning({
          content: '网络发生异常，请再试一次!',
          duration: 3
        })
      }

    },


    /**
     * 签入当前座席拥有的技能中指定的某个技能
     */
    signInSkillByID: function (agentSkillId) {
      this.g_RequestSignInSkillIDs = []
      this.g_RequestSignInSkillIDs.push(agentSkillId)
      this.signInSkill([agentSkillId])
      // $Send.SignInSkill(g_RequestSignInSkillIDs, g_RequestSignInSkillIDs.length)
    },

    /**
     * 签出当前座席拥有的技能中指定的某个技能
     */
    signOutSkillByID: function (agentSkillId) {
      this.g_RequestSignOutSkillIDs = []
      this.g_RequestSignOutSkillIDs.push(agentSkillId)
      this.signOutSkill([agentSkillId])
    },


    /**
     * 签入当前座席拥有的座席组中指定的某个座席组
     */
    signInAgentGroupByID: function (agentGroupId) {
      this.g_RequestSignInAgentGroupIDs = []
      this.g_RequestSignInAgentGroupIDs.push(agentGroupId)

      this.SignInGroup([agentGroupId])
      // $Send.SignInAllGroup(g_RequestSignInAgentGroupIDs, g_RequestSignInAgentGroupIDs.length)
    },

    /**
     * 签出当前座席拥有的座席组中指定的某个座席组
     */
    signOutAgentGroupByID: function (agentGroupId) {
      //{{added by zhao at 2018-12-14
      //  -- 签出座席组时，清除相关排队队列
      let that = this
      try {
        if (Object.keys(this.AgentQueueCallGridData).length > 0) {

          let keys = Object.keys(this.AgentQueueCallGridData) || []
          keys.forEach(key => {
            let obj = that.AgentQueueCallGridData[key]
            if (obj.AgentGroupID == agentGroupId) {
              that.$delete(that.AgentQueueCallGridData, key)
            }
          })
        }
        // if ($Global.AgentQueueCallGridData.length > 0) {
        //   let n = $Global.AgentQueueCallGridData.deleteByGroupID(agentGroupId)
        //   if (n > 0) {
        //     this.changeToolBarAgentACDQueueCallButtonNumber()
        //   }
        // }
      } catch (e) {
        agentServer.$Log.send('Error', "签出座席组(" + agentGroupId + ")时，清除相关排队异常! " + agentServer.$Log.message(e))
        console.error("签出座席组(" + agentGroupId + ")时，清除相关排队异常! " + e)
      }
      //}}
      this.g_RequestSignOutAgentGroupIDs = []
      this.g_RequestSignOutAgentGroupIDs.push(agentGroupId)
      this.SignOutGroup([agentGroupId])
      // $Send.SignOutAllGroup(g_RequestSignOutAgentGroupIDs, g_RequestSignOutAgentGroupIDs.length)
    },


    // 右边展示来电信息-时长
    rightShowCallInfoDuration: function () {
      let that = this
      this.g_Timer4TalkingTime = setInterval(() => {
        that.timersDurationFun()
      }, 1000)// 通话时长
    },


    // 定时器
    timersDurationFun: function () {
      this.timersDuration = Number.parseInt(this.timersDuration) + 1
      this.txt_duration = this.getSecondToTimeString(this.timersDuration)
    },


    /**
     * 根据座席组ID 获取座席座席列表和状态 bak
     */
    FunRequestAgentStatusListBak: function (obackData) {
      // 因异步操作，若处理期间，关主窗，必将致句柄无效，故加try..catch防之。
      try {
        console.log('获取座席座席列表和状态', obackData)
        let that = this
        this.agentList = []
        let count = obackData.Count
        let bak = obackData.AgentStatus || []

        this.agentListFull.forEach(agent => {
          bak.forEach(ext => {
            if (ext.AgentID == agent.id) {
              // this.$set(agent, 'agent', ext.AgentStatus)
              // this.$set(agent, 'statusTimeSeconds', ext.StatusTimeSeconds)
              agent.agentStatus = ext.AgentStatus
              agent.statusTimeSeconds = ext.StatusTimeSeconds
            }
          })
          if (agent.id != that.g_AgentID) {
            if (that.agentSearchBox.agentStatus) {
              if (that.agentSearchBox.agentStatus == (agent.agentStatus || '').toString()) {
                this.agentList.push(agent)
              }
            } else {
              this.agentList.push(agent)
            }
          }
        })
      } catch (e) {
        console.error("收到APG返回座席状态事件进处理异常，" + e)
      }
    },

    getSecondToTimeString: (iSecond) => {
      if (iSecond) {
        let iHour = Math.floor(iSecond / 3600)
        let iMinute = Math.floor((iSecond - (iHour * 3600)) / 60)
        iSecond = iSecond - (iHour * 3600) - (iMinute * 60)
        let strHour = String(iHour)
        let strMinute = String(iMinute)
        let strSecond = String(iSecond)
        if (iHour < 10) strHour = "0" + strHour
        if (iMinute < 10) strMinute = "0" + strMinute
        if (iSecond < 10) strSecond = "0" + strSecond
        return strHour + ":" + strMinute + ":" + strSecond
      }
      return ""
    },
    // 电话排队
    acdCallQueueUpdateEvt: function (dataEvt) {
      console.log('电话排队 dataEvt', dataEvt)
      let iQueueFlag = dataEvt.QueueFlag
      let iLogicNO = dataEvt.LogicNO
      let iFrontLogicNO = dataEvt.FrontLogicNO
      let iAgentGroupID = dataEvt.AgentGroupID
      let iSkillID = dataEvt.SkillID
      let strCallerNO = dataEvt.CallerID
      let strAgentGroupName = ""
      let strSkillName = ""
      let strDateTime = ""

      if (iFrontLogicNO == 4294967295) {
        iFrontLogicNO = -1
      }


      if (this.g_AgentGroupArray4Agent.length > 0) {
        this.g_AgentGroupArray4Agent.forEach(item => {
          console.log('g_AgentGroupArray4Agent item', item)
          if (item.AgentGroupID == iAgentGroupID) {
            strAgentGroupName = item.GroupName
          }
        })
      }

      if (this.g_SkillArray4Agent.length > 0) {
        this.g_SkillArray4Agent.forEach(item => {
          console.log('g_SkillArray4Agent item', item)
          if (item.SkillID == iAgentGroupID) {
            strSkillName = item.SkillName
          }
        })
      }

      // 排队事件类型,0=退出排队,1=加入排队
      if (iQueueFlag == 1) {
        //strDateTime = data.datenow;

        // 加入排队
        try {
          // let obj = new CallQueueDataItem(strCallerNO, iFrontLogicNO, iAgentGroupID, strAgentGroupName, iSkillID, strSkillName, iLogicNO)

          /**
           * 排队电话对象
           * @param strCallerNO 主叫电话(主键)
           * @param iFrontLogicNO 前一个通道ID，如果为-1说明当前前通道在排在最前面
           * @param iAgentGroupID 座席组ID
           * @param strAgentGroupName 座席组名称
           * @param iSkillID 技能组ID
           * @param strSkillName 技能组名称
           * @param iLogicNO 逻辑通道
           * @returns
           */
          let obj = {
            CallerNO: strCallerNO,
            AgentGroupID: iAgentGroupID,
            AgentGroupName: strAgentGroupName,
            SkillID: iSkillID,
            SkillName: strSkillName,
            FrontLogicNO: iFrontLogicNO,
            LogicNO: iLogicNO
          }
          // 插入排队
          this.$set(this.AgentQueueCallGridData, strCallerNO, obj)
          // $Global.AgentQueueCallGridData.push(obj)
          // this.changeToolBarAgentACDQueueCallButtonNumber()
        } catch (e) {
          console.log('电话排队 error', e)
          let tstr = this.$moment().format('YYYY-MM-DD HH:mm:ss')
          console.error("号码[" + strCallerNO + "]入排队异常，时间[" + tstr + "]!")
          console.log("number[" + strCallerNO + "]add to queue fail，time[" + tstr + "]")
        }

      } else {
        // 退出排队
        try {
          // let obj = new CallQueueDataItem(strCallerNO, iFrontLogicNO, iAgentGroupID, strAgentGroupName, iSkillID, strSkillName, iLogicNO)
          this.$delete(this.AgentQueueCallGridData, strCallerNO)
          this.getWaitList(false)
          // $Global.AgentQueueCallGridData.delete(obj)
          // this.changeToolBarAgentACDQueueCallButtonNumber()
        } catch (e) {
          console.log('退出排队 error', e)
          let tstr = this.$moment().format('YYYY-MM-DD HH:mm:ss')
          console.error("号码[" + strCallerNO + "]退出排队异常，时间[" + tstr + "]!")
          console.log("number[" + strCallerNO + "]exit queue fail，time[" + tstr + "]")
        }
      }
    },

    agentOnAnsweredEvt (dataEvt) {
      let objLastHoldCallItem = this.LastHoldCallItem()

      switch (this.g_AgentHoldCallBeforOperation) {
        case g_CONST_AgentHoldCallBeforOperation.InviteAgent():     // 将收到的事件：呼叫失败=CONS_EU_AG_AgentOnCallEndEvt_97,呼叫成功=CONS_EU_AG_AgentOnAnsweredEvt_101
        case g_CONST_AgentHoldCallBeforOperation.InviteCallOut():   // 将收到的事件：呼叫失败=CONS_EU_AG_AgentOnCallEndEvt_97,呼叫成功=CONS_EU_AG_AgentOnAnsweredEvt_101
          if (objLastHoldCallItem != null) {

            //{{ modify by zhao 2017-05-23
            //let iCallIDType = g_CallIDType;
            let iCallIDType = objLastHoldCallItem.CallIDType
            //}}
            let iCallID = objLastHoldCallItem.CallID
            if (objLastHoldCallItem.PopupType == 8) // 座席直接呼叫另一座席时
            {
              iCallIDType = 0
              iCallID = -1
            }
            // $Send.AgentRetrieveHoldCall(iAgentID, iCallIDType, iCallID)

            this.agentRetrieveHoldCall(this.g_AgentID, iCallIDType, iCallID)
          }
          break
        default:
          break
      }
      this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.Unknown()
      this.$emit('changePanel', true)
    },


    //座席找回返回确认消息
    agentRetrieveHoldAck (dataAck) {

      if (dataAck.Status != 0) {
        this.onNetResult(dataAck.Status)
        return
      }

      this.RemoveHoldCallList(dataAck.CallIDType, dataAck.CallID)
      this.changeToolBarAgentHold4RetriveCallButtonNumber()
      this.img_keepOrContinue = "/jxyAgent/images/icon/Enable/keep.png"
      this.keepOrContinueLabel = "保持"
      // $("#").attr("src", "images/icon/Enable/keep.png")
      // $('#keepOrContinueLabel').text("保持")
    },


    //开始静音-ack
    AgentBeginMuteAck (dataAck) {

      if (dataAck.Status != 0) {
        this.onNetResult(dataAck.Status)
        return
      } else {
        this.muteState = true
        this.rightPrint("开始静音.")
        // this.muteLable = "停止静音"
        // this.img_mute = "images/icon/Enable/mute.png"
      }
    },


    // 结束静音-ack
    AgentEndMuteAck (dataAck) {
      if (dataAck.Status != 0) {
        this.onNetResult(dataAck.Status)
        return
      } else {
        this.muteState = false
        this.rightPrint("结束静音.")
        // this.muteLable = "开始静音"
        // this.img_mute = "images/icon/Enable/mute.png"
      }
    },


    //座席与当前呼叫建立联接事件
    agentOnConnectedEvt (dataEvt) {
      console.log('座席与当前呼叫建立联接事件 agentOnConnectedEvt', dataEvt)
      console.log('callData', this.AgentMissedCallGridData[this.m_LastAgentMissedCallDataKey])
      // this.$emit('changeRecordStatus', 'establish')
      // this.$emit('updateCallRecord', this.options.appId, this.currentSerialNum, 'establish')

      // 产生来电时长 移除未接存储的数据
      this.$delete(this.AgentMissedCallGridData, this.m_LastAgentMissedCallDataKey)
      // $Global.AgentMissedCallGridData.delete($Global.getLastAgentMissedCallDataKey())

      // 改变话务工具栏上座席未接电话数量数值
      this.changeToolBarAgentMissedCallButtonNumber()
      this.setLastAgentMissedCallDataKey("")
    },


    //呼转外线返回事件
    agentTransferOutAck (dataAck) {
      console.log("——>>>呼转外线返回事件(dataAck)")
      console.dir(dataAck)
      console.log("<<<——呼转外线返回事件(dataAck)")

      if (dataAck.Status != 0) {
        this.onNetResult(dataAck.Status)
        return
      }
    },


    //座席 上线通知
    AgentOnLineEvt (jsonData) {

    },


    logoutByRefresh () {
      agentServer.$Log.send('Info', "刷新浏览器时注销当前座席")
      console.log("刷新浏览器时注销当前座席")
      this.agentLoggedOffType = 1

      this.logOut()
    },


    //文书处理文本记时处理
    autoTime () {
      let that = this
      this.m_TextProcessCounter--
      console.log('事后处理还剩', that.m_TextProcessCounter)
      if (this.m_TextProcessCounter <= 0) {

        this.agentStatusLabel = "文书处理"
        if (this.m_Timer4TextProcess) {

          clearInterval(this.m_Timer4TextProcess)
          this.m_Timer4TextProcess = null
        }
        this.cancelAdjust()
      } else {
        if (this.m_ifAutoBusiness == 0) {
          this.agentStatusLabel = "文书处理(" + this.m_TextProcessCounter + ")"
        } else {
          this.agentStatusLabel = "文书处理"
        }
      }
    },

    //获取外呼时送出的主叫号码等座席参数
    getAgent () {
      let that = this
      this.g_CallerNO4AgentCallout = ""
      agentServer.getAgent(this.g_VDNID, this.g_AgentID, this.g_WorkNO).then(data => {
        that.m_FinishedGetAgent = true
        if (data == null) {
          console.error("getAgent 返回数结果为null.")
          return
        }
        that.agentHookMode = data.agenthookmode // 摘机挂机 是否显示1：表示话机摘挂机，2：表示座席软件摘挂机。
        if (data.calledtel) {
          this.g_CallerNO4AgentCallout = data.calledtel
          //console.info("外呼送出主叫号码为[" + g_CallerNO4AgentCallout + "]");
        }
      }).catch(err => {
        console.log('getAgent error', err)
      })
    },


    interGetStatusCount () {
      if (this.interGetStatusCountTime) {
        clearInterval(this.interGetStatusCountTime)
        this.interGetStatusCountTime = null
      }
      this.interGetStatusCountTime = window.setInterval(this.getStatusCount(), 5000)
    },

    /**
     * 响应CCS函数 座席登陆返回
     */
    AgentLoginAck: function (ObjData) {
      this.AgentLoginAck_data = ObjData
      console.log('AgentLoginAck', this.AgentLoginAck_data)
      // let ObjData = this.AgentLoginAck_data
      if (ObjData.Result == 0) {
        console.info("登录成功")
        this.$emit('changeStatus', true)
        // this.linkStateLabel = '成功'
        this.linkStateLabel = '<span style="color:red;">已登录</span>'
        this.success_login(ObjData)

        this.addMessages('登录成功')
        this.$emit('signLog', { appId: this.options.appId, seatId: this.loginInfo.operatorId, logType: 'signIn', logStatus: true, remark: '登录成功' })
        //轮询获取状态（示闲、示忙、文案处理）人数
        //interGetStatusCount();
        // $('#b_AgentName').text(ObjData.AgentName)
      } else {
        this.currentStatus = 'offline'

        if (ObjData.Result == 1127) {
          let workNO = this.loginInfo.operatorId
          let extension = this.loginInfo.extension
          let vdn = this.loginInfo.vdn
          let ErrInfo = "座席(VDN:" + vdn + ",WorkNO:" + workNO + ",分机:" + extension + ")登录失败，当前分机号已被工号\"" + ObjData.workNO + "\"占用。"
          this.addMessages(ErrInfo, 'error')
          this.$Notice.error({
            title: '登录失败',
            content: "1127: 分机号冲突 <br>" + ErrInfo,
            duration: 3
          })
          this.$emit('signLog', { appId: this.options.appId, seatId: this.loginInfo.operatorId, logType: 'signIn', logStatus: false, remark: ErrInfo })
        } else {
          this.onNetResult(ObjData.Result)
        }
      }
    },

    onNetResult: function (nResult, strMoreErrInfo) {
      if (nResult != 0) {
        let that = this
        agentServer.err_Code(nResult).then(data => {

          let strErrorCodeDescription = nResult + ":" + data.description_cn
          try {
            if (strMoreErrInfo) {
              strErrorCodeDescription += "<br/>"
              strErrorCodeDescription += strMoreErrInfo
            }
          } catch (e) {
            console.error("异常：" + e)
          }
          that.rightPrint(strErrorCodeDescription)

        }).catch(err => {
          console.log('onNetResult err', err)
          that.rightPrint(nResult + (strMoreErrInfo ? (":" + strMoreErrInfo) : ''))
        })

        if (nResult == 1084) {
          //座席应用无效, 注销座席
          that.logOut()
        }
      }
    },


    AgentSelfStatusUpdateEvt: function (dataEvt) {
      // 座席状态改变事件
      if ((dataEvt) && (dataEvt.AgentID) && (dataEvt.AgentID == this.g_AgentID)) {
        let agentStatus = dataEvt.AgentStatus[1]
        // $Global.AgentCurrentStatus = agentStatus
        this.changeAgentStatus(agentStatus)
      } else {
        agentServer.$Log.send('Warn', "Haven't process CONST_CCS_CT_AgentProxy_12 MSG " + agentFunc.showAgentMessageName(dataEvt.Base.Function) + ":" + JSON.stringify(dataEvt))
      }
    },

    ShowAgentStateName: function (code) {
      let statusC = this.stateMap[code]
      if (statusC) return statusC.name
      return code.toString()
    },


    //获取Agent状态描述,需要参数iAgentState 业务控制
    changeAgentStatus: function (iAgentState) {
      let that = this
      console.log('changeAgentStatus iAgentState at ' + this.$moment().format('YYYY-MM-DD HH:mm:ss'), this.currentAgentCode, iAgentState)

      if (this.currentAgentCode == iAgentState) return
      this.addMessages("座席由状态【" + (this.stateMap[this.currentAgentCode]?.label || this.currentAgentCode) + "】切换至[" + (this.stateMap[iAgentState]?.label || iAgentState) + "]")
      this.currentAgentCode = iAgentState
      // 改变座席状态图标
      this.ChangePhoneToolbarAgentStatusIcon(iAgentState)
      if ((this.m_Timer4TextProcess != undefined) || (this.m_Timer4TextProcess != null)) {
        clearTimeout(this.m_Timer4TextProcess) // 停止上一次文书处理的定时器
        this.m_Timer4TextProcess = null
      }
      switch (Number.parseInt(iAgentState)) {
        case 1:
          agentServer.$Log.send('Info', "【Agent Status】未知_" + this.ShowAgentStateName(iAgentState))
          this.currentStatus == 'offline'
          break
        case 2:
          agentServer.$Log.send('Info', "【Agent Status】示忙_" + this.ShowAgentStateName(iAgentState))
          // 座席正在示忙
          this.currentStatus = 'busy'
          this.$emit('changeRecordStatus', 'busy')
          break
        case 4:
          agentServer.$Log.send('Info', "【Agent Status】离席_" + this.ShowAgentStateName(iAgentState))
          break
        case 8:
          agentServer.$Log.send('Info', "【Agent Status】被阻塞_" + this.ShowAgentStateName(iAgentState))

          break
        case 16:
          agentServer.$Log.send('Info', "【Agent Status】登录未签入_" + this.ShowAgentStateName(iAgentState))

          break
        case 32:
          agentServer.$Log.send('Info', "【Agent Status】空闲_" + this.ShowAgentStateName(iAgentState))
          //座席空闲(已签入)
          this.currentStatus = 'idle'
          this.phoneNO = ''
          this.callType = '1'
          this.$emit('changeRecordStatus', 'idle')
          this.viewModel = 'numberPanel'
          this.panelMode == 'normal'
          break
        case 64:
          agentServer.$Log.send('Info', "【Agent Status】振铃_" + this.ShowAgentStateName(iAgentState))
          this.$emit('changeRecordStatus', 'ringing')

          this.viewModel = 'telRingPanel'
          this.panelMode == 'normal'
          break
        case 128:
          agentServer.$Log.send('Info', "【Agent Status】外呼_" + this.ShowAgentStateName(iAgentState))
          this.$emit('changeRecordStatus', 'calling')
          this.viewModel = 'telRingPanel'
          this.panelMode == 'normal'
          break
        case 256:
          // this.ChangePhoneToolbarIconsByAction(CONST_PhoneToolbarAction_callIn)
          this.rightShowCallInfoDuration()
          agentServer.$Log.send('Info', "【Agent Status】通话中_" + this.ShowAgentStateName(iAgentState))
          this.$emit('changeRecordStatus', 'establish')
          this.$emit('updateCallRecord', this.options.appId, this.currentSerialNum, 'establish')
          break
        case 512:
          // this.ChangePhoneToolbarIconsByAction(CONST_PhoneToolbarAction_keep)
          agentServer.$Log.send('Info', "【Agent Status】保持_" + this.ShowAgentStateName(iAgentState))
          break
        case 1024:
          console.log(this.currentAgentCode == iAgentState)
          if (this.m_ifAutoBusiness == 0) {
            this.m_TextProcessCounter = Number.parseInt(this.agentSetForm.textProcTime)
            // this.m_TextProcessFixedCounter = Number.parseInt($Global.TextProcTime)
          } else {
            this.m_TextProcessCounter = 86400
            // this.m_TextProcessFixedCounter = 86400
          }
          this.$emit('updateCallRecord', this.options.appId, this.currentSerialNum, 'release')
          this.currentStatus = 'handle'
          this.$emit('changeRecordStatus', 'handle')
          this.m_Timer4TextProcess = setInterval(() => {
            that.autoTime()
          }, 1000)
          // if(this.m_Timer4TextProcess )
          agentServer.$Log.send('Info', "【Agent Status】文书处理_" + this.ShowAgentStateName(iAgentState))
          break
        case 2048:
          agentServer.$Log.send('Info', "【Agent Status】质检_" + this.ShowAgentStateName(iAgentState))
          break
        case 4096:
          agentServer.$Log.send('Info', "【Agent Status】离线_" + this.ShowAgentStateName(iAgentState))
          this.currentStatus = 'offline'
          break
        case 8192:
          agentServer.$Log.send('Info', "【Agent Status】报工号_" + this.ShowAgentStateName(iAgentState))
          this.$emit('changeRecordStatus', 'playWorkNO')
          break
        case 16384:
          agentServer.$Log.send('Info', "【Agent Status】送催挂音_" + this.ShowAgentStateName(iAgentState))
          break
        case 32768:
          agentServer.$Log.send('Info', "【Agent Status】收听录音_" + this.ShowAgentStateName(iAgentState))

          break
        case 65536:
          agentServer.$Log.send('Info', "【Agent Status】分机临时失效_" + this.ShowAgentStateName(iAgentState))

          break
        case 131072:
          agentServer.$Log.send('Info', "【Agent Status】分机不存在_" + this.ShowAgentStateName(iAgentState))

          break
        case 262144:
          agentServer.$Log.send('Info', "【Agent Status】分机未注册_" + this.ShowAgentStateName(iAgentState))

          break
        case 524288:
          agentServer.$Log.send('Info', "【Agent Status】边界_" + this.ShowAgentStateName(iAgentState))
          break
        default:
          agentServer.$Log.send('Info', "【Agent Status】不确定_" + this.ShowAgentStateName(iAgentState))

          break
      }
    },



    /**
     * 保存VDN等登录信息到后台的Session后，执行下一步的动作.
     */
    afterSaveLoginInfo2Session: function (ObjData) {
      // let strMSG = "座席已经登陆"
      // 加载座席基础配置
      this.loadAgentPersonalized()

      // 获取外呼时送出的主叫号码等座席参数
      this.getAgent()

      // 加载来去电弹屏参数设置
      // this.loadCallPopupSettingList()

      Cookies.set(this.constMap.cookie_AgentName, ObjData.AgentName,
        {
          expires: 365
        })
      // this.rightPrint(strMSG)
    },



    /**
     *  获取一个新的GUID
     */
    GetNewGUID () {
      return agentServer.$GUID.newGUID()
    },

    handlePanel: function (show) {
      console.log('zte handlePanel', show)
    },
    changeStatus: function (name) {
      console.log('changeStatus', name)
      if (this.g_AgentID == -1) {
        this.$Message.warning("当前未登录！")
        return
      }
      let that = this
      switch (name) {
        case "btn_showBusy":
          //示忙
          this.agentSetBusy()
          break
        case "btn_showIdle":
          // 示闲
          this.agentSetIdle()
          break
        case "btn_askForRest":
          // 示闲状态 - 小休
          // 当前状态为文书处理或已是小休时，则直接提示申请失败
          if (this.currentAgentCode == 1024) {
            this.rightPrint("操作不允许，当前座席处于文书处理.")
            return
          } else if (this.currentAgentCode == 4) {
            this.rightPrint("操作不允许，当前座席正在小休中.")
            return
          }
          this.agentRest()
          break
        case "btn_businessArrange":
          //状态 - 文书处理
          this.m_ifAutoBusiness = 0
          this.agentBusinessArrange()
          break
        case "btn_shutdown":
          //下线
          if (this.currentStatus != 'offline') {
            this.$Modal.confirm({
              title: '出确认退',
              content: '<p>确认退出当前座席？</p>',
              onOk: () => {
                agentServer.$Log.send('Info', "退出当前座席")
                that.agentLoggedOffType = 2
                that.logOut()
              }
            })
          }

          break
      }
    },
    cancelAdjust: function () {
      this.changeStatus('btn_showIdle')
    },
    agentBusinessArrange: function () {
      let that = this
      this.$Spin.show()

      let base = new Base(12, 57)

      let time = this.m_ifAutoBusiness == 0 ? (this.agentSetForm.textProcTime) : 86400
      let stAgentRequestTextProc_t = new StAgentRequestTextProc_t(base, this.g_AgentID, time)
      let jsStAgentRequestTextProtJSON = JSON.stringify(stAgentRequestTextProc_t)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + jsStAgentRequestTextProtJSON + ")")

      try {

        if (this.m_ifAutoBusiness == 0) {
          this.m_TextProcessCounter = Number.parseInt(this.agentSetForm.textProcTime)
        } else {
          this.m_TextProcessCounter = 86400
        }

        this.g_Socket4AGP.send(jsStAgentRequestTextProtJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        // $.ligerDialog.warn('网络发生异常，请再试一次')
        this.$Message.warning({
          content: '网络发生异常，请再试一次',
          duration: 3
        })
      } finally {
        that.$Spin.hide()
      }

    },
    agentSetBusy: function () {
      let that = this
      this.$Spin.show()
      let base = new Base(12, 51)
      let stAgentSetBusy_t = new StAgentSetBusy_t(base, this.g_AgentID)
      let jsStAgentSetBusy_t = JSON.stringify(stAgentSetBusy_t)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + jsStAgentSetBusy_t + ")")
      try {
        this.g_Socket4AGP.send(jsStAgentSetBusy_t)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        // $.ligerDialog.warn('网络发生异常，请再试一次')
        this.$Message.warning({
          content: '网络发生异常，请再试一次',
          duration: 3
        })
      } finally {
        that.$Spin.hide()
      }
    },
    agentSetIdle: function () {
      let that = this
      this.$Spin.show()
      let base = new Base(12, 53)
      let stAgentSetIdle_t = new StAgentSetIdle_t(base, this.g_AgentID)
      let jsStAgentSetIdle_t = JSON.stringify(stAgentSetIdle_t)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + jsStAgentSetIdle_t + ")")
      try {
        this.g_Socket4AGP.send(jsStAgentSetIdle_t)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))

        this.$Message.warning({
          content: '网络发生异常，请再试一次',
          duration: 3
        })
      } finally {
        that.$Spin.hide()
      }
    },
    /**
     * 申请小休
     */
    agentRest: function () {
      let that = this
      console.log('agentRest time', this.agentSetForm.restTime)
      this.$Spin.show()
      let base = new Base(12, 83)
      let stAgentApproveRest_t = new StAgentApproveRest_t(base, this.g_AgentID, this.g_AgentID, this.restStatus, this.agentSetForm.restTime)
      let agentApproveRest_tJSON = JSON.stringify(stAgentApproveRest_t)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + agentApproveRest_tJSON + ")")

      try {
        this.g_Socket4AGP.send(agentApproveRest_tJSON)
        this.$emit('signLog', { appId: this.options.appId, seatId: this.loginInfo.operatorId, logType: 'shortBreak', logStatus: true, remark: '申请小休！' })
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.warning({
          content: '网络发生异常，请再试一次',
          duration: 3
        })
        this.$emit('signLog', { appId: this.options.appId, seatId: this.loginInfo.operatorId, logType: 'shortBreak', logStatus: false, remark: '申请小休失败！' })
      } finally {
        that.$Spin.hide()
      }

    },
    skillFuc: function (name) {
      if (this.g_AgentID == -1) {
        this.$Message.warning("当前未登录！")
        return
      }
      switch (name) {
        case 'btn_checkInAll':
          // 签入 - 签入所有 座席组,技能组
          this.signInAllGroup()
          this.signInAllSkill()
          break
        case 'btn_checkOutAll':
          // 签出所有 座席组,技能组
          this.signOutAllGroup()
          this.signOutAllSkill()
          break
        case 'btn_checkinOrout':
          //签入 - 指定技能
          this.reloadSkills()

          this.showSkillList = true
          break
      }

    },
    reloadSkills: function () {
      this.groupList = []
      this.groupWithSkills.forEach(group => {
        let part = {
          type: 'group',
          title: group.groupName,
          id: group.groupId,
          expand: true,
          checkIn: group.checkIn
        }
        let children = [];
        (group.skills || []).forEach(sk => {
          children.push({
            type: 'skill',
            title: sk.skillName,
            id: sk.skillId,
            value: sk.value,
            parentId: sk.groupId,
            checkIn: sk.checkIn
          })
        })
        part.children = children
        this.groupList.push(part)
      })
      // if (this.skillSeacrhBox.groupName) {
      //   this.groupWithSkills.forEach(item => {
      //     if (item.groupName.indexOf(this.skillSeacrhBox.groupName) >= 0) {
      //       this.groupList.push(item)
      //     }
      //   })
      // } else {
      //   this.groupList = this.groupWithSkills
      // }
      // this.loadSkillList()
    },
    renderContent (h, { root, node, data }) {

      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [
        h('span', [
          h('span', (data.type == 'group' ? '【座席组】' : '【座席技能】') + data.title)
        ]),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '32px'
          }
        }, [
          h('Button', {
            props: Object.assign({}, {
              type: data.checkIn ? 'success' : 'error',
              size: 'small',
            }),
            style: {
              marginRight: '8px'
            },
            on: {
              click: () => {
                console.log('node data', data)
                if (data.checkIn) {
                  if (data.type == 'group') {
                    this.signOutAgentGroupByID(data.id)
                  } else {
                    this.signOutSkillByID(data.id)
                  }
                } else {
                  if (data.type == 'group') {
                    this.signInAgentGroupByID(data.id)
                  } else {
                    this.signInSkillByID(data.id)
                  }
                }
              }
            }
          }, data.checkIn ? '已签入' : '未签入')
        ])
      ])
    },
    transfer: function (name) {
      console.log('transfer', name)
      if (this.g_AgentID == -1) {
        this.$Message.warning("当前未登录！")
        return
      }
      switch (name) {
        case "btn_shiftToGroupAndSkill":
          //转移至技能
          this.getSkillList()
          break
        case "btn_shiftBanquets":
          //  转移 - 转移至座席
          /**
              * 呼叫座席
              */
          this.loadAllGroup('transfer')
          break
        case "btn_shiftToIVR":
          //转移 - 转移至IVR
          this.getIVRList()
          break
        case 'btn_shiftToStatic':
          /**
           * 转移 - 转移至满意度
           */
          let strPrivateInfo = "" // 座席要传入到IVR的私有信息
          this.AgentTransferIVR(this.g_AgentID, this.g_CallID, this.g_CallIDType, this.defaultTransferType, this.defaultFlowID, this.defaultNodeID, strPrivateInfo)
          break

        case 'btn_release':
          /**
           * 座席-挂机
           */
          this.agentHangUp()

          break
        case 'btn_keepOrContinue':
          /**
           * 保持或恢复
           */
          if (this.HoldCallList.length == 0) {
            //保持
            this.objAgentCallItem = this.GetRecentAgentCallItem4Hold()
            if (this.objAgentCallItem == null) {
              // $.ligerDialog.warn("当前没有可被保持的通话.")
              this.$Message.warning("当前没有可被保持的通话")
              return
            }
            // $Send.AgentHoldCall(objAgentCallItem.CallIDType, objAgentCallItem.CallID)

            this.agentHoldCall(this.objAgentCallItem.CallIDType, this.objAgentCallItem.CallID)

          } else {
            //恢复
            if (this.HoldCallList.length < 1) {
              // $.ligerDialog.warn("当前没有可被恢复的通话.")
              this.$Message.warning("当前没有可被恢复的通话")
              return
            } else if (this.HoldCallList.length == 1) {
              //let objHoldCallList = $Global.HoldCallList[0];
              let objHoldCall = this.deepCopy(this.HoldCallList[0])

              let iCallIDType = objHoldCall.CallIDType
              let iCallID = objHoldCall.CallID
              // $Send.AgentRetrieveHoldCall(iAgentID, iCallIDType, iCallID)

              this.agentRetrieveHoldCall(this.g_AgentID, iCallIDType, iCallID)
            } else {

              g_ModalDialogObj = $.ligerDialog.open(
                {
                  name: "selectAgentMissedCallDialog",
                  height: 400,
                  width: 850,
                  url: 'dialogPage/selectRetriveHold/selectRetriveHold.html',
                  isResize: true,
                  title: '恢复列表（双击选择）',
                  modal: true
                })
            }
          }
          break
        case 'btn_callBanquets':
          /**
           * 呼叫座席
           */
          this.loadAllGroup('call')
          break

        case 'btn_mute':

          /**
           * 开始静音
           */
          if (!this.muteState) {

            let base = new Base(12, 47)

            let stAgentBeginMute_t = new StAgentBeginMute_t(base, this.g_AgentID)
            let stAgentBeginMuteJSON = JSON.stringify(stAgentBeginMute_t)
            agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + stAgentBeginMuteJSON + ")")

            try {
              this.g_Socket4AGP.send(stAgentBeginMuteJSON)
            } catch (e) {
              agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
              this.$Message.warning('网络发生异常，请再试一次')
            }

            // $Send.BeginMute()
          } else {
            // $Send.EndMute()

            let base = new Base(12, 49)
            let stAgentEndMute_t = new StAgentEndMute_t(base, this.g_AgentID)
            let stAgentEndMuteJSON = JSON.stringify(stAgentEndMute_t)
            agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + stAgentEndMuteJSON + ")")

            try {
              this.g_Socket4AGP.send(stAgentEndMuteJSON)
            } catch (e) {
              agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
              this.$Message.warning('网络发生异常，请再试一次')
            }
          }
          break
        case 'btn_agentSnatch':
          /**
                    * 抢接座席
                    */
          this.loadAllGroup('grabbing')

          //抢接座席
          // this.g_ModalDialogObj = $.ligerDialog.open(
          //   {
          //     name: "agentGroupsDialog",
          //     height: 400,
          //     width: 830,
          //     url: this.constMap.dailogURL_SelectAgent + this.constMap.openSelectAgentDialogType_AgentSnatch,
          //     isResize: true,
          //     isHidden: false,
          //     title: '座席列表（双击抢接）-【抢接座席响铃电话】'
          //   })
          break
        case 'btn_conferenceManagement':
          this.meetingMgrData = {
            confSize: 4,
            skillGroupValue: '',
            phoneNO: ''
          }
          this.showMeetingMgr = true
          //   //会议
          //   if (g_ConferenceDialog == "1") {
          //     g_ConfDialog.active()
          //     return
          //   }
          //   g_ConfDialog = $.ligerDialog.open({
          //     id: 'conferenceMgr',
          //     height: 500,
          //     width: 1000,
          //     url: 'dialogPage/meetingMgr/meetingMgr.html',
          //     isResize: true,
          //     title: '会议管理',
          //     modal: false,
          //     showMax: true,
          //     showMin: true,
          //     allowClose: false
          //   })
          //   g_ConferenceDialog = "1"
          break
        case 'btn_queue':
          //排队(当前排队电话)
          this.getWaitList(true)
          break
        case 'btn_missed':
          /**
           * 未接(座席未接电话)
           */
          this.g_ModalDialogObj = $.ligerDialog.open(
            {
              name: "missedDialog",
              height: 400,
              width: 850,
              url: 'dialogPage/selectAgentMissedCall/selectAgentMissedCall.html',
              isResize: true,
              title: '座席响铃未接电话（右键菜单操作）'
            })
          break
        case 'btn_agentSet':
          //座席设置
          this.initAgentSet()

          break
      }

    },
    changePageIvr: function (page) {
      this.ivrPages.current = page

      let that = this
      this.loadIvr = true
      this.ivrList = []
      let params = {
        page: this.ivrPages.current,
        pagesize: this.ivrPages.pageSize,
      }
      if (this.ivrSearchBox.flowName) {
        params.queryParm = {
          "keyWord": this.ivrSearchBox.flowName
        }
      }
      agentServer.initIVRGrid4Domain(params).then(data => {
        console.log('initIVRGrid4Domain data', data)
        this.ivrPages.total = data.Total
        this.ivrList = data.Rows || []
        this.showTransferIVR = true
      }).catch(err => {
        console.log('initIVRGrid4Domain err', err)
        that.$Message.error("获取ivr流程失败！")
      }).finally(() => {
        that.loadIvr = false
      })
    },
    canceIvr: function () {
      this.ivrSearchBox = {
        transferType: 0,
        flowName: ''
      }
      this.showTransferIVR = false
    },

    /**
     * 转移-转移至IVR
     * @param iAgentID 当前座席ID
     * @param iCallID 当前呼叫的CallID
     * @param iCallIDType 当前呼叫的呼叫类型
     * @param iTransferType 释放转还是保持转
     * @param iFlowID 目标IVR的流程ID
     * @param iNodeID 目标IVR流程的节点ID
     * @param strPrivateInfo 座席要传给IVR的字符串数据
     */
    AgentTransferIVR: function (iAgentID, iCallID, iCallIDType, iTransferType, iFlowID, iNodeID, strPrivateInfo) {
      console.log('AgentTransferIVR g_CallOfferedType', this.g_CallOfferedType)
      console.log('AgentTransferIVR currentCallType', this.currentCallType)
      let base = new Base(12, 35)

      let callId = this.currentCallType == 'OUTBOUND' || this.g_CallOfferedType == 7 ? -1 : iCallID

      let stAgentTransferIVRObj = new stAgentTransferIVR_t(base, iAgentID, callId, iCallIDType, iTransferType, iFlowID, iNodeID, strPrivateInfo)
      let stAgentTransferIVRJSON = JSON.stringify(stAgentTransferIVRObj)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + stAgentTransferIVRJSON + ")")

      try {
        this.g_Socket4AGP.send(stAgentTransferIVRJSON)
      } catch (e) {
        $Log.error("send message to agp failed!" + $Log.message(e))
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },

    getIVRList: function () {
      this.ivrSearchBox = {
        transferType: 0,
        flowName: ''
      }

      this.ivrPages = {
        current: 1,
        total: 0,
        pageSize: 10,
      }
      this.changePageIvr(1)
    },

    getSkillList: function () {
      let that = this

      this.skillPages = {
        current: 1,
        total: 0,
        pageSize: 10,
      }

      this.loadSkill = true
      this.transferSkillFullList = []
      this.transferSkillList = []
      let params = {

      }
      if (this.skillSearchBox.groupName) {
        params.groupName = this.skillSearchBox.groupName
      }
      if (this.skillSearchBox.skillName) {
        params.skillName = this.skillSearchBox.skillName
      }
      agentServer.initGroupAndSkill(params).then(data => {
        console.log('initGroupAndSkill data', data)
        this.skillPages.total = data.Total
        this.transferSkillFullList = data.Rows || []
        this.changePageSkill(1)
        this.showTransferSkill = true
      }).catch(err => {
        console.log('initGroupAndSkill err', err)
        that.$Message.error("获取技能列表失败！")
      }).finally(() => {
        that.loadSkill = false
      })
    },
    canceSkill: function () {
      this.showTransferSkill = false
      this.skillSearchBox = {
        skillName: '',
        groupName: ''
      }
    },
    changePageSkill: function (page) {
      this.skillPages.current = page
      let start = this.skillPages.pageSize * page
      let end = (page + 1) * this.skillPages.pageSize
      if (end > this.transferSkillFullList.length) {
        end = this.transferSkillFullList.length
      }
      this.transferSkillList = this.transferSkillFullList.slice(start, end)
    },

    getWaitList: function (open) {
      console.log('getWaitList', this.AgentQueueCallGridData)
      this.waitList = []
      Object.keys(this.AgentQueueCallGridData).forEach(key => {
        let add = true
        let item = this.AgentQueueCallGridData[key]
        if (this.waitSearchBox.groupName) {
          add = item.AgentGroupName.indexOf(this.waitSearchBox.groupName) >= 0
        }
        if (this.waitSearchBox.skillName) {
          add = item.SkillName.indexOf(this.waitSearchBox.skillName) >= 0
        }
        if (add) this.waitList.push(Object.assign({}, item))
      })
      if (open) this.showWaitList = true
    },
    cancelWait: function () {
      this.waitSearchBox = {
        skillName: '',
        groupName: ''
      }
      this.showWaitList = false
    },
    /**
     * 解散会议
     */
    closeMeeting: function () {
      this.g_ConferenceCaller = "0"	//标识会议结束
      this.agentHangUp()
    },

    cancelMeeting: function () {
      this.meetingMgrData = {
        confSize: 4,
        skillGroupValue: '',
        phoneNO: ''
      }
      this.showMeetingMgr = false
    },
    /**
     * 邀请外线
     */
    inviteMeeting: function () {


      let ConfSize = this.meetingMgrData.confSize
      let calledNo = this.meetingMgrData.phoneNO
      let strPrivateInfo = this.constPop.ConstPopupTypeAgentDefaultCallOut

      let strGroupAndSkillVal = this.meetingMgrData.skillGroupValue

      if (calledNo == "") {
        this.$Message.warning({
          content: "请输入电话号码！",
          duration: 3
        })
        return false
      }
      this.phoneNO = calledNo
      // 邀请外线
      this.callType = "2"
      // top.$("#phoneNO").val(calledNo);
      // top.$("#call_type").val("2");	
      // top.m_MainSelectGroupAndSkill4Call.selectValue(strGroupAndSkillVal);	

      let arrayGroupAndSkill = strGroupAndSkillVal.split("|")
      let iGroupID = parseInt(arrayGroupAndSkill[0])
      let iSkillID = parseInt(arrayGroupAndSkill[1])
      this.g_ConferenceCaller = "1"	//标识会议开始
      this.AgentCallOut(this.g_CallerNO4AgentCallout, calledNo, iGroupID, iSkillID, ConfSize, this.constMap.defaultCallOutBusiType, strPrivateInfo)
    },


    /**
     * 转移-ACD排队
     * @param iGroupID 座席组
     * @param iSkillId 技能组
     */
    TransferAgentACD: function (iGroupID, iSkillId) {
      let base = new Base(12, 39)

      let callID = -1
      let stAgentTransferAgentGroup = new StAgentTransferAgentGroup_t(base, this.g_AgentID, callID, this.constMap.callIDType_CallID_AgentID, iGroupID, iSkillId)
      let stAgentTransferAgentGroupJSON = JSON.stringify(stAgentTransferAgentGroup)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + stAgentTransferAgentGroupJSON + ")")
      try {
        this.g_Socket4AGP.send(stAgentTransferAgentGroupJSON)
        agentServer.saveData("转移-ACD排队请求参数： " + stAgentTransferAgentGroupJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + $Log.message(e))
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },

    cancelAgentSet: function () {
      this.showAgentSet = false
      this.$refs.agentSetForm.resetFields()
    },

    //function SaveObject(AgentId, TextProcTime, MaxPageSize, PopMsgTime, RestTime, TransferConnectMode, ShowLoginWindow, AutoSigin, ShowWhenCalling, AutoBusyAfterTalk)

    submitAgentSet: function () {
      this.showAgentSet = true
      let that = this
      this.$refs.agentSetForm.validate(valid => {
        console.log('submitAgentSet', valid)
        if (valid) {
          //let saveObject = new SaveObject(AgentId, TextProcTime, MaxPageSize, PopMsgTime, RestTime, TransferConnectMode, ShowLoginWindow, AutoSigin, ShowWhenCalling, AutoBusyAfterTalk);
          try {
            let saveObject = {
              AgentId: this.g_AgentID,
              TextProcTime: that.agentSetForm.textProcTime,
              MaxPageSize: 0,
              PopMsgTime: that.agentSetForm.popMsgTime,
              RestTime: that.agentSetForm.restTime,
              TransferConnectMode: that.agentSetForm.transferConnectMode,
              ShowLoginWindow: that.agentSetForm.showLoginWindow,
              AutoSigin: that.agentSetForm.autoSigin,
              ShowWhenCalling: that.agentSetForm.showWhenCalling,
              AutoBusyAfterTalk: that.agentSetForm.autoBusyAfterTalk
            }
            agentServer.updateAgendSetting(saveObject).then(data => {
              if (data == true) {
                that.$Message.success("保存成功！")
                that.cancelAgentSet()
              } else {
                that.$Message.error("保存失败！")
              }
            }).catch(err => {
              console.log('submitAgentSet error', err)
              that.$Message.error("保存失败！")
            })
          } catch (error) {
            console.log('error', error)
          }
        }
      })
    },
    callP: function (data) {
      console.log('callP', data)
      if (this.g_AgentID == -1) {
        this.$Message.warning("当前未登录！")
        return
      }
      switch (data.callType) {
        case 'OUTBOUND':
          this.phoneNO = data.callee
          this.makeCall()
          break
        case 'INBOUND':
          this.phoneNO = data.caller
          this.makeCall()
          break
      }
    },
    /**
     * 点击右边拨号栏外呼按钮处理事件
     */
    makeCall: function () {
      let patt = /^[0-9*#]*$/ //外呼输入只能匹配数字
      let strCalledNO = this.phoneNO.trim()
      console.log('makeCall strCalledNO', strCalledNO)

      let iCallType = Number.parseInt(this.callType)

      let arrayGroupAndSkill = []
      let strPrivateInfo = ""
      let iGroupID = -1
      let iSkillID = -1
      let callerNO4AgentCallout = this.g_CallerNO4AgentCallout

      //console.log("g_CallerNO4AgentCallout:"+g_CallerNO4AgentCallout);
      //console.log("默认主叫，下拉选中的号码："+callerNO4AgentCallout);
      //console.log("实际主叫的号码："+callerNO4AgentCallout);

      if (strCalledNO == "") {
        this.$Message.warning("拨打号码不能为空!")
        return
      }

      let illegalCharCount = 0
      let echoStr = ""
      for (let i = 0; i < strCalledNO.length; i++) {
        let ch = strCalledNO.charAt(i)
        let code = ch.charCodeAt()
        if (code < 33 || code > 126) {//不可见字符
          illegalCharCount++
          echoStr += "?"
        } else {//
          if (!patt.test(ch)) { //非法字符
            illegalCharCount++
          }
          echoStr += ch
        }
      }

      if (illegalCharCount > 0) {
        this.$Message.warning("电话号码存在非法字符，请重新输入！")
        this.phoneNO = echoStr
        return
      }
      console.log('skillGroupValue', this.skillGroupValue)
      if ((this.skillGroupValue == undefined) || (this.skillGroupValue == null) || (this.skillGroupValue.trim() == "")) {
        this.$Message.warning("请选择当前操作技能组!")
        return
      }

      //外地号码前自动加0
      let reg1 = /^1[3|4|5|6|7|8|9][0-9]{9}$/
      if (reg1.test(strCalledNO)) {
        let callNoPrefix = strCalledNO.substring(0, 7)
        let telNoPreFix = this.g_TelNoPrefix
        console.log('telNoPreFix', telNoPreFix)
        let flag = false
        for (let index = 0; index < telNoPreFix.length; index++) {
          const item = telNoPreFix[index]
          if (item == callNoPrefix) {
            flag = true
            console.log('item == callNoPrefix', item == callNoPrefix)
            // return false
            break
          }
        }

        if (!flag) {
          strCalledNO = "0" + strCalledNO
        }
      }

      //console.log("外呼呼出的电话号码："+strCalledNO);

      arrayGroupAndSkill = this.skillGroupValue.split("|")
      iGroupID = Number.parseInt(arrayGroupAndSkill[0])
      iSkillID = Number.parseInt(arrayGroupAndSkill[1])
      console.log('iCallType', iCallType)
      switch (iCallType) {
        case 1:     // 呼叫外线
          strPrivateInfo = this.constPop.ConstPopupTypeAgentDefaultCallOut
          this.agentCallOut(callerNO4AgentCallout, strCalledNO, iGroupID, iSkillID, this.constMap.defaultCallOutConfSize, this.constMap.defaultCallOutBusiType, strPrivateInfo)
          break
        case 2:     // 邀请外线（先保持，后外呼）            
          objAgentCallItem = this.GetRecentAgentCallItem4Hold()
          if (objAgentCallItem == null) {
            // $.ligerDialog.warn("当前没有可被保持的通话.")
            this.$Message.warning("当前没有可被保持的通话")
            return
          }
          //如果当前状态不是保持状态，则进行保持操作。
          if (this.currentAgentCode != 512) {
            //保持
            this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.InviteCallOut()
            // $Send.AgentHoldCall()
            this.agentHoldCall(objAgentCallItem.CallIDType, objAgentCallItem.CallID)
          } else {
            //外呼
            strPrivateInfo = this.constPop.ConstPopupTypeAgentDefaultCallOut
            this.agentCallOut(callerNO4AgentCallout, strCalledNO, iGroupID, iSkillID, this.constMap.defaultCallOutConfSize, this.constMap.defaultCallOutBusiType, strPrivateInfo)
          }
          //}}
          break
        case 3:     // 转移外线并保持
          this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.TransferOutThenHold()
          // $Send.TransferOut(strCalledNO, g_CONST_TransferType_Hold)
          this.transferOut(strCalledNO, this.constMap.transferType_Hold)
          break
        case 4:     // 转移外线并释放
          this.g_AgentHoldCallBeforOperation = g_CONST_AgentHoldCallBeforOperation.TransferOutThenRelease()
          // $Send.TransferOut(strCalledNO, g_CONST_TransferType_Release)
          this.transferOut(strCalledNO, this.constMap.transferType_Release)
          break
      }
    },


    /**
     * 转移-外线
     */
    transferOut: function (strCalledNO, transferType) {
      let base = new Base(12, 37)

      let strCallerNO = this.g_CallerNO4AgentCallout
      let iConnectMode = 1
      let iCallIDType = this.constMap.callIDType_CallID_LogicNO
      let iCallID = -1
      let strPrivateInfo = ""


      if ((strCallerNO == undefined) || (strCallerNO == null))
        strCallerNO = ""

      let objAgentTransferOut = new StAgentTransferOut_t(base, this.g_AgentID, strCalledNO, strCallerNO, transferType, iConnectMode, iCallIDType, iCallID, strPrivateInfo)
      let strAgentTransferOut = JSON.stringify(objAgentTransferOut)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + strAgentTransferOut + ")")

      try {
        this.g_Socket4AGP.send(strAgentTransferOut)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        // $.ligerDialog.warn('网络发生异常，请再试一次')
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },

    /**
    * 座席外呼
    * @param strCallerNO 主叫号码
    * @param strCalledNO 被叫号码
    * @param iGroupID 外呼时选择的座席组
    * @param iSkillID 外呼时选择的技能组
    * @param iConfSize 会议大小(默认为0,如果>3就是会议)
    * @param iBusiType 业务类型,用于更新录音表记录,用数值为代表
    * @param strPrivateInfo 外呼时座席传递的私有数据
    */
    agentCallOut: function (strCallerNO, strCalledNO, iGroupID, iSkillID, iConfSize, iBusiType, strPrivateInfo) {
      console.log('座席外呼事件 agentCallOut', { strCallerNO, strCalledNO, iGroupID, iSkillID, iConfSize, iBusiType, strPrivateInfo })


      let base = new Base(12, 29)
      let iAgentCalltype = 4 // 0=转座席，1=IVR，2=座席组，3=通用应用，4=外线
      let iFlowID = 0
      let szCallerNO = ""
      let agentCallOutObj = null
      let strAgentCallOut = null

      if ((strCallerNO == undefined) || (strCallerNO == null)) strCallerNO = ""
      if ((strCalledNO == undefined) || (strCalledNO == null)) strCalledNO = ""
      if ((iGroupID == undefined) || (iGroupID == null) || Number.isNaN(Number.parseInt(iGroupID))) iGroupID = -1
      if ((iSkillID == undefined) || (iSkillID == null) || Number.isNaN(Number.parseInt(iSkillID))) iSkillID = -1
      if ((iConfSize == undefined) || (iConfSize == null) || Number.isNaN(Number.parseInt(iConfSize))) iConfSize = 3
      if ((iBusiType == undefined) || (iBusiType == null) || Number.isNaN(Number.parseInt(iBusiType))) iBusiType = 0
      if ((strPrivateInfo == undefined) || (strPrivateInfo == null)) strPrivateInfo = ""

      strCallerNO = strCallerNO.trim()
      strCalledNO = strCalledNO.trim()
      iGroupID = Number.parseInt(iGroupID)
      iSkillID = Number.parseInt(iSkillID)
      iConfSize = Number.parseInt(iConfSize)
      iBusiType = Number.parseInt(iBusiType)
      strPrivateInfo = strPrivateInfo.trim()

      agentCallOutObj = new StAgentCallOut_t(base, this.g_AgentID, strCalledNO, iAgentCalltype, iGroupID, iSkillID, iFlowID, strPrivateInfo, strCallerNO, iBusiType, iConfSize)
      strAgentCallOut = JSON.stringify(agentCallOutObj)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + strAgentCallOut + ")")

      try {
        this.g_Socket4AGP.send(strAgentCallOut)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.warning('网络发生异常，请再试一次')
      }

    },


    /**
     * 转移-座席
     *
     * @param workNo
     *            座席
     */
    ShiftAgent: function (workNo, agentGroupID, skillID, privateInfo) {
      let base = new Base(12, 41)
      let callID = -1
      let callIDType = this.constMap.callIDType_CallID_AgentID
      let workNO = workNo.toString()
      let AutoRetrieveCall = 2
      let stAgentTransferAgent = new StAgentTransferAgent_t(base, this.g_AgentID, callID, callIDType, workNO, agentGroupID, skillID, privateInfo, AutoRetrieveCall)
      let stAgentTransferAgentJSON = JSON.stringify(stAgentTransferAgent)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + stAgentTransferAgentJSON + ")")

      try {
        this.g_Socket4AGP.send(stAgentTransferAgentJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },


    /**
     * 抢接-座席
     */
    SnatchAgent: function (agentGroupId, agentSkillId, dstAgentId) {
      let base = new Base(12, 43)
      let callID = -1
      let callIDType = g_CONST_CallIDType_CallID_AgentID
      let stAgentSnatchCall_t = new StAgentSnatchCall_t(base, g_AgentID, dstAgentId, callID, callIDType)
      let stAgentSnatchCallJSON = JSON.stringify(stAgentSnatchCall_t)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + stAgentSnatchCallJSON + ")")

      try {
        this.g_Socket4AGP.send(stAgentSnatchCallJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },


    /** *#####other(其他)######*** */
    /**
     * 保持
     *
     * @constructor
     */
    agentHoldCall: function (iCallIDType, iCallID) {

      let base = new Base(12, 21)

      let callID = iCallID ? iCallID : -1
      let callIDType = iCallIDType ? iCallIDType : 0
      let noMusic = 0
      let agentHoldCall = new StAgentHoldCall_t(base, this.g_AgentID, callID, callIDType, noMusic)
      let agentHoldCall_tJSON = JSON.stringify(agentHoldCall)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + agentHoldCall_tJSON + ")")

      try {
        this.g_Socket4AGP.send(agentHoldCall_tJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },
    editCallLedger: function () {
      this.$emit('changeRecordStatus', 'establish')

    },
    /**
     * 挂机按钮处理事件
     */
    agentHangUp: function () {
      console.log('agentHangUp')
      this.isRing = false
      let base = new Base(12, 19)

      //{{modify by zhao 2017-11-27
      //var callID      = -1;   // 挂所有
      let callID = this.g_AgentID   // 只挂自己

      let callIDType = this.constMap.callIDType_CallID_AgentID    // 指明CallID类型为AgentID
      //var callIDType  = g_CallIDType;

      let agentReleaseCall_t = new StAgentReleaseCall_t(base, this.g_AgentID, callID, callIDType)
      let agentReleaseCall_tJSON = JSON.stringify(agentReleaseCall_t)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + agentReleaseCall_tJSON + ")")

      try {
        this.g_Socket4AGP.send(agentReleaseCall_tJSON)
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        this.$Message.warning('网络发生异常，请再试一次')
      }
    },
    currentUserIno: function () {
      let that = this
      that.$axios.post(that.$apis.HLConfigApi.hlAccountApi.currentUserIno, null, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          that.currentUser = res.result || {}
          that.loginInfo.operatorId = that.currentUser.userId
          that.loginInfo.password = that.currentUser.pwd
          that.loginInfo.phoneType = that.currentUser.phoneType || '0'
          that.loginInfo.mobile = that.currentUser.mobile
          that.loginInfo.vdn = that.currentUser.vdn
          that.loginInfo.extension = that.currentUser.extension

          that.$nextTick(() => {
            that.checkHeartTimer = setInterval(() => {
              that.checkHeart()
            }, 60000)
            that.initDom(that.hlLawyerStatus)
          })
        } else {
          that.$Message.error({
            content: res.message || '获取当前座席信息失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('that error', err)
        that.$Message.error({
          content: '获取当前座席信息失败',
          duration: 3
        })
      })
    },
    initDom: function (init) {
      if (this.options.params?.agentServer == undefined || this.options.params?.agentServer == '') {
        this.$Message.error("未配置agentServer")
        return
      }

      if (this.options.params?.agpIp == undefined || this.options.params?.agpIp == '') {
        this.$Message.error("未配置agpIp")
        return
      }

      if (this.options.params?.agpPort == undefined || this.options.params?.agpPort == '') {
        this.$Message.error({
          content: "未配置agpPort",
          duration: 3
        })
        return
      }
      let that = this

      // 1、初始化websocket
      this.initWebSocket()

      // 2、初始化VDN
      // this.initVDN()

      // 3 、获取本地号码前缀
      this.g_TelNoPrefix = []
      agentServer.getTelNoPrefix().then(data => {
        console.log('getTelNoPrefix', data)

        if (data.flag) {
          // data = JSON.parse(data)
          let telNoData = data.telNoData || []
          telNoData.forEach(item => {
            that.g_TelNoPrefix.push(item)
          })
        }
      }).catch(err => {
        console.log('getTelNoPrefix err', err)
      })


      if (init) {
        this.clickBtnSignIn()
      } else {
        this.$Modal.confirm({
          title: '提醒',
          content: '<p>请确认是否上线话务工作台？</p><p>若不上线，稍候可在话务面板中手动上线</p>',
          okText: '上线',
          cancelText: '稍后处理',
          onOk: () => {
            that.clickBtnSignIn()
          }
        })
      }
    },
    logIn: function () {
      console.log('start logIn')
      this.clickBtnSignIn()
    },

    /**
     * 注销-退出
     */
    logOut: function () {
      console.log('start logOut')
      let that = this
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', '正在注销,请稍候...')
          ])
        }
      })

      let base = new Base(12, 3)
      //let agentId = 4;
      agentServer.$Log.send('Info', "Agent logout ==>> " + this.g_AgentID)
      let logoutInfo = new StAgentLoggedOff_t(base, this.g_AgentID, this.constMap.agentLogin_Priority)
      let jslogoutInfo = JSON.stringify(logoutInfo)
      agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + jslogoutInfo + ")")
      try {
        this.g_Socket4AGP.send(jslogoutInfo)
        //清除获取状态人数定时器
        if (this.interGetStatusCountTime) {
          window.clearTimeout(this.interGetStatusCountTime)
          this.interGetStatusCountTime = null
        }
      } catch (e) {
        agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
        // $.ligerDialog.warn('网络发生异常，请再试一次')
        that.$Message.warning({
          content: "网络发生异常，请再试一次",
          duration: 3
        })
        that.addMessages('退出失败！', 'error')
        that.$emit('signLog', { appId: this.options?.appId, seatId: this.loginInfo?.operatorId, logType: 'signOut', logStatus: false, remark: '网络发生异常，请再试一次' })
      } finally {
        that.$Spin.hide()
      }
    },
    /**
    * 点击登录按钮事件
    */
    clickBtnSignIn: function () {
      let that = this
      console.log('needReload', this.needReload)
      console.log('clickBtnSignIn', this.g_IsConnectAGP)
      if (this.g_IsConnectAGP) {
        this.autoSign()
      } else {
        if (this.needReload) {
          this.initWebSocket()
        } else {
          console.error("代理服务器连接失败!")
          this.$Message.error('代理服务器连接失败!')
          this.$emit('changeStatus', false)
          console.log('changeStatus sigin error')
        }
      }
    },
    autoSign: function () {
      let that = this
      try {
        console.log('loginInfo', this.loginInfo)
        let operatorId = this.loginInfo.operatorId || ''
        if (operatorId.length == 0) {
          this.$Message.error("未知座席工号")
          return
        }

        let password = this.loginInfo.password || ''
        if (password.length == 0) {
          this.$Message.error("未知座席密码")
          return
        }

        let extension = this.loginInfo.extension || ''
        if (extension.length == 0) {
          this.$Message.error("未知座席分机号")
          return
        }

        let vdn = this.loginInfo.vdn || ''
        if (vdn.length == 0) {
          this.$Message.error("未知座席VDN")
          return
        }


        this.g_WorkNO = operatorId
        this.g_ExtensionTelNO = extension
        this.g_PassWord = password
        this.g_VDNID = vdn

        Cookies.set(this.constMap.cookie_IsLoad, 'loaded')
        // 保存网页会话
        this.saveLogiInfoToCookie(operatorId, password, extension)

        // $Send.AgentLogin(operatorId, password, extension, vdn, g_CONST_AgentLogin_Priority)

        let base = null
        let agentInfo = null
        this.$Spin.show({
          render: (h) => {
            return h('div', [
              h('Icon', {
                'class': 'demo-spin-icon-load',
                props: {
                  type: 'ios-loading',
                  size: 18
                }
              }),
              h('div', '正在登陆中,请稍候...')
            ])
          }
        })
        if ((typeof (vdn) != undefined) && (typeof (this.constMap.agentLogin_Priority) != undefined)) {
          base = new Base(12, 146)
          vdn = Number.parseInt(vdn)
          agentInfo = new AgentLoginDataEx(base, vdn, operatorId, password, extension, extension, '', 3, this.constMap.agentLogin_Priority, '')
        } else {
          base = new Base(12, 1)
          agentInfo = new AgentLoginData(base, operatorId, password, extension, extension, '', 0)
        }

        // g_password = password

        let agentInfoJSON = JSON.stringify(agentInfo)
        agentServer.$Log.send('Info', "Send [" + defComp.showComponentName(base.ComponentType) + "," + agentFunc.showAgentMessageName(base.Function) + "]==>(" + agentInfoJSON + ")")
        console.log('agentInfoJSON', agentInfoJSON)
        try {
          this.g_Socket4AGP.send(agentInfoJSON)
        } catch (e) {
          console.log('e', e)
          agentServer.$Log.send('Error', "send message to agp failed!" + agentServer.$Log.message(e))
          this.$Message.error('网络发生异常，请再试一次!')
        } finally {
          that.$Spin.hide()
        }
      } catch (err) {
        console.log('clickBtnSignIn error', err)
        that.$Message.error('登录失败!')
      }
    },
    logoutByRefresh () {
      agentServer.$Log.send('Info', "刷新浏览器时注销当前座席")
      console.log("刷新浏览器时注销当前座席")
      this.agentLoggedOffType = 1
      this.logOut()
    },

    /**
    * 显示座席保持电话数量信息
    */
    changeToolBarAgentHold4RetriveCallButtonNumber () {
      if (Number.parseInt(this.HoldCallList.length) > 0) {
        this.keepOrContinueLabel = "恢复(" + this.HoldCallList.length + ")"
      }
      else {
        this.keepOrContinueLabel = "保持"
      }

      try {
        this.refreshHoldCall4RetriveGrid()
      } catch (e) {
        agentServer.$Log.send('Error', "改变显示保持恢复电话数量信息时异常" + agentServer.$Log.message(e))
        this.$Message.error('改变显示保持恢复电话数量信息时异常')
      }

      // this.ChangePhoneToolbarIconsByAction(CONST_PhoneToolbarAction_continue)
    },
    refreshHoldCall4RetriveGrid: function () {
      // todo
    },
    checkHeart: function () {
      this.$axios.post(this.$apis.HLConfigApi.hlAccountApi.checkHeart, null, {
        baseURL: this.baseURL
      }).then(res => {
        console.log('checkHeart', res)
      }).catch(function (err) {
        console.log('checkHeart error', err)

      })
    },
    callPhone: function (data) {
      // this.calleeNumber = data.number
      this.type = data.category
      this.phoneNO = data.number
      this.makeCall()
    },
  },
  beforeDestroy () {
    this.logoutByRefresh()
    if (this.checkHeartTimer) {
      clearInterval(this.checkHeartTimer)
      this.checkHeartTimer = null
    }
    // this.unregEvents()
  },
  beforeMount () {
    this.currentUserIno()
    // this.getWaitList()
  },
}
</script>
<style lang="less" scoped>
.JXYMainContainer {
  // width: 100%;
  // background-color: #fff;
  // margin: 0;
  // padding: 0;
  // font-size: 1rem;
  // margin-bottom: 1rem;

  width: 100%;
  min-width: 240px;
  max-width: 360px;
  background-color: #fff;
  overflow: hidden;
  min-height: fit-content;
  // height: 100%;

  .JXYPanel {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 1px solid #e9e9e9;
    border-radius: 5px;

    box-shadow: 0 0 1px #ebebeb, 0 8px 16px #00000014;

    .JXYPanelHeader {
      padding: 10px;
      background: linear-gradient(#e7f1ff93 12%, #f6f6fb0c 99%, #f7f7fb00 100%);

      .lineHeader {
        display: flex;
        justify-content: space-between;
        align-content: center;

        .title {
          font-weight: 600;
          font-size: 1rem;
        }

        .titleBtns {
          font-weight: 600;
          font-size: 1.2rem;
        }
      }

      > .lineHeader:not(:first-child) {
        margin-top: 10px;
      }

      .leftH {
        align-items: center;
        display: flex;
      }

      .leftC {
        text-align: left;
        font-size: 12px;
      }

      .centerH {
        display: flex;
        align-items: center;
        padding-right: 10px;
      }

      .rightH {
      }
    }
    .JXYPanelBody {
      min-height: 420px;
      overflow: hidden;
      border-top: 1px solid #e9e9e9;
      padding: 10px;

      .numberPanel,
      .hisPanel {
        height: 100%;
        overflow: hidden;
      }

      .phoneContainer {
        padding-top: 10px;

        .line {
          display: flex;
          justify-content: center;
          align-items: center;

          .numBtn {
            cursor: pointer;
            background-color: #eee;
            font-size: 1.4rem;
            font-weight: 600;
            border-radius: 50%;
            text-align: center;
            line-height: 3rem;
            width: 3rem;
            height: 3rem;
            margin: 8px 10px;
            user-select: none;
          }
          .numBtn:hover {
            background-color: #5cadff;
            color: #fff;
          }

          .numBtn.disabled {
            cursor: not-allowed;
            background-color: #f7f7f7;
            color: #c5c8ce;
          }
        }
      }

      .inlineBtnContianer {
        padding-top: 10px;

        .inlineBtnLine {
          display: flex;
          justify-content: center;
          align-items: center;

          .inlineBtn {
            margin: 8px 1rem;
            user-select: none;
            text-align: center;

            .inlineBtnIcon {
              cursor: pointer;
              background-color: #eee;
              font-size: 1.4rem;
              font-weight: 600;
              border-radius: 50%;
              text-align: center;
              line-height: 3rem;
              width: 3rem;
              height: 3rem;
            }

            .inlineBtnLabel {
              font-size: 12px;
              line-height: 1;
              margin-top: 6px;
              font-weight: normal;
              white-space: nowrap;
            }
          }
          .inlineBtn:hover {
            .inlineBtnIcon {
              background-color: #5cadff;
              color: #fff;
            }
          }

          .inlineBtn.disabled {
            .inlineBtnIcon {
              cursor: not-allowed !important;
              background-color: #999 !important;
              color: #fff;
            }
          }
        }
      }

      .hisPanel {
        display: flex;
        flex-direction: column;

        .historyRecordList {
          flex-grow: 1;
          max-height: 500px;
          overflow-y: auto;
          overflow-x: hidden;
        }
      }

      .phoneBtns {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
        margin-bottom: 10px;

        > div {
          margin: 0 6px;
          // flex: 1;
          width: 56px;
        }
      }

      .historyHeader {
        cursor: default;
        user-select: none;
        display: flex;
        // align-items: center;

        .backBtn {
          cursor: pointer;
          margin-right: 6px;
          font-size: 1.1rem;
        }
      }

      .loadingC {
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .historyRecordList {
        padding: 10px;
        min-height: 200px;
        .ivu-timeline-item {
          padding: 0;
        }

        .time {
          font-size: 0.85rem;
          font-weight: bold;
        }
        .content {
          font-size: 12px;
        }

        .historyRecord {
          border-bottom: 1px dashed #e9e9e9;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 6px 4px;
          cursor: default;

          .historyRecordTitle {
            display: flex;
            align-items: center;
            font-size: 0.9rem;
          }

          .historyRecordTime {
            color: #999;
            font-size: 12px;
          }

          .historyRecordBtns {
            display: flex;
            align-items: center;
            .callBtn {
              background: #19be6b;
              font-size: 1rem;
              cursor: pointer;
              color: #fff;
              width: 1.6rem;
              border-radius: 5px;
              text-align: center;
            }

            .moreBtn {
              font-size: 1.2rem;
              color: #888;
              cursor: pointer;
            }
          }
        }

        .historyRecord:hover {
          background: #f2f2f2;
        }
      }

      .nodata {
        text-align: center;
        line-height: 200px;
      }

      .JXYPanelOff,
      .JXYPanelWel,
      .JXYPanelOnline {
        background-image: url(./jxy/images/bgOff.png);
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        width: 80%;
        height: 220px;
        margin: 0 auto;
        position: relative;
        margin-bottom: 1rem;

        > p,
        > div {
          text-align: center;
          left: 0;
          right: 0;
          bottom: 0;
          position: absolute;
          font-weight: 500;
          color: #888;
        }
      }

      .JXYPanelOff {
        background-image: url(./jxy/images/welcome.png);
      }

      .JXYPanelOnline {
        background-image: url(./jxy/images/bgOnline.png);
      }

      .telPanelHeader {
        text-align: center;
        font-size: 0.9rem;
        color: #888;
      }

      .telNumber {
        margin: 10px;
        text-align: center;
        font-weight: 500;
        font-size: 1.4rem;
      }

      .telTime {
        text-align: center;
        font-weight: 400;
        font-size: 0.9rem;
      }

      .telRingInfo {
        > div {
          display: flex;
          line-height: 2rem;
          justify-content: space-between;
          align-items: center;

          color: #999;
          font-size: 0.8rem;
        }
      }

      .btnContainer {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .answerBtn {
        text-align: center;
        margin: 1rem;
      }

      .btnDesc {
        margin-top: 10px;
      }
    }

    .buttomBtnContianer {
      width: 100%;

      display: flex;
      // border-top: 1px solid #e9e9e9;

      .buttomBtn {
        cursor: pointer;
        // width: 2rem;
        width: 25%;
        text-align: center;
        // line-height: 2rem;
        font-size: 1rem;
        font-weight: 500;
        padding: 4px;
        line-height: 1;
        color: #999;
        border-top: 1px solid #e9e9e9;
        border-right: 1px solid #e9e9e9;

        .btnLabel {
          font-size: 12px;

          margin-top: 5px;
        }
      }

      .buttomBtn.disable {
        cursor: not-allowed;
        background: #f2f2f2;
        color: #aaa;
      }

      > .buttomBtn:not(:last-child) {
        border-right: 1px solid #e9e9e9;
      }
    }

    .logContianerBody {
      padding: 10px 10px;
      margin-bottom: 10px;
      max-height: 200px;
      overflow-y: auto;
    }
  }

  .JXYBtnContainer {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .JXYBtnItem {
      min-width: 3rem;
      font-size: 0.8rem;
      text-align: center;
      padding: 5px;
      // color: #2d8cf0;
      cursor: pointer;

      .JXYBtnImg {
        width: 1.6rem;
        height: 1.6rem;
      }
      .JXYBtnItemLabel {
        display: flex;
        align-items: center;
        line-height: 1;
        font-size: 12px;
        margin-top: 5px;
        white-space: nowrap;
      }

      .JXYBtnItemSinle {
        height: 58px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .JXYBtnItemSinle.shake {
        display: inline-block;
        animation: shake 0.5s infinite;
      }

      @keyframes shake {
        0% {
          transform: rotate(0deg);
        }
        25% {
          transform: rotate(-3deg);
        }
        50% {
          transform: rotate(3deg);
        }
        75% {
          transform: rotate(-5deg);
        }
        100% {
          transform: rotate(5deg);
        }
      }

      .JXYBtnItemHandler {
        white-space: nowrap;
        text-align: left;
        font-size: 12px;
      }

      .JXYBtnItemHandlerBtn {
        display: flex;
        width: fit-content;
        max-width: fit-content;
        align-items: center;

        > div {
          height: 45px;
        }
        > div:first-child {
          margin: 0 5px;
        }
      }
    }

    .JXYBtnItem.online {
      margin: 1rem auto;

      .jxyPanelOff {
        margin-bottom: 1rem;
      }
    }
  }
}

.JXYBtnItemSub {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .JXYBtnItemSubIcon {
    width: 1rem;
    height: 1rem;
    margin-right: 4px;
  }
}

.statusMenu,
.leftH {
  user-select: none;

  .status {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 4px;
    background-color: gray;
    border-radius: 50%;
  }

  .status.online {
    background-color: #19be6b;
  }

  .status.offline {
    background-color: #c5c8ce;
  }

  .status.idle {
    background-color: #19be6b //#2d8cf0;;
  }

  .status.busy {
    background-color: #ed4014;
  }

  .status.sleep {
    background-color: #ff9900;
  }
}
</style>